/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AchieveWorksReportAnswerFullRead
 */
export interface AchieveWorksReportAnswerFullRead {
    /**
     * Get all examples with their text and tags.
     * @type {Array<ExampleFullRead>}
     * @memberof AchieveWorksReportAnswerFullRead
     */
    'examples': Array<ExampleFullRead>;
    /**
     * Get id.
     * @type {string}
     * @memberof AchieveWorksReportAnswerFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AchieveWorksReportAnswerFullRead
     */
    'text': string | null;
    /**
     * 
     * @type {string}
     * @memberof AchieveWorksReportAnswerFullRead
     */
    'question': string;
}
/**
 * AchieveWorksReportAssessmentMacroScore
 * @export
 * @interface AchieveWorksReportAssessmentMacroScoreFullRead
 */
export interface AchieveWorksReportAssessmentMacroScoreFullRead {
    /**
     * 
     * @type {number}
     * @memberof AchieveWorksReportAssessmentMacroScoreFullRead
     */
    'score': number;
    /**
     * 
     * @type {string}
     * @memberof AchieveWorksReportAssessmentMacroScoreFullRead
     */
    'name': string;
    /**
     * 
     * @type {MacroQuestionTypeFullRead}
     * @memberof AchieveWorksReportAssessmentMacroScoreFullRead
     */
    'macroQuestionType': MacroQuestionTypeFullRead;
    /**
     * 
     * @type {Array<AchieveWorksReportAssessmentScoreFullRead>}
     * @memberof AchieveWorksReportAssessmentMacroScoreFullRead
     */
    'topTruTalentFactorAssessmentScores'?: Array<AchieveWorksReportAssessmentScoreFullRead>;
}
/**
 * AchieveWorksReportAssessmentScore
 * @export
 * @interface AchieveWorksReportAssessmentScoreFullRead
 */
export interface AchieveWorksReportAssessmentScoreFullRead {
    /**
     * 
     * @type {number}
     * @memberof AchieveWorksReportAssessmentScoreFullRead
     */
    'score': number;
    /**
     * 
     * @type {string}
     * @memberof AchieveWorksReportAssessmentScoreFullRead
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AchieveWorksReportAssessmentScoreFullRead
     */
    'description': string;
    /**
     * 
     * @type {QuestionTypeFullRead}
     * @memberof AchieveWorksReportAssessmentScoreFullRead
     */
    'questionType': QuestionTypeFullRead;
}
/**
 * Badge.
 * @export
 * @interface AchieveWorksReportBadgeFullRead
 */
export interface AchieveWorksReportBadgeFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof AchieveWorksReportBadgeFullRead
     */
    'id': string;
    /**
     * Get name.
     * @type {string}
     * @memberof AchieveWorksReportBadgeFullRead
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AchieveWorksReportBadgeFullRead
     */
    'badgeText': string | null;
    /**
     * 
     * @type {string}
     * @memberof AchieveWorksReportBadgeFullRead
     */
    'badgeTextEarned': string | null;
    /**
     * 
     * @type {string}
     * @memberof AchieveWorksReportBadgeFullRead
     */
    'activityBadgeText': string | null;
    /**
     * 
     * @type {string}
     * @memberof AchieveWorksReportBadgeFullRead
     */
    'activityBadgeTextEarned': string | null;
}
/**
 * Element.
 * @export
 * @interface AchieveWorksReportElementFullRead
 */
export interface AchieveWorksReportElementFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof AchieveWorksReportElementFullRead
     */
    'id': string;
    /**
     * Get assessmentMacroQuestionType.
     * @type {MacroQuestionTypeFullRead}
     * @memberof AchieveWorksReportElementFullRead
     */
    'assessmentMacroQuestionType'?: MacroQuestionTypeFullRead;
    /**
     * Get assessmentQuestionType.
     * @type {QuestionTypeFullRead}
     * @memberof AchieveWorksReportElementFullRead
     */
    'assessmentQuestionType'?: QuestionTypeFullRead;
    /**
     * Get displayType.
     * @type {string}
     * @memberof AchieveWorksReportElementFullRead
     */
    'displayType': string;
    /**
     * Get activityType.
     * @type {ActivityTypeFullRead}
     * @memberof AchieveWorksReportElementFullRead
     */
    'activityType'?: ActivityTypeFullRead;
    /**
     * 
     * @type {Array<AchieveWorksReportElementFullRead>}
     * @memberof AchieveWorksReportElementFullRead
     */
    'elements': Array<AchieveWorksReportElementFullRead>;
    /**
     * 
     * @type {Array<AchieveWorksReportQuestionFullRead>}
     * @memberof AchieveWorksReportElementFullRead
     */
    'questions': Array<AchieveWorksReportQuestionFullRead>;
    /**
     * 
     * @type {string}
     * @memberof AchieveWorksReportElementFullRead
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof AchieveWorksReportElementFullRead
     */
    'subTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof AchieveWorksReportElementFullRead
     */
    'content'?: string;
    /**
     * 
     * @type {Array<CareerMinimumRead>}
     * @memberof AchieveWorksReportElementFullRead
     */
    'careers': Array<CareerMinimumRead>;
    /**
     * Get productConfiguration.
     * @type {ProductConfigurationFullRead}
     * @memberof AchieveWorksReportElementFullRead
     */
    'productConfiguration'?: ProductConfigurationFullRead;
    /**
     * Get assessment.
     * @type {AssessmentStatusRead}
     * @memberof AchieveWorksReportElementFullRead
     */
    'assessment'?: AssessmentStatusRead;
    /**
     * 
     * @type {AptitudeSectionConfigurationFullRead}
     * @memberof AchieveWorksReportElementFullRead
     */
    'aptitudeSectionConfiguration'?: AptitudeSectionConfigurationFullRead;
}
/**
 * Report.
 * @export
 * @interface AchieveWorksReportFullRead
 */
export interface AchieveWorksReportFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof AchieveWorksReportFullRead
     */
    'id': string;
    /**
     * Get createdAt.
     * @type {string}
     * @memberof AchieveWorksReportFullRead
     */
    'createdAt': string;
    /**
     * Get assessment.
     * @type {string}
     * @memberof AchieveWorksReportFullRead
     */
    'assessment': string;
    /**
     * Return all assessment scores.
     * @type {Array<AchieveWorksReportAssessmentScoreFullRead>}
     * @memberof AchieveWorksReportFullRead
     */
    'assessmentScores': Array<AchieveWorksReportAssessmentScoreFullRead>;
    /**
     * 
     * @type {number}
     * @memberof AchieveWorksReportFullRead
     */
    'emotionalIntelligenceScore'?: number | null;
    /**
     * Return all elements.
     * @type {Array<AchieveWorksReportElementFullRead>}
     * @memberof AchieveWorksReportFullRead
     */
    'elements': Array<AchieveWorksReportElementFullRead>;
    /**
     * 
     * @type {Array<ReportUserAnswerFullRead>}
     * @memberof AchieveWorksReportFullRead
     */
    'reportUserAnswers': Array<ReportUserAnswerFullRead>;
    /**
     * 
     * @type {Array<ReportElementRatingFullRead>}
     * @memberof AchieveWorksReportFullRead
     */
    'reportElementRatings': Array<ReportElementRatingFullRead>;
    /**
     * 
     * @type {Array<ReportElementBadgesFullRead>}
     * @memberof AchieveWorksReportFullRead
     */
    'reportElementBadges': Array<ReportElementBadgesFullRead> | null;
    /**
     * Return product.
     * @type {ProductConfigurationFullRead}
     * @memberof AchieveWorksReportFullRead
     */
    'productConfiguration': ProductConfigurationFullRead;
    /**
     * Return careerRange.
     * @type {CareerRangeMinimumRead}
     * @memberof AchieveWorksReportFullRead
     */
    'careerRange'?: CareerRangeMinimumRead;
    /**
     * Minimum O*NET job zone the careers are restricted to, resolved from the assessment owner account rather than the viewer; null when no restriction applies.
     * @type {number}
     * @memberof AchieveWorksReportFullRead
     */
    'minOnetJobZone'?: number | null;
    /**
     * Return all assessment macro scores.
     * @type {Array<AchieveWorksReportAssessmentMacroScoreFullRead>}
     * @memberof AchieveWorksReportFullRead
     */
    'assessmentMacroScores': Array<AchieveWorksReportAssessmentMacroScoreFullRead>;
    /**
     * 
     * @type {UserAnswerFullRead}
     * @memberof AchieveWorksReportFullRead
     */
    'assessmentRating'?: UserAnswerFullRead;
    /**
     * 
     * @type {Array<ReportScoreRangeFullRead>}
     * @memberof AchieveWorksReportFullRead
     */
    'reportScoreRanges': Array<ReportScoreRangeFullRead>;
    /**
     * 
     * @type {UserFullRead}
     * @memberof AchieveWorksReportFullRead
     */
    'user': UserFullRead;
    /**
     * 
     * @type {string}
     * @memberof AchieveWorksReportFullRead
     */
    'assessmentCompletedAt': string | null;
    /**
     * 
     * @type {Array<AchieveWorksReportAssessmentMacroScoreFullRead>}
     * @memberof AchieveWorksReportFullRead
     */
    'topTruTalentsScores'?: Array<AchieveWorksReportAssessmentMacroScoreFullRead>;
}
/**
 * Report.
 * @export
 * @interface AchieveWorksReportMinimumRead
 */
export interface AchieveWorksReportMinimumRead {
    /**
     * Get id.
     * @type {string}
     * @memberof AchieveWorksReportMinimumRead
     */
    'id': string;
    /**
     * Get assessment.
     * @type {string}
     * @memberof AchieveWorksReportMinimumRead
     */
    'assessment'?: string;
}
/**
 * Question.
 * @export
 * @interface AchieveWorksReportQuestionFullRead
 */
export interface AchieveWorksReportQuestionFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof AchieveWorksReportQuestionFullRead
     */
    'id': string;
    /**
     * Get isMultiAnswer.
     * @type {boolean}
     * @memberof AchieveWorksReportQuestionFullRead
     */
    'isMultiAnswer'?: boolean | null;
    /**
     * Get numAnswersRequired.
     * @type {number}
     * @memberof AchieveWorksReportQuestionFullRead
     */
    'numAnswersRequired'?: number | null;
    /**
     * Get sortOrder.
     * @type {number}
     * @memberof AchieveWorksReportQuestionFullRead
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {any}
     * @memberof AchieveWorksReportQuestionFullRead
     */
    'answers'?: any;
    /**
     * 
     * @type {string}
     * @memberof AchieveWorksReportQuestionFullRead
     */
    'text': string | null;
}
/**
 * 
 * @export
 * @interface AchieveWorksReportRatingFullRead
 */
export interface AchieveWorksReportRatingFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof AchieveWorksReportRatingFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AchieveWorksReportRatingFullRead
     */
    'text'?: string | null;
}
/**
 * ActivityType.
 * @export
 * @interface ActivityTypeFullRead
 */
export interface ActivityTypeFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof ActivityTypeFullRead
     */
    'id': string;
    /**
     * Get name.
     * @type {string}
     * @memberof ActivityTypeFullRead
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AnswerFullRead
 */
export interface AnswerFullRead {
    /**
     * 
     * @type {string}
     * @memberof AnswerFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AnswerFullRead
     */
    'text': string;
    /**
     * 
     * @type {QuestionFullRead}
     * @memberof AnswerFullRead
     */
    'question': QuestionFullRead;
    /**
     * 
     * @type {ImageFullRead}
     * @memberof AnswerFullRead
     */
    'image'?: ImageFullRead;
}
/**
 * 
 * @export
 * @interface AnswerMinimumRead
 */
export interface AnswerMinimumRead {
    /**
     * 
     * @type {string}
     * @memberof AnswerMinimumRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AnswerMinimumRead
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof AnswerMinimumRead
     */
    'question': string;
    /**
     * 
     * @type {ImageMinimumRead}
     * @memberof AnswerMinimumRead
     */
    'image'?: ImageMinimumRead;
}
/**
 * 
 * @export
 * @interface AptitudeSectionConfigurationFullRead
 */
export interface AptitudeSectionConfigurationFullRead {
    /**
     * 
     * @type {string}
     * @memberof AptitudeSectionConfigurationFullRead
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof AptitudeSectionConfigurationFullRead
     */
    'timeout': number | null;
    /**
     * 
     * @type {number}
     * @memberof AptitudeSectionConfigurationFullRead
     */
    'memoryQuestionPromptTimeout'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AptitudeSectionConfigurationFullRead
     */
    'memoryQuestionTimeout'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AptitudeSectionConfigurationFullRead
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AptitudeSectionConfigurationFullRead
     */
    'pageDisplayType': string;
}
/**
 * AssessmentCareerMatches.
 * @export
 * @interface AssessmentCareerMatchesFullRead
 */
export interface AssessmentCareerMatchesFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof AssessmentCareerMatchesFullRead
     */
    'id': string;
    /**
     * Return Assessment.
     * @type {string}
     * @memberof AssessmentCareerMatchesFullRead
     */
    'assessment': string | null;
    /**
     * Return CareerRange.
     * @type {CareerRangeMinimumRead}
     * @memberof AssessmentCareerMatchesFullRead
     */
    'careerRange': CareerRangeMinimumRead;
    /**
     * 
     * @type {Array<CareerMatchFullRead>}
     * @memberof AssessmentCareerMatchesFullRead
     */
    'careerMatches': Array<CareerMatchFullRead>;
}
/**
 * Assessment.
 * @export
 * @interface AssessmentFullRead
 */
export interface AssessmentFullRead {
    /**
     * 
     * @type {string}
     * @memberof AssessmentFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFullRead
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFullRead
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFullRead
     */
    'completedAt'?: string | null;
    /**
     * 
     * @type {ProductConfigurationFullRead}
     * @memberof AssessmentFullRead
     */
    'productConfiguration': ProductConfigurationFullRead;
    /**
     * 
     * @type {UserFullRead}
     * @memberof AssessmentFullRead
     */
    'user': UserFullRead;
    /**
     * 
     * @type {Array<QuestionFullRead>}
     * @memberof AssessmentFullRead
     */
    'questions': Array<QuestionFullRead>;
    /**
     * 
     * @type {Array<UserAnswerFullRead>}
     * @memberof AssessmentFullRead
     */
    'userAnswers': Array<UserAnswerFullRead>;
    /**
     * 
     * @type {Array<QuestionFullRead>}
     * @memberof AssessmentFullRead
     */
    'tiebreakerQuestions': Array<QuestionFullRead>;
    /**
     * 
     * @type {Array<CareerClusterUserRatingFullRead>}
     * @memberof AssessmentFullRead
     */
    'careerClusterUserRatings': Array<CareerClusterUserRatingFullRead>;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFullRead
     */
    'introductionText': string;
    /**
     * Get isInvalid.
     * @type {boolean}
     * @memberof AssessmentFullRead
     */
    'isInvalid'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentFullRead
     */
    'isResultReviewed': boolean;
    /**
     * Get achieveWorksReport.
     * @type {string}
     * @memberof AssessmentFullRead
     */
    'achieveWorksReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFullRead
     */
    'aptitudesConfiguration'?: string | null;
    /**
     * 
     * @type {AptitudeSectionConfigurationFullRead}
     * @memberof AssessmentFullRead
     */
    'aptitudeSectionConfiguration'?: AptitudeSectionConfigurationFullRead;
    /**
     * 
     * @type {TimerFullRead}
     * @memberof AssessmentFullRead
     */
    'timer'?: TimerFullRead;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFullRead
     */
    'parentAssessment'?: string | null;
    /**
     * 
     * @type {QuestionFullRead}
     * @memberof AssessmentFullRead
     */
    'ratingQuestion'?: QuestionFullRead;
    /**
     * 
     * @type {UserAnswerFullRead}
     * @memberof AssessmentFullRead
     */
    'ratingAnswer'?: UserAnswerFullRead;
    /**
     * 
     * @type {Array<UserAnswerFullRead>}
     * @memberof AssessmentFullRead
     */
    'tiebreakerUserAnswers': Array<UserAnswerFullRead>;
    /**
     * Gets the object state.
     * @type {string}
     * @memberof AssessmentFullRead
     */
    'status': string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFullRead
     */
    'personalityType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFullRead
     */
    'personalityProfile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentFullRead
     */
    'assessmentType'?: string;
    /**
     * 
     * @type {Array<PageFullRead>}
     * @memberof AssessmentFullRead
     */
    'pages'?: Array<PageFullRead>;
    /**
     * 
     * @type {Array<IntroductionPageFullRead>}
     * @memberof AssessmentFullRead
     */
    'introductionPages'?: Array<IntroductionPageFullRead>;
}
/**
 * 
 * @export
 * @interface AssessmentMacroScoreFullRead
 */
export interface AssessmentMacroScoreFullRead {
    /**
     * 
     * @type {MacroQuestionTypeFullRead}
     * @memberof AssessmentMacroScoreFullRead
     */
    'macroQuestionType'?: MacroQuestionTypeFullRead | null;
    /**
     * Get score.
     * @type {number}
     * @memberof AssessmentMacroScoreFullRead
     */
    'score'?: number | null;
    /**
     * 
     * @type {Array<AssessmentScoreFullRead>}
     * @memberof AssessmentMacroScoreFullRead
     */
    'topTruTalentFactorAssessmentScores'?: Array<AssessmentScoreFullRead>;
    /**
     * 
     * @type {string}
     * @memberof AssessmentMacroScoreFullRead
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface AssessmentMacroScoreMinimumRead
 */
export interface AssessmentMacroScoreMinimumRead {
    /**
     * 
     * @type {number}
     * @memberof AssessmentMacroScoreMinimumRead
     */
    'score': number;
    /**
     * 
     * @type {string}
     * @memberof AssessmentMacroScoreMinimumRead
     */
    'name': string;
    /**
     * 
     * @type {MacroQuestionTypeFullRead}
     * @memberof AssessmentMacroScoreMinimumRead
     */
    'macroQuestionType': MacroQuestionTypeFullRead;
    /**
     * 
     * @type {Array<AchieveWorksReportAssessmentScoreFullRead>}
     * @memberof AssessmentMacroScoreMinimumRead
     */
    'topTruTalentFactorAssessmentScores'?: Array<AchieveWorksReportAssessmentScoreFullRead>;
}
/**
 * Assessment.
 * @export
 * @interface AssessmentMinimumPatch
 */
export interface AssessmentMinimumPatch {
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentMinimumPatch
     */
    'isResultReviewed'?: boolean;
}
/**
 * Assessment.
 * @export
 * @interface AssessmentMinimumRead
 */
export interface AssessmentMinimumRead {
    /**
     * 
     * @type {string}
     * @memberof AssessmentMinimumRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentMinimumRead
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentMinimumRead
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentMinimumRead
     */
    'completedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentMinimumRead
     */
    'productConfiguration': string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentMinimumRead
     */
    'user': string;
    /**
     * Get isInvalid.
     * @type {boolean}
     * @memberof AssessmentMinimumRead
     */
    'isInvalid'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentMinimumRead
     */
    'isResultReviewed': boolean;
    /**
     * Get achieveWorksReport.
     * @type {string}
     * @memberof AssessmentMinimumRead
     */
    'achieveWorksReport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentMinimumRead
     */
    'aptitudesConfiguration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentMinimumRead
     */
    'aptitudeSectionConfiguration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentMinimumRead
     */
    'timer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentMinimumRead
     */
    'parentAssessment'?: string | null;
    /**
     * Gets the object state.
     * @type {string}
     * @memberof AssessmentMinimumRead
     */
    'status': string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentMinimumRead
     */
    'personalityType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentMinimumRead
     */
    'assessmentType': string;
    /**
     * 
     * @type {Array<AssessmentScoreMinimumRead>}
     * @memberof AssessmentMinimumRead
     */
    'scores'?: Array<AssessmentScoreMinimumRead>;
    /**
     * 
     * @type {Array<AssessmentMacroScoreMinimumRead>}
     * @memberof AssessmentMinimumRead
     */
    'macroScores'?: Array<AssessmentMacroScoreMinimumRead>;
}
/**
 * Assessment.
 * @export
 * @interface AssessmentMinimumWrite
 */
export interface AssessmentMinimumWrite {
    /**
     * 
     * @type {string}
     * @memberof AssessmentMinimumWrite
     */
    'productConfiguration'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentMinimumWrite
     */
    'user'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentMinimumWrite
     */
    'parentAssessment'?: string;
}
/**
 * 
 * @export
 * @interface AssessmentScoreFullRead
 */
export interface AssessmentScoreFullRead {
    /**
     * Get score.
     * @type {number}
     * @memberof AssessmentScoreFullRead
     */
    'score'?: number | null;
    /**
     * 
     * @type {QuestionTypeFullRead}
     * @memberof AssessmentScoreFullRead
     */
    'questionType'?: QuestionTypeFullRead | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentScoreFullRead
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentScoreFullRead
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface AssessmentScoreMinimumRead
 */
export interface AssessmentScoreMinimumRead {
    /**
     * 
     * @type {number}
     * @memberof AssessmentScoreMinimumRead
     */
    'score': number;
    /**
     * 
     * @type {string}
     * @memberof AssessmentScoreMinimumRead
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentScoreMinimumRead
     */
    'description': string;
    /**
     * 
     * @type {QuestionTypeFullRead}
     * @memberof AssessmentScoreMinimumRead
     */
    'questionType': QuestionTypeFullRead;
}
/**
 * 
 * @export
 * @interface AssessmentStatusRead
 */
export interface AssessmentStatusRead {
    /**
     * 
     * @type {string}
     * @memberof AssessmentStatusRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentStatusRead
     */
    'status': string;
    /**
     * 
     * @type {TimerFullRead}
     * @memberof AssessmentStatusRead
     */
    'timer'?: TimerFullRead | null;
}
/**
 * AssessmentType.
 * @export
 * @interface AssessmentTypeFullRead
 */
export interface AssessmentTypeFullRead {
    /**
     * 
     * @type {string}
     * @memberof AssessmentTypeFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentTypeFullRead
     */
    'name'?: string;
}
/**
 * Class CareerAptitudesBaseline.
 * @export
 * @interface CareerAptitudesBaselineFullRead
 */
export interface CareerAptitudesBaselineFullRead {
    /**
     * 
     * @type {string}
     * @memberof CareerAptitudesBaselineFullRead
     */
    'career': string;
    /**
     * 
     * @type {MacroQuestionTypeMinimumRead}
     * @memberof CareerAptitudesBaselineFullRead
     */
    'macroQuestionType': MacroQuestionTypeMinimumRead;
    /**
     * 
     * @type {number}
     * @memberof CareerAptitudesBaselineFullRead
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface CareerClusterFullRead
 */
export interface CareerClusterFullRead {
    /**
     * 
     * @type {string}
     * @memberof CareerClusterFullRead
     */
    'id': string;
    /**
     * Set name.
     * @type {string}
     * @memberof CareerClusterFullRead
     */
    'name': string | null;
    /**
     * Set clusterCode.
     * @type {number}
     * @memberof CareerClusterFullRead
     */
    'clusterCode'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CareerClusterFullRead
     */
    'description': string | null;
}
/**
 * 
 * @export
 * @interface CareerClusterMinimumRead
 */
export interface CareerClusterMinimumRead {
    /**
     * 
     * @type {string}
     * @memberof CareerClusterMinimumRead
     */
    'id': string;
    /**
     * Set name.
     * @type {string}
     * @memberof CareerClusterMinimumRead
     */
    'name'?: string | null;
    /**
     * Set clusterCode.
     * @type {number}
     * @memberof CareerClusterMinimumRead
     */
    'clusterCode'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CareerClusterMinimumRead
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface CareerClusterRatingFullRead
 */
export interface CareerClusterRatingFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof CareerClusterRatingFullRead
     */
    'id': string;
    /**
     * Get name.
     * @type {string}
     * @memberof CareerClusterRatingFullRead
     */
    'name'?: string;
    /**
     * Get value.
     * @type {string}
     * @memberof CareerClusterRatingFullRead
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface CareerClusterUserRatingFullRead
 */
export interface CareerClusterUserRatingFullRead {
    /**
     * 
     * @type {string}
     * @memberof CareerClusterUserRatingFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CareerClusterUserRatingFullRead
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CareerClusterUserRatingFullRead
     */
    'updatedAt': string;
    /**
     * 
     * @type {CareerClusterFullRead}
     * @memberof CareerClusterUserRatingFullRead
     */
    'careerCluster': CareerClusterFullRead;
    /**
     * 
     * @type {CareerClusterRatingFullRead}
     * @memberof CareerClusterUserRatingFullRead
     */
    'rating': CareerClusterRatingFullRead;
}
/**
 * 
 * @export
 * @interface CareerClusterUserRatingMinimumUpdate
 */
export interface CareerClusterUserRatingMinimumUpdate {
    /**
     * 
     * @type {string}
     * @memberof CareerClusterUserRatingMinimumUpdate
     */
    'rating'?: string;
}
/**
 * 
 * @export
 * @interface CareerClusterUserRatingMinimumWrite
 */
export interface CareerClusterUserRatingMinimumWrite {
    /**
     * 
     * @type {string}
     * @memberof CareerClusterUserRatingMinimumWrite
     */
    'assessment': string;
    /**
     * 
     * @type {string}
     * @memberof CareerClusterUserRatingMinimumWrite
     */
    'careerCluster': string;
    /**
     * 
     * @type {string}
     * @memberof CareerClusterUserRatingMinimumWrite
     */
    'rating': string;
}
/**
 * 
 * @export
 * @interface CareerFacetFullRead
 */
export interface CareerFacetFullRead {
    /**
     * 
     * @type {string}
     * @memberof CareerFacetFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CareerFacetFullRead
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CareerFacetFullRead
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface CareerFullRead
 */
export interface CareerFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof CareerFullRead
     */
    'id': string;
    /**
     * Get onetId.
     * @type {string}
     * @memberof CareerFullRead
     */
    'onetId': string | null;
    /**
     * Set name.
     * @type {string}
     * @memberof CareerFullRead
     */
    'name': string | null;
    /**
     * Get annualSalary.
     * @type {string}
     * @memberof CareerFullRead
     */
    'annualSalary'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CareerFullRead
     */
    'outlookGrowthPercentage'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CareerFullRead
     */
    'outlookJobOpenings'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CareerFullRead
     */
    'overallOutlook'?: number;
    /**
     * 
     * @type {string}
     * @memberof CareerFullRead
     */
    'description': string | null;
    /**
     * 
     * @type {number}
     * @memberof CareerFullRead
     */
    'onetJobZone'?: number | null;
    /**
     * 
     * @type {Array<CareerClusterFullRead>}
     * @memberof CareerFullRead
     */
    'clusters': Array<CareerClusterFullRead>;
    /**
     * 
     * @type {any}
     * @memberof CareerFullRead
     */
    'majors': any;
    /**
     * 
     * @type {any}
     * @memberof CareerFullRead
     */
    'relatedCareers': any;
    /**
     * 
     * @type {Array<CareerProgramFullRead>}
     * @memberof CareerFullRead
     */
    'careerPrograms': Array<CareerProgramFullRead>;
}
/**
 * Class CareerIntelligencesBaseline.
 * @export
 * @interface CareerIntelligencesBaselineFullRead
 */
export interface CareerIntelligencesBaselineFullRead {
    /**
     * 
     * @type {string}
     * @memberof CareerIntelligencesBaselineFullRead
     */
    'career': string;
    /**
     * 
     * @type {QuestionTypeMinimumRead}
     * @memberof CareerIntelligencesBaselineFullRead
     */
    'questionType': QuestionTypeMinimumRead;
    /**
     * 
     * @type {number}
     * @memberof CareerIntelligencesBaselineFullRead
     */
    'value': number;
}
/**
 * Career.
 * @export
 * @interface CareerItemFullRead
 */
export interface CareerItemFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof CareerItemFullRead
     */
    'id': string;
    /**
     * Get onetId.
     * @type {string}
     * @memberof CareerItemFullRead
     */
    'onetId': string | null;
    /**
     * Set name.
     * @type {string}
     * @memberof CareerItemFullRead
     */
    'name': string | null;
    /**
     * Get annualSalary.
     * @type {string}
     * @memberof CareerItemFullRead
     */
    'annualSalary'?: string | null;
    /**
     * 
     * @type {Array<CareerClusterFullRead>}
     * @memberof CareerItemFullRead
     */
    'clusters': Array<CareerClusterFullRead>;
    /**
     * 
     * @type {string}
     * @memberof CareerItemFullRead
     */
    'outlookGrowthPercentage'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CareerItemFullRead
     */
    'outlookJobOpenings'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CareerItemFullRead
     */
    'overallOutlook'?: number;
    /**
     * 
     * @type {Array<RelatedCareerRead>}
     * @memberof CareerItemFullRead
     */
    'relatedCareers': Array<RelatedCareerRead>;
    /**
     * 
     * @type {Array<CareerSkillsBaselineFullRead>}
     * @memberof CareerItemFullRead
     */
    'careerSkillsBaselines': Array<CareerSkillsBaselineFullRead>;
    /**
     * 
     * @type {Array<CareerIntelligencesBaselineFullRead>}
     * @memberof CareerItemFullRead
     */
    'careerIntelligencesBaselines': Array<CareerIntelligencesBaselineFullRead>;
    /**
     * 
     * @type {Array<CareerAptitudesBaselineFullRead>}
     * @memberof CareerItemFullRead
     */
    'careerAptitudesBaselines': Array<CareerAptitudesBaselineFullRead>;
    /**
     * 
     * @type {number}
     * @memberof CareerItemFullRead
     */
    'outlookStartYearJobsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CareerItemFullRead
     */
    'outlookEndYearJobsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof CareerItemFullRead
     */
    'description': string | null;
    /**
     * 
     * @type {Array<CareerProgramFullRead>}
     * @memberof CareerItemFullRead
     */
    'careerPrograms': Array<CareerProgramFullRead>;
    /**
     * 
     * @type {number}
     * @memberof CareerItemFullRead
     */
    'onetJobZone'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CareerItemFullRead
     */
    'onetJobZoneDescription'?: string | null;
    /**
     * 
     * @type {Array<CareerFacetFullRead>}
     * @memberof CareerItemFullRead
     */
    'interests': Array<CareerFacetFullRead>;
    /**
     * 
     * @type {Array<CareerFacetFullRead>}
     * @memberof CareerItemFullRead
     */
    'knowledge': Array<CareerFacetFullRead>;
    /**
     * 
     * @type {Array<CareerFacetFullRead>}
     * @memberof CareerItemFullRead
     */
    'abilities': Array<CareerFacetFullRead>;
    /**
     * 
     * @type {Array<CareerFacetFullRead>}
     * @memberof CareerItemFullRead
     */
    'skills': Array<CareerFacetFullRead>;
    /**
     * 
     * @type {Array<CareerFacetFullRead>}
     * @memberof CareerItemFullRead
     */
    'activities': Array<CareerFacetFullRead>;
    /**
     * 
     * @type {Array<CareerFacetFullRead>}
     * @memberof CareerItemFullRead
     */
    'tasks': Array<CareerFacetFullRead>;
    /**
     * 
     * @type {number}
     * @memberof CareerItemFullRead
     */
    'outlookStartYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof CareerItemFullRead
     */
    'outlookEndYear'?: number;
}
/**
 * 
 * @export
 * @interface CareerMatchFullRead
 */
export interface CareerMatchFullRead {
    /**
     * 
     * @type {string}
     * @memberof CareerMatchFullRead
     */
    'career': string;
    /**
     * 
     * @type {number}
     * @memberof CareerMatchFullRead
     */
    'matchScore': number;
}
/**
 * Career.
 * @export
 * @interface CareerMinimumRead
 */
export interface CareerMinimumRead {
    /**
     * Get id.
     * @type {string}
     * @memberof CareerMinimumRead
     */
    'id': string;
    /**
     * Get onetId.
     * @type {string}
     * @memberof CareerMinimumRead
     */
    'onetId': string | null;
    /**
     * Set name.
     * @type {string}
     * @memberof CareerMinimumRead
     */
    'name': string | null;
    /**
     * Get annualSalary.
     * @type {string}
     * @memberof CareerMinimumRead
     */
    'annualSalary'?: string | null;
    /**
     * 
     * @type {Array<CareerClusterMinimumRead>}
     * @memberof CareerMinimumRead
     */
    'clusters'?: Array<CareerClusterMinimumRead>;
    /**
     * 
     * @type {string}
     * @memberof CareerMinimumRead
     */
    'outlookGrowthPercentage'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CareerMinimumRead
     */
    'outlookJobOpenings'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CareerMinimumRead
     */
    'overallOutlook'?: number;
    /**
     * 
     * @type {string}
     * @memberof CareerMinimumRead
     */
    'description': string | null;
    /**
     * 
     * @type {number}
     * @memberof CareerMinimumRead
     */
    'onetJobZone'?: number | null;
}
/**
 * 
 * @export
 * @interface CareerProgramFullRead
 */
export interface CareerProgramFullRead {
    /**
     * 
     * @type {string}
     * @memberof CareerProgramFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CareerProgramFullRead
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CareerProgramFullRead
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CareerProgramFullRead
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CareerProgramMatchFullRead
 */
export interface CareerProgramMatchFullRead {
    /**
     * 
     * @type {string}
     * @memberof CareerProgramMatchFullRead
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof CareerProgramMatchFullRead
     */
    'matchScore'?: number;
    /**
     * 
     * @type {CareerProgramFullRead}
     * @memberof CareerProgramMatchFullRead
     */
    'careerProgram'?: CareerProgramFullRead;
}
/**
 * 
 * @export
 * @interface CareerRangeFullRead
 */
export interface CareerRangeFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof CareerRangeFullRead
     */
    'id': string;
    /**
     * Get name.
     * @type {string}
     * @memberof CareerRangeFullRead
     */
    'name'?: string;
    /**
     * Get type.
     * @type {string}
     * @memberof CareerRangeFullRead
     */
    'type'?: string;
}
/**
 * CareerRange.
 * @export
 * @interface CareerRangeMinimumRead
 */
export interface CareerRangeMinimumRead {
    /**
     * Get id.
     * @type {string}
     * @memberof CareerRangeMinimumRead
     */
    'id': string;
    /**
     * Get name.
     * @type {string}
     * @memberof CareerRangeMinimumRead
     */
    'name': string;
    /**
     * Get type.
     * @type {string}
     * @memberof CareerRangeMinimumRead
     */
    'type': string;
}
/**
 * CareerRating.
 * @export
 * @interface CareerRatingFullRead
 */
export interface CareerRatingFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof CareerRatingFullRead
     */
    'id': string;
    /**
     * Get name.
     * @type {string}
     * @memberof CareerRatingFullRead
     */
    'name': string;
    /**
     * Get value.
     * @type {number}
     * @memberof CareerRatingFullRead
     */
    'value': number;
}
/**
 * Class CareerSkillsBaseline.
 * @export
 * @interface CareerSkillsBaselineFullRead
 */
export interface CareerSkillsBaselineFullRead {
    /**
     * 
     * @type {string}
     * @memberof CareerSkillsBaselineFullRead
     */
    'career': string;
    /**
     * 
     * @type {MacroQuestionTypeMinimumRead}
     * @memberof CareerSkillsBaselineFullRead
     */
    'macroQuestionType': MacroQuestionTypeMinimumRead;
    /**
     * 
     * @type {number}
     * @memberof CareerSkillsBaselineFullRead
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface CareerUserRatingFullRead
 */
export interface CareerUserRatingFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof CareerUserRatingFullRead
     */
    'id': string;
    /**
     * Get createdAt.
     * @type {string}
     * @memberof CareerUserRatingFullRead
     */
    'createdAt'?: string;
    /**
     * Get updatedAt.
     * @type {string}
     * @memberof CareerUserRatingFullRead
     */
    'updatedAt'?: string;
    /**
     * Get user.
     * @type {string}
     * @memberof CareerUserRatingFullRead
     */
    'user': string | null;
    /**
     * Get career.
     * @type {CareerFullRead}
     * @memberof CareerUserRatingFullRead
     */
    'career': CareerFullRead;
    /**
     * Get rating.
     * @type {CareerRatingFullRead}
     * @memberof CareerUserRatingFullRead
     */
    'rating': CareerRatingFullRead;
}
/**
 * 
 * @export
 * @interface CareerUserRatingMinimumWrite
 */
export interface CareerUserRatingMinimumWrite {
    /**
     * Get user.
     * @type {string}
     * @memberof CareerUserRatingMinimumWrite
     */
    'user': string;
    /**
     * Get career.
     * @type {string}
     * @memberof CareerUserRatingMinimumWrite
     */
    'career': string;
    /**
     * Get rating.
     * @type {string}
     * @memberof CareerUserRatingMinimumWrite
     */
    'rating': string;
}
/**
 * Class CareerWage.
 * @export
 * @interface CareerWageFullRead
 */
export interface CareerWageFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'career': string | null;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'parentAreaId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'areaType': string;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'areaName': string;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'areaId': string;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'meanHourlyWage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'meanAverageWage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'hourlyWage10thPercentile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'hourlyWage25thPercentile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'hourlyWage50thPercentile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'hourlyWage75thPercentile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'hourlyWage90thPercentile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'annualWage10thPercentile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'annualWage25thPercentile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'annualWage50thPercentile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'annualWage75thPercentile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CareerWageFullRead
     */
    'annualWage90thPercentile'?: string | null;
}
/**
 * 
 * @export
 * @interface ContentBlockFullRead
 */
export interface ContentBlockFullRead {
    /**
     * 
     * @type {string}
     * @memberof ContentBlockFullRead
     */
    'id': string;
    /**
     * 
     * @type {Array<ImageFullRead>}
     * @memberof ContentBlockFullRead
     */
    'images'?: Array<ImageFullRead>;
    /**
     * 
     * @type {string}
     * @memberof ContentBlockFullRead
     */
    'displayType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContentBlockFullRead
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContentBlockFullRead
     */
    'subTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContentBlockFullRead
     */
    'content'?: string | null;
}
/**
 * 
 * @export
 * @interface ExampleFullRead
 */
export interface ExampleFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof ExampleFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ExampleFullRead
     */
    'text': string | null;
    /**
     * 
     * @type {string}
     * @memberof ExampleFullRead
     */
    'exampleType': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExampleFullRead
     */
    'tags': Array<string>;
}
/**
 * UserToken
 * @export
 * @interface GetTokenUserItem200Response
 */
export interface GetTokenUserItem200Response {
    /**
     * 
     * @type {string}
     * @memberof GetTokenUserItem200Response
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface ImageFullRead
 */
export interface ImageFullRead {
    /**
     * 
     * @type {string}
     * @memberof ImageFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ImageFullRead
     */
    'filePath': string;
    /**
     * 
     * @type {string}
     * @memberof ImageFullRead
     */
    'altText'?: string | null;
}
/**
 * 
 * @export
 * @interface ImageMinimumRead
 */
export interface ImageMinimumRead {
    /**
     * 
     * @type {string}
     * @memberof ImageMinimumRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ImageMinimumRead
     */
    'filePath'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageMinimumRead
     */
    'altText'?: string | null;
}
/**
 * Account.
 * @export
 * @interface InstitutionFullRead
 */
export interface InstitutionFullRead {
    /**
     * 
     * @type {string}
     * @memberof InstitutionFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InstitutionFullRead
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstitutionFullRead
     */
    'address1'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstitutionFullRead
     */
    'address2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstitutionFullRead
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstitutionFullRead
     */
    'zipcode'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstitutionFullRead
     */
    'worldStateProvince'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstitutionFullRead
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstitutionFullRead
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface InstructionFullRead
 */
export interface InstructionFullRead {
    /**
     * 
     * @type {string}
     * @memberof InstructionFullRead
     */
    'id': string;
    /**
     * 
     * @type {Array<ImageFullRead>}
     * @memberof InstructionFullRead
     */
    'images'?: Array<ImageFullRead>;
    /**
     * 
     * @type {string}
     * @memberof InstructionFullRead
     */
    'displayType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstructionFullRead
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstructionFullRead
     */
    'subTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstructionFullRead
     */
    'content'?: string | null;
}
/**
 * 
 * @export
 * @interface IntroductionPageFullRead
 */
export interface IntroductionPageFullRead {
    /**
     * 
     * @type {string}
     * @memberof IntroductionPageFullRead
     */
    'id': string;
    /**
     * 
     * @type {Array<ContentBlockFullRead>}
     * @memberof IntroductionPageFullRead
     */
    'contentBlocks': Array<ContentBlockFullRead>;
    /**
     * 
     * @type {string}
     * @memberof IntroductionPageFullRead
     */
    'displayType': string;
    /**
     * 
     * @type {Array<IntroductionQuestionContentBlockFullRead>}
     * @memberof IntroductionPageFullRead
     */
    'introductionQuestionContentBlocks'?: Array<IntroductionQuestionContentBlockFullRead>;
}
/**
 * 
 * @export
 * @interface IntroductionQuestionContentBlockFullRead
 */
export interface IntroductionQuestionContentBlockFullRead {
    /**
     * 
     * @type {QuestionFullRead}
     * @memberof IntroductionQuestionContentBlockFullRead
     */
    'introductionQuestion'?: QuestionFullRead;
    /**
     * 
     * @type {string}
     * @memberof IntroductionQuestionContentBlockFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IntroductionQuestionContentBlockFullRead
     */
    'correctAnswer': string;
    /**
     * 
     * @type {Array<ImageFullRead>}
     * @memberof IntroductionQuestionContentBlockFullRead
     */
    'images'?: Array<ImageFullRead>;
    /**
     * 
     * @type {string}
     * @memberof IntroductionQuestionContentBlockFullRead
     */
    'displayType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IntroductionQuestionContentBlockFullRead
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IntroductionQuestionContentBlockFullRead
     */
    'subTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IntroductionQuestionContentBlockFullRead
     */
    'content'?: string | null;
}
/**
 * 
 * @export
 * @interface MacroQuestionTypeFullRead
 */
export interface MacroQuestionTypeFullRead {
    /**
     * 
     * @type {string}
     * @memberof MacroQuestionTypeFullRead
     */
    'id': string;
    /**
     * Get name.
     * @type {string}
     * @memberof MacroQuestionTypeFullRead
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MacroQuestionTypeMinimumRead
 */
export interface MacroQuestionTypeMinimumRead {
    /**
     * 
     * @type {string}
     * @memberof MacroQuestionTypeMinimumRead
     */
    'id': string;
    /**
     * Get name.
     * @type {string}
     * @memberof MacroQuestionTypeMinimumRead
     */
    'name': string;
}
/**
 * Major.
 * @export
 * @interface MajorFullRead
 */
export interface MajorFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof MajorFullRead
     */
    'id': string;
    /**
     * Set name.
     * @type {string}
     * @memberof MajorFullRead
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PageFullRead
 */
export interface PageFullRead {
    /**
     * 
     * @type {string}
     * @memberof PageFullRead
     */
    'id': string;
    /**
     * 
     * @type {Array<InstructionFullRead>}
     * @memberof PageFullRead
     */
    'instructions': Array<InstructionFullRead>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PageFullRead
     */
    'questions'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PersonalitySubTypeFullRead
 */
export interface PersonalitySubTypeFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof PersonalitySubTypeFullRead
     */
    'id': string;
    /**
     * Get abbrev.
     * @type {string}
     * @memberof PersonalitySubTypeFullRead
     */
    'abbrev': string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalitySubTypeFullRead
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ProductConfigurationFullRead
 */
export interface ProductConfigurationFullRead {
    /**
     * 
     * @type {string}
     * @memberof ProductConfigurationFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductConfigurationFullRead
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductConfigurationFullRead
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof ProductConfigurationFullRead
     */
    'productLogo': string;
    /**
     * 
     * @type {string}
     * @memberof ProductConfigurationFullRead
     */
    'achieveWorksReportType': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductConfigurationFullRead
     */
    'assessmentType': string;
    /**
     * 
     * @type {string}
     * @memberof ProductConfigurationFullRead
     */
    'productId': string;
    /**
     * 
     * @type {string}
     * @memberof ProductConfigurationFullRead
     */
    'productSuite': string;
}
/**
 * 
 * @export
 * @interface PromptMinimumRead
 */
export interface PromptMinimumRead {
    /**
     * 
     * @type {string}
     * @memberof PromptMinimumRead
     */
    'id': string;
    /**
     * 
     * @type {Array<ImageMinimumRead>}
     * @memberof PromptMinimumRead
     */
    'images'?: Array<ImageMinimumRead>;
    /**
     * 
     * @type {string}
     * @memberof PromptMinimumRead
     */
    'displayType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PromptMinimumRead
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PromptMinimumRead
     */
    'subTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PromptMinimumRead
     */
    'content'?: string | null;
}
/**
 * 
 * @export
 * @interface QuestionFullRead
 */
export interface QuestionFullRead {
    /**
     * 
     * @type {string}
     * @memberof QuestionFullRead
     */
    'id': string;
    /**
     * 
     * @type {Array<AnswerMinimumRead>}
     * @memberof QuestionFullRead
     */
    'answers': Array<AnswerMinimumRead>;
    /**
     * 
     * @type {string}
     * @memberof QuestionFullRead
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionFullRead
     */
    'answerDisplayType': string | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionFullRead
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionFullRead
     */
    'leftText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionFullRead
     */
    'rightText'?: string | null;
    /**
     * 
     * @type {Array<StemMinimumRead>}
     * @memberof QuestionFullRead
     */
    'stems'?: Array<StemMinimumRead>;
    /**
     * 
     * @type {Array<PromptMinimumRead>}
     * @memberof QuestionFullRead
     */
    'prompts'?: Array<PromptMinimumRead>;
}
/**
 * 
 * @export
 * @interface QuestionMinimumRead
 */
export interface QuestionMinimumRead {
    /**
     * 
     * @type {string}
     * @memberof QuestionMinimumRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionMinimumRead
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionMinimumRead
     */
    'answerDisplayType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionMinimumRead
     */
    'text': string | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionMinimumRead
     */
    'leftText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionMinimumRead
     */
    'rightText'?: string | null;
    /**
     * 
     * @type {Array<StemMinimumRead>}
     * @memberof QuestionMinimumRead
     */
    'stems'?: Array<StemMinimumRead>;
    /**
     * 
     * @type {Array<PromptMinimumRead>}
     * @memberof QuestionMinimumRead
     */
    'prompts'?: Array<PromptMinimumRead>;
}
/**
 * 
 * @export
 * @interface QuestionTypeFullRead
 */
export interface QuestionTypeFullRead {
    /**
     * Get id.
     * @type {string}
     * @memberof QuestionTypeFullRead
     */
    'id': string;
    /**
     * Get abbrev.
     * @type {string}
     * @memberof QuestionTypeFullRead
     */
    'abbrev': string | null;
    /**
     * Get name.
     * @type {string}
     * @memberof QuestionTypeFullRead
     */
    'name': string;
    /**
     * 
     * @type {PersonalitySubTypeFullRead}
     * @memberof QuestionTypeFullRead
     */
    'leftPersonalitySubType'?: PersonalitySubTypeFullRead;
    /**
     * 
     * @type {PersonalitySubTypeFullRead}
     * @memberof QuestionTypeFullRead
     */
    'rightPersonalitySubType'?: PersonalitySubTypeFullRead;
    /**
     * Get doesPreferText.
     * @type {string}
     * @memberof QuestionTypeFullRead
     */
    'doesPreferText'?: string | null;
    /**
     * Get doesNotPreferText.
     * @type {string}
     * @memberof QuestionTypeFullRead
     */
    'doesNotPreferText'?: string | null;
    /**
     * Get doesPreferDescription.
     * @type {string}
     * @memberof QuestionTypeFullRead
     */
    'doesPreferDescription'?: string | null;
    /**
     * Get doesNotPreferDescription.
     * @type {string}
     * @memberof QuestionTypeFullRead
     */
    'doesNotPreferDescription'?: string | null;
}
/**
 * 
 * @export
 * @interface QuestionTypeMinimumRead
 */
export interface QuestionTypeMinimumRead {
    /**
     * Get id.
     * @type {string}
     * @memberof QuestionTypeMinimumRead
     */
    'id': string;
    /**
     * Get name.
     * @type {string}
     * @memberof QuestionTypeMinimumRead
     */
    'name': string;
}
/**
 * Career.
 * @export
 * @interface RelatedCareerRead
 */
export interface RelatedCareerRead {
    /**
     * Get id.
     * @type {string}
     * @memberof RelatedCareerRead
     */
    'id': string;
    /**
     * Get onetId.
     * @type {string}
     * @memberof RelatedCareerRead
     */
    'onetId': string | null;
    /**
     * Set name.
     * @type {string}
     * @memberof RelatedCareerRead
     */
    'name': string | null;
    /**
     * Get annualSalary.
     * @type {string}
     * @memberof RelatedCareerRead
     */
    'annualSalary'?: string | null;
    /**
     * 
     * @type {Array<CareerClusterMinimumRead>}
     * @memberof RelatedCareerRead
     */
    'clusters'?: Array<CareerClusterMinimumRead>;
    /**
     * 
     * @type {string}
     * @memberof RelatedCareerRead
     */
    'outlookGrowthPercentage'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RelatedCareerRead
     */
    'outlookJobOpenings'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RelatedCareerRead
     */
    'overallOutlook'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelatedCareerRead
     */
    'description': string | null;
    /**
     * 
     * @type {number}
     * @memberof RelatedCareerRead
     */
    'onetJobZone'?: number | null;
    /**
     * 
     * @type {Array<CareerSkillsBaselineFullRead>}
     * @memberof RelatedCareerRead
     */
    'careerSkillsBaselines': Array<CareerSkillsBaselineFullRead>;
    /**
     * 
     * @type {Array<CareerIntelligencesBaselineFullRead>}
     * @memberof RelatedCareerRead
     */
    'careerIntelligencesBaselines': Array<CareerIntelligencesBaselineFullRead>;
    /**
     * 
     * @type {Array<CareerAptitudesBaselineFullRead>}
     * @memberof RelatedCareerRead
     */
    'careerAptitudesBaselines': Array<CareerAptitudesBaselineFullRead>;
}
/**
 * 
 * @export
 * @interface ReportElementBadgesFullRead
 */
export interface ReportElementBadgesFullRead {
    /**
     * 
     * @type {string}
     * @memberof ReportElementBadgesFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ReportElementBadgesFullRead
     */
    'achieveWorksReport': string;
    /**
     * 
     * @type {string}
     * @memberof ReportElementBadgesFullRead
     */
    'achieveWorksReportElement': string;
    /**
     * 
     * @type {Array<AchieveWorksReportBadgeFullRead>}
     * @memberof ReportElementBadgesFullRead
     */
    'achieveWorksReportBadges': Array<AchieveWorksReportBadgeFullRead>;
}
/**
 * 
 * @export
 * @interface ReportElementBadgesMinimumWrite
 */
export interface ReportElementBadgesMinimumWrite {
    /**
     * 
     * @type {string}
     * @memberof ReportElementBadgesMinimumWrite
     */
    'achieveWorksReport': string;
    /**
     * 
     * @type {string}
     * @memberof ReportElementBadgesMinimumWrite
     */
    'achieveWorksReportElement': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportElementBadgesMinimumWrite
     */
    'achieveWorksReportBadges': Array<string>;
}
/**
 * 
 * @export
 * @interface ReportElementRatingFullRead
 */
export interface ReportElementRatingFullRead {
    /**
     * 
     * @type {string}
     * @memberof ReportElementRatingFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ReportElementRatingFullRead
     */
    'achieveWorksReportElement': string;
    /**
     * 
     * @type {AchieveWorksReportRatingFullRead}
     * @memberof ReportElementRatingFullRead
     */
    'achieveWorksReportRating': AchieveWorksReportRatingFullRead;
    /**
     * 
     * @type {string}
     * @memberof ReportElementRatingFullRead
     */
    'achieveWorksReport': string;
}
/**
 * 
 * @export
 * @interface ReportElementRatingMinimumWrite
 */
export interface ReportElementRatingMinimumWrite {
    /**
     * 
     * @type {string}
     * @memberof ReportElementRatingMinimumWrite
     */
    'achieveWorksReport': string;
    /**
     * 
     * @type {string}
     * @memberof ReportElementRatingMinimumWrite
     */
    'achieveWorksReportElement': string;
    /**
     * 
     * @type {string}
     * @memberof ReportElementRatingMinimumWrite
     */
    'achieveWorksReportRating': string;
}
/**
 * AssessmentReport.
 * @export
 * @interface ReportFullRead
 */
export interface ReportFullRead {
    /**
     * 
     * @type {string}
     * @memberof ReportFullRead
     */
    'id': string | null;
    /**
     * 
     * @type {AssessmentFullRead}
     * @memberof ReportFullRead
     */
    'assessment'?: AssessmentFullRead;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportFullRead
     */
    'content'?: Array<string>;
    /**
     * 
     * @type {Array<CareerClusterFullRead>}
     * @memberof ReportFullRead
     */
    'careerClusters'?: Array<CareerClusterFullRead>;
}
/**
 * 
 * @export
 * @interface ReportScoreRangeFullRead
 */
export interface ReportScoreRangeFullRead {
    /**
     * Get name.
     * @type {string}
     * @memberof ReportScoreRangeFullRead
     */
    'name'?: string;
    /**
     * Get min.
     * @type {number}
     * @memberof ReportScoreRangeFullRead
     */
    'min'?: number;
    /**
     * Get max.
     * @type {number}
     * @memberof ReportScoreRangeFullRead
     */
    'max'?: number;
}
/**
 * 
 * @export
 * @interface ReportTypeElementBadgeRequirementsFullRead
 */
export interface ReportTypeElementBadgeRequirementsFullRead {
    /**
     * 
     * @type {string}
     * @memberof ReportTypeElementBadgeRequirementsFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ReportTypeElementBadgeRequirementsFullRead
     */
    'badgeDisplayType': string;
    /**
     * 
     * @type {string}
     * @memberof ReportTypeElementBadgeRequirementsFullRead
     */
    'badgeEarnType': string;
    /**
     * 
     * @type {string}
     * @memberof ReportTypeElementBadgeRequirementsFullRead
     */
    'achieveWorksReportType': string;
    /**
     * 
     * @type {string}
     * @memberof ReportTypeElementBadgeRequirementsFullRead
     */
    'achieveWorksReportElement': string;
    /**
     * 
     * @type {string}
     * @memberof ReportTypeElementBadgeRequirementsFullRead
     */
    'achieveWorksReportBadge': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportTypeElementBadgeRequirementsFullRead
     */
    'achieveWorksReportElementBadgesRequired': Array<string>;
}
/**
 * 
 * @export
 * @interface ReportUserAnswerFullRead
 */
export interface ReportUserAnswerFullRead {
    /**
     * 
     * @type {string}
     * @memberof ReportUserAnswerFullRead
     */
    'id': string;
    /**
     * 
     * @type {AchieveWorksReportQuestionFullRead}
     * @memberof ReportUserAnswerFullRead
     */
    'achieveWorksReportQuestion': AchieveWorksReportQuestionFullRead;
    /**
     * 
     * @type {Array<AchieveWorksReportAnswerFullRead>}
     * @memberof ReportUserAnswerFullRead
     */
    'achieveWorksReportAnswers': Array<AchieveWorksReportAnswerFullRead>;
}
/**
 * 
 * @export
 * @interface ReportUserAnswerMinimumWrite
 */
export interface ReportUserAnswerMinimumWrite {
    /**
     * 
     * @type {string}
     * @memberof ReportUserAnswerMinimumWrite
     */
    'achieveWorksReport': string;
    /**
     * 
     * @type {string}
     * @memberof ReportUserAnswerMinimumWrite
     */
    'achieveWorksReportQuestion': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportUserAnswerMinimumWrite
     */
    'achieveWorksReportAnswers': Array<string>;
}
/**
 * 
 * @export
 * @interface StemMinimumRead
 */
export interface StemMinimumRead {
    /**
     * 
     * @type {string}
     * @memberof StemMinimumRead
     */
    'id': string;
    /**
     * 
     * @type {Array<ImageMinimumRead>}
     * @memberof StemMinimumRead
     */
    'images'?: Array<ImageMinimumRead>;
    /**
     * 
     * @type {string}
     * @memberof StemMinimumRead
     */
    'displayType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StemMinimumRead
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StemMinimumRead
     */
    'subTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StemMinimumRead
     */
    'content'?: string | null;
}
/**
 * 
 * @export
 * @interface TimerFullRead
 */
export interface TimerFullRead {
    /**
     * 
     * @type {string}
     * @memberof TimerFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TimerFullRead
     */
    'assessment': string | null;
    /**
     * 
     * @type {string}
     * @memberof TimerFullRead
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof TimerFullRead
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TimerFullRead
     */
    'expiry'?: string | null;
}
/**
 * 
 * @export
 * @interface UserAnswerFullRead
 */
export interface UserAnswerFullRead {
    /**
     * 
     * @type {string}
     * @memberof UserAnswerFullRead
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserAnswerFullRead
     */
    'createdAt': string;
    /**
     * Get QuestionAnswer.
     * @type {AnswerFullRead}
     * @memberof UserAnswerFullRead
     */
    'answer': AnswerFullRead;
}
/**
 * 
 * @export
 * @interface UserAnswerMinimumWrite
 */
export interface UserAnswerMinimumWrite {
    /**
     * 
     * @type {string}
     * @memberof UserAnswerMinimumWrite
     */
    'assessment': string | null;
    /**
     * Get QuestionAnswer.
     * @type {string}
     * @memberof UserAnswerMinimumWrite
     */
    'answer': string;
}
/**
 * 
 * @export
 * @interface UserFullRead
 */
export interface UserFullRead {
    /**
     * 
     * @type {string}
     * @memberof UserFullRead
     */
    'id': string;
    /**
     * Set createdAt.
     * @type {string}
     * @memberof UserFullRead
     */
    'createdAt'?: string;
    /**
     * Set updatedAt.
     * @type {string}
     * @memberof UserFullRead
     */
    'updatedAt'?: string;
    /**
     * Set firstName.
     * @type {string}
     * @memberof UserFullRead
     */
    'firstName': string | null;
    /**
     * Set lastName.
     * @type {string}
     * @memberof UserFullRead
     */
    'lastName'?: string | null;
    /**
     * Set emailAddress.
     * @type {string}
     * @memberof UserFullRead
     */
    'emailAddress'?: string | null;
    /**
     * Set lastLoggedInAt.
     * @type {string}
     * @memberof UserFullRead
     */
    'lastLoggedInAt'?: string | null;
    /**
     * Set isUnder13.
     * @type {boolean}
     * @memberof UserFullRead
     */
    'isUnder13': boolean;
    /**
     * Set birthDate.
     * @type {string}
     * @memberof UserFullRead
     */
    'birthDate'?: string | null;
    /**
     * Set customData.
     * @type {string}
     * @memberof UserFullRead
     */
    'customData'?: string | null;
    /**
     * Set externalId.
     * @type {string}
     * @memberof UserFullRead
     */
    'externalId'?: string | null;
    /**
     * Set account.
     * @type {string}
     * @memberof UserFullRead
     */
    'institution': string | null;
    /**
     * Set gender.
     * @type {string}
     * @memberof UserFullRead
     */
    'gender'?: UserFullReadGenderEnum | null;
}

export const UserFullReadGenderEnum = {
    M: 'M',
    F: 'F'
} as const;

export type UserFullReadGenderEnum = typeof UserFullReadGenderEnum[keyof typeof UserFullReadGenderEnum];

/**
 * 
 * @export
 * @interface UserMinimumWrite
 */
export interface UserMinimumWrite {
    /**
     * Set firstName.
     * @type {string}
     * @memberof UserMinimumWrite
     */
    'firstName': string | null;
    /**
     * Set lastName.
     * @type {string}
     * @memberof UserMinimumWrite
     */
    'lastName'?: string | null;
    /**
     * Set emailAddress.
     * @type {string}
     * @memberof UserMinimumWrite
     */
    'emailAddress'?: string | null;
    /**
     * Set isUnder13.
     * @type {boolean}
     * @memberof UserMinimumWrite
     */
    'isUnder13': boolean;
    /**
     * Set birthDate.
     * @type {string}
     * @memberof UserMinimumWrite
     */
    'birthDate'?: string | null;
    /**
     * Set customData.
     * @type {string}
     * @memberof UserMinimumWrite
     */
    'customData': string | null;
    /**
     * Set externalId.
     * @type {string}
     * @memberof UserMinimumWrite
     */
    'externalId'?: string | null;
    /**
     * Set account.
     * @type {string}
     * @memberof UserMinimumWrite
     */
    'institution'?: string | null;
    /**
     * Set gender.
     * @type {string}
     * @memberof UserMinimumWrite
     */
    'gender'?: UserMinimumWriteGenderEnum | null;
}

export const UserMinimumWriteGenderEnum = {
    M: 'M',
    F: 'F'
} as const;

export type UserMinimumWriteGenderEnum = typeof UserMinimumWriteGenderEnum[keyof typeof UserMinimumWriteGenderEnum];


/**
 * AchieveWorksReportApi - axios parameter creator
 * @export
 */
export const AchieveWorksReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {string} id AchieveWorksReport identifier
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAchieveWorksReportsIdcareerProgramMatchesGetCollection: async (id: string, page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAchieveWorksReportsIdcareerProgramMatchesGetCollection', 'id', id)
            const localVarPath = `/api/achieve_works_reports/{id}/career_program_matches`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAchieveWorksReportCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/achieve_works_reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a AchieveWorksReport resource.
         * @summary Retrieves a AchieveWorksReport resource.
         * @param {string} id AchieveWorksReport identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAchieveWorksReportItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAchieveWorksReportItem', 'id', id)
            const localVarPath = `/api/achieve_works_reports/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {string} id AchieveWorksReport identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareersByReportAchieveWorksReportItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCareersByReportAchieveWorksReportItem', 'id', id)
            const localVarPath = `/api/achieve_works_reports/{id}/careers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {string} id AchieveWorksReport identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportElementBadgesByReportAchieveWorksReportItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReportElementBadgesByReportAchieveWorksReportItem', 'id', id)
            const localVarPath = `/api/achieve_works_reports/{id}/report_element_badges`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {string} id AchieveWorksReport identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportElementRatingsByReportAchieveWorksReportItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReportElementRatingsByReportAchieveWorksReportItem', 'id', id)
            const localVarPath = `/api/achieve_works_reports/{id}/report_element_ratings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {string} id AchieveWorksReport identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportUserAnswersByReportAchieveWorksReportItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReportUserAnswersByReportAchieveWorksReportItem', 'id', id)
            const localVarPath = `/api/achieve_works_reports/{id}/report_user_answers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AchieveWorksReportApi - functional programming interface
 * @export
 */
export const AchieveWorksReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AchieveWorksReportApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {string} id AchieveWorksReport identifier
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAchieveWorksReportsIdcareerProgramMatchesGetCollection(id: string, page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAchieveWorksReportsIdcareerProgramMatchesGetCollection(id, page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AchieveWorksReportApi.apiAchieveWorksReportsIdcareerProgramMatchesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAchieveWorksReportCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AchieveWorksReportMinimumRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAchieveWorksReportCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AchieveWorksReportApi.getAchieveWorksReportCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a AchieveWorksReport resource.
         * @summary Retrieves a AchieveWorksReport resource.
         * @param {string} id AchieveWorksReport identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAchieveWorksReportItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AchieveWorksReportFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAchieveWorksReportItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AchieveWorksReportApi.getAchieveWorksReportItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {string} id AchieveWorksReport identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareersByReportAchieveWorksReportItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CareerFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareersByReportAchieveWorksReportItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AchieveWorksReportApi.getCareersByReportAchieveWorksReportItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {string} id AchieveWorksReport identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportElementBadgesByReportAchieveWorksReportItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportElementBadgesFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportElementBadgesByReportAchieveWorksReportItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AchieveWorksReportApi.getReportElementBadgesByReportAchieveWorksReportItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {string} id AchieveWorksReport identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportElementRatingsByReportAchieveWorksReportItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportElementRatingFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportElementRatingsByReportAchieveWorksReportItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AchieveWorksReportApi.getReportElementRatingsByReportAchieveWorksReportItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {string} id AchieveWorksReport identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportUserAnswersByReportAchieveWorksReportItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportUserAnswerFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportUserAnswersByReportAchieveWorksReportItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AchieveWorksReportApi.getReportUserAnswersByReportAchieveWorksReportItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AchieveWorksReportApi - factory interface
 * @export
 */
export const AchieveWorksReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AchieveWorksReportApiFp(configuration)
    return {
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {string} id AchieveWorksReport identifier
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAchieveWorksReportsIdcareerProgramMatchesGetCollection(id: string, page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.apiAchieveWorksReportsIdcareerProgramMatchesGetCollection(id, page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAchieveWorksReportCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<AchieveWorksReportMinimumRead>> {
            return localVarFp.getAchieveWorksReportCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a AchieveWorksReport resource.
         * @summary Retrieves a AchieveWorksReport resource.
         * @param {string} id AchieveWorksReport identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAchieveWorksReportItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AchieveWorksReportFullRead> {
            return localVarFp.getAchieveWorksReportItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {string} id AchieveWorksReport identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareersByReportAchieveWorksReportItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CareerFullRead>> {
            return localVarFp.getCareersByReportAchieveWorksReportItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {string} id AchieveWorksReport identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportElementBadgesByReportAchieveWorksReportItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ReportElementBadgesFullRead>> {
            return localVarFp.getReportElementBadgesByReportAchieveWorksReportItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {string} id AchieveWorksReport identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportElementRatingsByReportAchieveWorksReportItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ReportElementRatingFullRead>> {
            return localVarFp.getReportElementRatingsByReportAchieveWorksReportItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of AchieveWorksReport resources.
         * @summary Retrieves the collection of AchieveWorksReport resources.
         * @param {string} id AchieveWorksReport identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportUserAnswersByReportAchieveWorksReportItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ReportUserAnswerFullRead>> {
            return localVarFp.getReportUserAnswersByReportAchieveWorksReportItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AchieveWorksReportApi - object-oriented interface
 * @export
 * @class AchieveWorksReportApi
 * @extends {BaseAPI}
 */
export class AchieveWorksReportApi extends BaseAPI {
    /**
     * Retrieves the collection of AchieveWorksReport resources.
     * @summary Retrieves the collection of AchieveWorksReport resources.
     * @param {string} id AchieveWorksReport identifier
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AchieveWorksReportApi
     */
    public apiAchieveWorksReportsIdcareerProgramMatchesGetCollection(id: string, page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return AchieveWorksReportApiFp(this.configuration).apiAchieveWorksReportsIdcareerProgramMatchesGetCollection(id, page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of AchieveWorksReport resources.
     * @summary Retrieves the collection of AchieveWorksReport resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AchieveWorksReportApi
     */
    public getAchieveWorksReportCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return AchieveWorksReportApiFp(this.configuration).getAchieveWorksReportCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a AchieveWorksReport resource.
     * @summary Retrieves a AchieveWorksReport resource.
     * @param {string} id AchieveWorksReport identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AchieveWorksReportApi
     */
    public getAchieveWorksReportItem(id: string, options?: RawAxiosRequestConfig) {
        return AchieveWorksReportApiFp(this.configuration).getAchieveWorksReportItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of AchieveWorksReport resources.
     * @summary Retrieves the collection of AchieveWorksReport resources.
     * @param {string} id AchieveWorksReport identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AchieveWorksReportApi
     */
    public getCareersByReportAchieveWorksReportItem(id: string, options?: RawAxiosRequestConfig) {
        return AchieveWorksReportApiFp(this.configuration).getCareersByReportAchieveWorksReportItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of AchieveWorksReport resources.
     * @summary Retrieves the collection of AchieveWorksReport resources.
     * @param {string} id AchieveWorksReport identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AchieveWorksReportApi
     */
    public getReportElementBadgesByReportAchieveWorksReportItem(id: string, options?: RawAxiosRequestConfig) {
        return AchieveWorksReportApiFp(this.configuration).getReportElementBadgesByReportAchieveWorksReportItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of AchieveWorksReport resources.
     * @summary Retrieves the collection of AchieveWorksReport resources.
     * @param {string} id AchieveWorksReport identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AchieveWorksReportApi
     */
    public getReportElementRatingsByReportAchieveWorksReportItem(id: string, options?: RawAxiosRequestConfig) {
        return AchieveWorksReportApiFp(this.configuration).getReportElementRatingsByReportAchieveWorksReportItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of AchieveWorksReport resources.
     * @summary Retrieves the collection of AchieveWorksReport resources.
     * @param {string} id AchieveWorksReport identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AchieveWorksReportApi
     */
    public getReportUserAnswersByReportAchieveWorksReportItem(id: string, options?: RawAxiosRequestConfig) {
        return AchieveWorksReportApiFp(this.configuration).getReportUserAnswersByReportAchieveWorksReportItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AchieveWorksReportAnswerApi - axios parameter creator
 * @export
 */
export const AchieveWorksReportAnswerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a AchieveWorksReportAnswer resource.
         * @summary Retrieves a AchieveWorksReportAnswer resource.
         * @param {string} id AchieveWorksReportAnswer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAchieveWorksReportAnswersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAchieveWorksReportAnswersIdGet', 'id', id)
            const localVarPath = `/api/achieve_works_report_answers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AchieveWorksReportAnswerApi - functional programming interface
 * @export
 */
export const AchieveWorksReportAnswerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AchieveWorksReportAnswerApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a AchieveWorksReportAnswer resource.
         * @summary Retrieves a AchieveWorksReportAnswer resource.
         * @param {string} id AchieveWorksReportAnswer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAchieveWorksReportAnswersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AchieveWorksReportAnswerFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAchieveWorksReportAnswersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AchieveWorksReportAnswerApi.apiAchieveWorksReportAnswersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AchieveWorksReportAnswerApi - factory interface
 * @export
 */
export const AchieveWorksReportAnswerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AchieveWorksReportAnswerApiFp(configuration)
    return {
        /**
         * Retrieves a AchieveWorksReportAnswer resource.
         * @summary Retrieves a AchieveWorksReportAnswer resource.
         * @param {string} id AchieveWorksReportAnswer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAchieveWorksReportAnswersIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AchieveWorksReportAnswerFullRead> {
            return localVarFp.apiAchieveWorksReportAnswersIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AchieveWorksReportAnswerApi - object-oriented interface
 * @export
 * @class AchieveWorksReportAnswerApi
 * @extends {BaseAPI}
 */
export class AchieveWorksReportAnswerApi extends BaseAPI {
    /**
     * Retrieves a AchieveWorksReportAnswer resource.
     * @summary Retrieves a AchieveWorksReportAnswer resource.
     * @param {string} id AchieveWorksReportAnswer identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AchieveWorksReportAnswerApi
     */
    public apiAchieveWorksReportAnswersIdGet(id: string, options?: RawAxiosRequestConfig) {
        return AchieveWorksReportAnswerApiFp(this.configuration).apiAchieveWorksReportAnswersIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AchieveWorksReportBadgeApi - axios parameter creator
 * @export
 */
export const AchieveWorksReportBadgeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a AchieveWorksReportBadge resource.
         * @summary Retrieves a AchieveWorksReportBadge resource.
         * @param {string} id AchieveWorksReportBadge identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAchieveWorksReportBadgesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAchieveWorksReportBadgesIdGet', 'id', id)
            const localVarPath = `/api/achieve_works_report_badges/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of AchieveWorksReportBadge resources.
         * @summary Retrieves the collection of AchieveWorksReportBadge resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAchieveWorksReportBadgeCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/achieve_works_report_badges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AchieveWorksReportBadgeApi - functional programming interface
 * @export
 */
export const AchieveWorksReportBadgeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AchieveWorksReportBadgeApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a AchieveWorksReportBadge resource.
         * @summary Retrieves a AchieveWorksReportBadge resource.
         * @param {string} id AchieveWorksReportBadge identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAchieveWorksReportBadgesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AchieveWorksReportBadgeFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAchieveWorksReportBadgesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AchieveWorksReportBadgeApi.apiAchieveWorksReportBadgesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of AchieveWorksReportBadge resources.
         * @summary Retrieves the collection of AchieveWorksReportBadge resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAchieveWorksReportBadgeCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AchieveWorksReportBadgeFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAchieveWorksReportBadgeCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AchieveWorksReportBadgeApi.getAchieveWorksReportBadgeCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AchieveWorksReportBadgeApi - factory interface
 * @export
 */
export const AchieveWorksReportBadgeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AchieveWorksReportBadgeApiFp(configuration)
    return {
        /**
         * Retrieves a AchieveWorksReportBadge resource.
         * @summary Retrieves a AchieveWorksReportBadge resource.
         * @param {string} id AchieveWorksReportBadge identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAchieveWorksReportBadgesIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AchieveWorksReportBadgeFullRead> {
            return localVarFp.apiAchieveWorksReportBadgesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of AchieveWorksReportBadge resources.
         * @summary Retrieves the collection of AchieveWorksReportBadge resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAchieveWorksReportBadgeCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<AchieveWorksReportBadgeFullRead>> {
            return localVarFp.getAchieveWorksReportBadgeCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AchieveWorksReportBadgeApi - object-oriented interface
 * @export
 * @class AchieveWorksReportBadgeApi
 * @extends {BaseAPI}
 */
export class AchieveWorksReportBadgeApi extends BaseAPI {
    /**
     * Retrieves a AchieveWorksReportBadge resource.
     * @summary Retrieves a AchieveWorksReportBadge resource.
     * @param {string} id AchieveWorksReportBadge identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AchieveWorksReportBadgeApi
     */
    public apiAchieveWorksReportBadgesIdGet(id: string, options?: RawAxiosRequestConfig) {
        return AchieveWorksReportBadgeApiFp(this.configuration).apiAchieveWorksReportBadgesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of AchieveWorksReportBadge resources.
     * @summary Retrieves the collection of AchieveWorksReportBadge resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AchieveWorksReportBadgeApi
     */
    public getAchieveWorksReportBadgeCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return AchieveWorksReportBadgeApiFp(this.configuration).getAchieveWorksReportBadgeCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AchieveWorksReportElementApi - axios parameter creator
 * @export
 */
export const AchieveWorksReportElementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a AchieveWorksReportElement resource.
         * @summary Retrieves a AchieveWorksReportElement resource.
         * @param {string} id AchieveWorksReportElement identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAchieveWorksReportElementsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAchieveWorksReportElementsIdGet', 'id', id)
            const localVarPath = `/api/achieve_works_report_elements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AchieveWorksReportElementApi - functional programming interface
 * @export
 */
export const AchieveWorksReportElementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AchieveWorksReportElementApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a AchieveWorksReportElement resource.
         * @summary Retrieves a AchieveWorksReportElement resource.
         * @param {string} id AchieveWorksReportElement identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAchieveWorksReportElementsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AchieveWorksReportElementFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAchieveWorksReportElementsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AchieveWorksReportElementApi.apiAchieveWorksReportElementsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AchieveWorksReportElementApi - factory interface
 * @export
 */
export const AchieveWorksReportElementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AchieveWorksReportElementApiFp(configuration)
    return {
        /**
         * Retrieves a AchieveWorksReportElement resource.
         * @summary Retrieves a AchieveWorksReportElement resource.
         * @param {string} id AchieveWorksReportElement identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAchieveWorksReportElementsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AchieveWorksReportElementFullRead> {
            return localVarFp.apiAchieveWorksReportElementsIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AchieveWorksReportElementApi - object-oriented interface
 * @export
 * @class AchieveWorksReportElementApi
 * @extends {BaseAPI}
 */
export class AchieveWorksReportElementApi extends BaseAPI {
    /**
     * Retrieves a AchieveWorksReportElement resource.
     * @summary Retrieves a AchieveWorksReportElement resource.
     * @param {string} id AchieveWorksReportElement identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AchieveWorksReportElementApi
     */
    public apiAchieveWorksReportElementsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return AchieveWorksReportElementApiFp(this.configuration).apiAchieveWorksReportElementsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AchieveWorksReportQuestionApi - axios parameter creator
 * @export
 */
export const AchieveWorksReportQuestionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a AchieveWorksReportQuestion resource.
         * @summary Retrieves a AchieveWorksReportQuestion resource.
         * @param {string} id AchieveWorksReportQuestion identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAchieveWorksReportQuestionsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAchieveWorksReportQuestionsIdGet', 'id', id)
            const localVarPath = `/api/achieve_works_report_questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AchieveWorksReportQuestionApi - functional programming interface
 * @export
 */
export const AchieveWorksReportQuestionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AchieveWorksReportQuestionApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a AchieveWorksReportQuestion resource.
         * @summary Retrieves a AchieveWorksReportQuestion resource.
         * @param {string} id AchieveWorksReportQuestion identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAchieveWorksReportQuestionsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AchieveWorksReportQuestionFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAchieveWorksReportQuestionsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AchieveWorksReportQuestionApi.apiAchieveWorksReportQuestionsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AchieveWorksReportQuestionApi - factory interface
 * @export
 */
export const AchieveWorksReportQuestionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AchieveWorksReportQuestionApiFp(configuration)
    return {
        /**
         * Retrieves a AchieveWorksReportQuestion resource.
         * @summary Retrieves a AchieveWorksReportQuestion resource.
         * @param {string} id AchieveWorksReportQuestion identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAchieveWorksReportQuestionsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AchieveWorksReportQuestionFullRead> {
            return localVarFp.apiAchieveWorksReportQuestionsIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AchieveWorksReportQuestionApi - object-oriented interface
 * @export
 * @class AchieveWorksReportQuestionApi
 * @extends {BaseAPI}
 */
export class AchieveWorksReportQuestionApi extends BaseAPI {
    /**
     * Retrieves a AchieveWorksReportQuestion resource.
     * @summary Retrieves a AchieveWorksReportQuestion resource.
     * @param {string} id AchieveWorksReportQuestion identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AchieveWorksReportQuestionApi
     */
    public apiAchieveWorksReportQuestionsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return AchieveWorksReportQuestionApiFp(this.configuration).apiAchieveWorksReportQuestionsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AchieveWorksReportRatingApi - axios parameter creator
 * @export
 */
export const AchieveWorksReportRatingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a AchieveWorksReportRating resource.
         * @summary Retrieves a AchieveWorksReportRating resource.
         * @param {string} id AchieveWorksReportRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAchieveWorksReportRatingsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAchieveWorksReportRatingsIdGet', 'id', id)
            const localVarPath = `/api/achieve_works_report_ratings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of AchieveWorksReportRating resources.
         * @summary Retrieves the collection of AchieveWorksReportRating resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAchieveWorksReportRatingCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/achieve_works_report_ratings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AchieveWorksReportRatingApi - functional programming interface
 * @export
 */
export const AchieveWorksReportRatingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AchieveWorksReportRatingApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a AchieveWorksReportRating resource.
         * @summary Retrieves a AchieveWorksReportRating resource.
         * @param {string} id AchieveWorksReportRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAchieveWorksReportRatingsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AchieveWorksReportRatingFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAchieveWorksReportRatingsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AchieveWorksReportRatingApi.apiAchieveWorksReportRatingsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of AchieveWorksReportRating resources.
         * @summary Retrieves the collection of AchieveWorksReportRating resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAchieveWorksReportRatingCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AchieveWorksReportRatingFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAchieveWorksReportRatingCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AchieveWorksReportRatingApi.getAchieveWorksReportRatingCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AchieveWorksReportRatingApi - factory interface
 * @export
 */
export const AchieveWorksReportRatingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AchieveWorksReportRatingApiFp(configuration)
    return {
        /**
         * Retrieves a AchieveWorksReportRating resource.
         * @summary Retrieves a AchieveWorksReportRating resource.
         * @param {string} id AchieveWorksReportRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAchieveWorksReportRatingsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AchieveWorksReportRatingFullRead> {
            return localVarFp.apiAchieveWorksReportRatingsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of AchieveWorksReportRating resources.
         * @summary Retrieves the collection of AchieveWorksReportRating resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAchieveWorksReportRatingCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<AchieveWorksReportRatingFullRead>> {
            return localVarFp.getAchieveWorksReportRatingCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AchieveWorksReportRatingApi - object-oriented interface
 * @export
 * @class AchieveWorksReportRatingApi
 * @extends {BaseAPI}
 */
export class AchieveWorksReportRatingApi extends BaseAPI {
    /**
     * Retrieves a AchieveWorksReportRating resource.
     * @summary Retrieves a AchieveWorksReportRating resource.
     * @param {string} id AchieveWorksReportRating identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AchieveWorksReportRatingApi
     */
    public apiAchieveWorksReportRatingsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return AchieveWorksReportRatingApiFp(this.configuration).apiAchieveWorksReportRatingsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of AchieveWorksReportRating resources.
     * @summary Retrieves the collection of AchieveWorksReportRating resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AchieveWorksReportRatingApi
     */
    public getAchieveWorksReportRatingCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return AchieveWorksReportRatingApiFp(this.configuration).getAchieveWorksReportRatingCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ActivityTypeApi - axios parameter creator
 * @export
 */
export const ActivityTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a ActivityType resource.
         * @summary Retrieves a ActivityType resource.
         * @param {string} id ActivityType identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActivityTypesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiActivityTypesIdGet', 'id', id)
            const localVarPath = `/api/activity_types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivityTypeApi - functional programming interface
 * @export
 */
export const ActivityTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivityTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a ActivityType resource.
         * @summary Retrieves a ActivityType resource.
         * @param {string} id ActivityType identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiActivityTypesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityTypeFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiActivityTypesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityTypeApi.apiActivityTypesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActivityTypeApi - factory interface
 * @export
 */
export const ActivityTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivityTypeApiFp(configuration)
    return {
        /**
         * Retrieves a ActivityType resource.
         * @summary Retrieves a ActivityType resource.
         * @param {string} id ActivityType identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActivityTypesIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ActivityTypeFullRead> {
            return localVarFp.apiActivityTypesIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivityTypeApi - object-oriented interface
 * @export
 * @class ActivityTypeApi
 * @extends {BaseAPI}
 */
export class ActivityTypeApi extends BaseAPI {
    /**
     * Retrieves a ActivityType resource.
     * @summary Retrieves a ActivityType resource.
     * @param {string} id ActivityType identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityTypeApi
     */
    public apiActivityTypesIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ActivityTypeApiFp(this.configuration).apiActivityTypesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnswerApi - axios parameter creator
 * @export
 */
export const AnswerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of Answer resources.
         * @summary Retrieves the collection of Answer resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnswerCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/answers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Answer resource.
         * @summary Retrieves a Answer resource.
         * @param {string} id Answer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnswerItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAnswerItem', 'id', id)
            const localVarPath = `/api/answers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnswerApi - functional programming interface
 * @export
 */
export const AnswerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnswerApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of Answer resources.
         * @summary Retrieves the collection of Answer resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnswerCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnswerFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnswerCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnswerApi.getAnswerCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a Answer resource.
         * @summary Retrieves a Answer resource.
         * @param {string} id Answer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnswerItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnswerFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnswerItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnswerApi.getAnswerItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnswerApi - factory interface
 * @export
 */
export const AnswerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnswerApiFp(configuration)
    return {
        /**
         * Retrieves the collection of Answer resources.
         * @summary Retrieves the collection of Answer resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnswerCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<AnswerFullRead>> {
            return localVarFp.getAnswerCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Answer resource.
         * @summary Retrieves a Answer resource.
         * @param {string} id Answer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnswerItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AnswerFullRead> {
            return localVarFp.getAnswerItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnswerApi - object-oriented interface
 * @export
 * @class AnswerApi
 * @extends {BaseAPI}
 */
export class AnswerApi extends BaseAPI {
    /**
     * Retrieves the collection of Answer resources.
     * @summary Retrieves the collection of Answer resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerApi
     */
    public getAnswerCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return AnswerApiFp(this.configuration).getAnswerCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Answer resource.
     * @summary Retrieves a Answer resource.
     * @param {string} id Answer identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerApi
     */
    public getAnswerItem(id: string, options?: RawAxiosRequestConfig) {
        return AnswerApiFp(this.configuration).getAnswerItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AptitudeSectionConfigurationApi - axios parameter creator
 * @export
 */
export const AptitudeSectionConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a AptitudeSectionConfiguration resource.
         * @summary Retrieves a AptitudeSectionConfiguration resource.
         * @param {string} id AptitudeSectionConfiguration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAptitudeSectionConfigurationsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAptitudeSectionConfigurationsIdGet', 'id', id)
            const localVarPath = `/api/aptitude_section_configurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AptitudeSectionConfigurationApi - functional programming interface
 * @export
 */
export const AptitudeSectionConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AptitudeSectionConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a AptitudeSectionConfiguration resource.
         * @summary Retrieves a AptitudeSectionConfiguration resource.
         * @param {string} id AptitudeSectionConfiguration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAptitudeSectionConfigurationsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AptitudeSectionConfigurationFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAptitudeSectionConfigurationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AptitudeSectionConfigurationApi.apiAptitudeSectionConfigurationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AptitudeSectionConfigurationApi - factory interface
 * @export
 */
export const AptitudeSectionConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AptitudeSectionConfigurationApiFp(configuration)
    return {
        /**
         * Retrieves a AptitudeSectionConfiguration resource.
         * @summary Retrieves a AptitudeSectionConfiguration resource.
         * @param {string} id AptitudeSectionConfiguration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAptitudeSectionConfigurationsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AptitudeSectionConfigurationFullRead> {
            return localVarFp.apiAptitudeSectionConfigurationsIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AptitudeSectionConfigurationApi - object-oriented interface
 * @export
 * @class AptitudeSectionConfigurationApi
 * @extends {BaseAPI}
 */
export class AptitudeSectionConfigurationApi extends BaseAPI {
    /**
     * Retrieves a AptitudeSectionConfiguration resource.
     * @summary Retrieves a AptitudeSectionConfiguration resource.
     * @param {string} id AptitudeSectionConfiguration identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AptitudeSectionConfigurationApi
     */
    public apiAptitudeSectionConfigurationsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return AptitudeSectionConfigurationApiFp(this.configuration).apiAptitudeSectionConfigurationsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AptitudesConfigurationApi - axios parameter creator
 * @export
 */
export const AptitudesConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a AptitudesConfiguration resource.
         * @summary Retrieves a AptitudesConfiguration resource.
         * @param {string} id AptitudesConfiguration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAptitudesConfigurationsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAptitudesConfigurationsIdGet', 'id', id)
            const localVarPath = `/api/aptitudes_configurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AptitudesConfigurationApi - functional programming interface
 * @export
 */
export const AptitudesConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AptitudesConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a AptitudesConfiguration resource.
         * @summary Retrieves a AptitudesConfiguration resource.
         * @param {string} id AptitudesConfiguration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAptitudesConfigurationsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAptitudesConfigurationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AptitudesConfigurationApi.apiAptitudesConfigurationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AptitudesConfigurationApi - factory interface
 * @export
 */
export const AptitudesConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AptitudesConfigurationApiFp(configuration)
    return {
        /**
         * Retrieves a AptitudesConfiguration resource.
         * @summary Retrieves a AptitudesConfiguration resource.
         * @param {string} id AptitudesConfiguration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAptitudesConfigurationsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.apiAptitudesConfigurationsIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AptitudesConfigurationApi - object-oriented interface
 * @export
 * @class AptitudesConfigurationApi
 * @extends {BaseAPI}
 */
export class AptitudesConfigurationApi extends BaseAPI {
    /**
     * Retrieves a AptitudesConfiguration resource.
     * @summary Retrieves a AptitudesConfiguration resource.
     * @param {string} id AptitudesConfiguration identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AptitudesConfigurationApi
     */
    public apiAptitudesConfigurationsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return AptitudesConfigurationApiFp(this.configuration).apiAptitudesConfigurationsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssessmentApi - axios parameter creator
 * @export
 */
export const AssessmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of Assessment resources.
         * @summary Retrieves the collection of Assessment resources.
         * @param {string} id Assessment identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdassessmentsGetCollection: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdassessmentsGetCollection', 'id', id)
            const localVarPath = `/api/users/{id}/assessments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the Assessment resource.
         * @summary Replaces the Assessment resource.
         * @param {string} id Assessment identifier
         * @param {object} body The updated Assessment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateAssessmentAssessmentItem: async (id: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('calculateAssessmentAssessmentItem', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('calculateAssessmentAssessmentItem', 'body', body)
            const localVarPath = `/api/assessments/{id}/calculate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Assessment resource.
         * @summary Creates a Assessment resource.
         * @param {string} id Assessment identifier
         * @param {AssessmentMinimumWrite} [assessmentMinimumWrite] The new Assessment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTimerForAssessmentAssessmentItem: async (id: string, assessmentMinimumWrite?: AssessmentMinimumWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createTimerForAssessmentAssessmentItem', 'id', id)
            const localVarPath = `/api/assessments/{id}/timer/create`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assessmentMinimumWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the Assessment resource.
         * @summary Removes the Assessment resource.
         * @param {string} id Assessment identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssessmentItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAssessmentItem', 'id', id)
            const localVarPath = `/api/assessments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of Assessment resources.
         * @summary Retrieves the collection of Assessment resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {string} [user] 
         * @param {Array<string>} [user2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentCollection: async (page?: number, pagination?: boolean, id?: number, id2?: Array<number>, user?: string, user2?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (id2) {
                localVarQueryParameter['id[]'] = id2;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            if (user2) {
                localVarQueryParameter['user[]'] = user2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Assessment resource.
         * @summary Retrieves a Assessment resource.
         * @param {string} id Assessment identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAssessmentItem', 'id', id)
            const localVarPath = `/api/assessments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Assessment resource.
         * @summary Retrieves a Assessment resource.
         * @param {string} id Assessment identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimerForAssessmentAssessmentItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTimerForAssessmentAssessmentItem', 'id', id)
            const localVarPath = `/api/assessments/{id}/timer`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the Assessment resource.
         * @summary Updates the Assessment resource.
         * @param {string} id Assessment identifier
         * @param {AssessmentMinimumPatch} assessmentMinimumPatch The updated Assessment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAssessmentItem: async (id: string, assessmentMinimumPatch: AssessmentMinimumPatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchAssessmentItem', 'id', id)
            // verify required parameter 'assessmentMinimumPatch' is not null or undefined
            assertParamExists('patchAssessmentItem', 'assessmentMinimumPatch', assessmentMinimumPatch)
            const localVarPath = `/api/assessments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assessmentMinimumPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Assessment resource.
         * @summary Creates a Assessment resource.
         * @param {AssessmentMinimumWrite} assessmentMinimumWrite The new Assessment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAssessmentAssessmentCollection: async (assessmentMinimumWrite: AssessmentMinimumWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentMinimumWrite' is not null or undefined
            assertParamExists('startAssessmentAssessmentCollection', 'assessmentMinimumWrite', assessmentMinimumWrite)
            const localVarPath = `/api/assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assessmentMinimumWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Assessment resource.
         * @summary Retrieves a Assessment resource.
         * @param {string} id Assessment identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopTimerForAssessmentAssessmentItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stopTimerForAssessmentAssessmentItem', 'id', id)
            const localVarPath = `/api/assessments/{id}/timer/stop`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssessmentApi - functional programming interface
 * @export
 */
export const AssessmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssessmentApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of Assessment resources.
         * @summary Retrieves the collection of Assessment resources.
         * @param {string} id Assessment identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdassessmentsGetCollection(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssessmentMinimumRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdassessmentsGetCollection(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentApi.apiUsersIdassessmentsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the Assessment resource.
         * @summary Replaces the Assessment resource.
         * @param {string} id Assessment identifier
         * @param {object} body The updated Assessment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateAssessmentAssessmentItem(id: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateAssessmentAssessmentItem(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentApi.calculateAssessmentAssessmentItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Assessment resource.
         * @summary Creates a Assessment resource.
         * @param {string} id Assessment identifier
         * @param {AssessmentMinimumWrite} [assessmentMinimumWrite] The new Assessment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTimerForAssessmentAssessmentItem(id: string, assessmentMinimumWrite?: AssessmentMinimumWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimerFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTimerForAssessmentAssessmentItem(id, assessmentMinimumWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentApi.createTimerForAssessmentAssessmentItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes the Assessment resource.
         * @summary Removes the Assessment resource.
         * @param {string} id Assessment identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAssessmentItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAssessmentItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentApi.deleteAssessmentItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of Assessment resources.
         * @summary Retrieves the collection of Assessment resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {string} [user] 
         * @param {Array<string>} [user2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessmentCollection(page?: number, pagination?: boolean, id?: number, id2?: Array<number>, user?: string, user2?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssessmentMinimumRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessmentCollection(page, pagination, id, id2, user, user2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentApi.getAssessmentCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a Assessment resource.
         * @summary Retrieves a Assessment resource.
         * @param {string} id Assessment identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessmentItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessmentItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentApi.getAssessmentItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a Assessment resource.
         * @summary Retrieves a Assessment resource.
         * @param {string} id Assessment identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimerForAssessmentAssessmentItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimerFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimerForAssessmentAssessmentItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentApi.getTimerForAssessmentAssessmentItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the Assessment resource.
         * @summary Updates the Assessment resource.
         * @param {string} id Assessment identifier
         * @param {AssessmentMinimumPatch} assessmentMinimumPatch The updated Assessment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAssessmentItem(id: string, assessmentMinimumPatch: AssessmentMinimumPatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentMinimumRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAssessmentItem(id, assessmentMinimumPatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentApi.patchAssessmentItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Assessment resource.
         * @summary Creates a Assessment resource.
         * @param {AssessmentMinimumWrite} assessmentMinimumWrite The new Assessment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startAssessmentAssessmentCollection(assessmentMinimumWrite: AssessmentMinimumWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startAssessmentAssessmentCollection(assessmentMinimumWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentApi.startAssessmentAssessmentCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a Assessment resource.
         * @summary Retrieves a Assessment resource.
         * @param {string} id Assessment identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopTimerForAssessmentAssessmentItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimerFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopTimerForAssessmentAssessmentItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentApi.stopTimerForAssessmentAssessmentItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssessmentApi - factory interface
 * @export
 */
export const AssessmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssessmentApiFp(configuration)
    return {
        /**
         * Retrieves the collection of Assessment resources.
         * @summary Retrieves the collection of Assessment resources.
         * @param {string} id Assessment identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdassessmentsGetCollection(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssessmentMinimumRead>> {
            return localVarFp.apiUsersIdassessmentsGetCollection(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the Assessment resource.
         * @summary Replaces the Assessment resource.
         * @param {string} id Assessment identifier
         * @param {object} body The updated Assessment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateAssessmentAssessmentItem(id: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentFullRead> {
            return localVarFp.calculateAssessmentAssessmentItem(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Assessment resource.
         * @summary Creates a Assessment resource.
         * @param {string} id Assessment identifier
         * @param {AssessmentMinimumWrite} [assessmentMinimumWrite] The new Assessment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTimerForAssessmentAssessmentItem(id: string, assessmentMinimumWrite?: AssessmentMinimumWrite, options?: RawAxiosRequestConfig): AxiosPromise<TimerFullRead> {
            return localVarFp.createTimerForAssessmentAssessmentItem(id, assessmentMinimumWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the Assessment resource.
         * @summary Removes the Assessment resource.
         * @param {string} id Assessment identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssessmentItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAssessmentItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of Assessment resources.
         * @summary Retrieves the collection of Assessment resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {string} [user] 
         * @param {Array<string>} [user2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentCollection(page?: number, pagination?: boolean, id?: number, id2?: Array<number>, user?: string, user2?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssessmentMinimumRead>> {
            return localVarFp.getAssessmentCollection(page, pagination, id, id2, user, user2, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Assessment resource.
         * @summary Retrieves a Assessment resource.
         * @param {string} id Assessment identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentFullRead> {
            return localVarFp.getAssessmentItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Assessment resource.
         * @summary Retrieves a Assessment resource.
         * @param {string} id Assessment identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimerForAssessmentAssessmentItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<TimerFullRead> {
            return localVarFp.getTimerForAssessmentAssessmentItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the Assessment resource.
         * @summary Updates the Assessment resource.
         * @param {string} id Assessment identifier
         * @param {AssessmentMinimumPatch} assessmentMinimumPatch The updated Assessment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAssessmentItem(id: string, assessmentMinimumPatch: AssessmentMinimumPatch, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentMinimumRead> {
            return localVarFp.patchAssessmentItem(id, assessmentMinimumPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Assessment resource.
         * @summary Creates a Assessment resource.
         * @param {AssessmentMinimumWrite} assessmentMinimumWrite The new Assessment resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAssessmentAssessmentCollection(assessmentMinimumWrite: AssessmentMinimumWrite, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentFullRead> {
            return localVarFp.startAssessmentAssessmentCollection(assessmentMinimumWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Assessment resource.
         * @summary Retrieves a Assessment resource.
         * @param {string} id Assessment identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopTimerForAssessmentAssessmentItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<TimerFullRead> {
            return localVarFp.stopTimerForAssessmentAssessmentItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssessmentApi - object-oriented interface
 * @export
 * @class AssessmentApi
 * @extends {BaseAPI}
 */
export class AssessmentApi extends BaseAPI {
    /**
     * Retrieves the collection of Assessment resources.
     * @summary Retrieves the collection of Assessment resources.
     * @param {string} id Assessment identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiUsersIdassessmentsGetCollection(id: string, options?: RawAxiosRequestConfig) {
        return AssessmentApiFp(this.configuration).apiUsersIdassessmentsGetCollection(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the Assessment resource.
     * @summary Replaces the Assessment resource.
     * @param {string} id Assessment identifier
     * @param {object} body The updated Assessment resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public calculateAssessmentAssessmentItem(id: string, body: object, options?: RawAxiosRequestConfig) {
        return AssessmentApiFp(this.configuration).calculateAssessmentAssessmentItem(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Assessment resource.
     * @summary Creates a Assessment resource.
     * @param {string} id Assessment identifier
     * @param {AssessmentMinimumWrite} [assessmentMinimumWrite] The new Assessment resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public createTimerForAssessmentAssessmentItem(id: string, assessmentMinimumWrite?: AssessmentMinimumWrite, options?: RawAxiosRequestConfig) {
        return AssessmentApiFp(this.configuration).createTimerForAssessmentAssessmentItem(id, assessmentMinimumWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes the Assessment resource.
     * @summary Removes the Assessment resource.
     * @param {string} id Assessment identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public deleteAssessmentItem(id: string, options?: RawAxiosRequestConfig) {
        return AssessmentApiFp(this.configuration).deleteAssessmentItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of Assessment resources.
     * @summary Retrieves the collection of Assessment resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {number} [id] 
     * @param {Array<number>} [id2] 
     * @param {string} [user] 
     * @param {Array<string>} [user2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public getAssessmentCollection(page?: number, pagination?: boolean, id?: number, id2?: Array<number>, user?: string, user2?: Array<string>, options?: RawAxiosRequestConfig) {
        return AssessmentApiFp(this.configuration).getAssessmentCollection(page, pagination, id, id2, user, user2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Assessment resource.
     * @summary Retrieves a Assessment resource.
     * @param {string} id Assessment identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public getAssessmentItem(id: string, options?: RawAxiosRequestConfig) {
        return AssessmentApiFp(this.configuration).getAssessmentItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Assessment resource.
     * @summary Retrieves a Assessment resource.
     * @param {string} id Assessment identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public getTimerForAssessmentAssessmentItem(id: string, options?: RawAxiosRequestConfig) {
        return AssessmentApiFp(this.configuration).getTimerForAssessmentAssessmentItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the Assessment resource.
     * @summary Updates the Assessment resource.
     * @param {string} id Assessment identifier
     * @param {AssessmentMinimumPatch} assessmentMinimumPatch The updated Assessment resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public patchAssessmentItem(id: string, assessmentMinimumPatch: AssessmentMinimumPatch, options?: RawAxiosRequestConfig) {
        return AssessmentApiFp(this.configuration).patchAssessmentItem(id, assessmentMinimumPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Assessment resource.
     * @summary Creates a Assessment resource.
     * @param {AssessmentMinimumWrite} assessmentMinimumWrite The new Assessment resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public startAssessmentAssessmentCollection(assessmentMinimumWrite: AssessmentMinimumWrite, options?: RawAxiosRequestConfig) {
        return AssessmentApiFp(this.configuration).startAssessmentAssessmentCollection(assessmentMinimumWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Assessment resource.
     * @summary Retrieves a Assessment resource.
     * @param {string} id Assessment identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public stopTimerForAssessmentAssessmentItem(id: string, options?: RawAxiosRequestConfig) {
        return AssessmentApiFp(this.configuration).stopTimerForAssessmentAssessmentItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssessmentCareerMatchesApi - axios parameter creator
 * @export
 */
export const AssessmentCareerMatchesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of AssessmentCareerMatches resources.
         * @summary Retrieves the collection of AssessmentCareerMatches resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentCareerMatchesCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/assessment_career_matches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a AssessmentCareerMatches resource.
         * @summary Retrieves a AssessmentCareerMatches resource.
         * @param {string} id AssessmentCareerMatches identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentCareerMatchesItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAssessmentCareerMatchesItem', 'id', id)
            const localVarPath = `/api/assessment_career_matches/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssessmentCareerMatchesApi - functional programming interface
 * @export
 */
export const AssessmentCareerMatchesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssessmentCareerMatchesApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of AssessmentCareerMatches resources.
         * @summary Retrieves the collection of AssessmentCareerMatches resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessmentCareerMatchesCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssessmentCareerMatchesFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessmentCareerMatchesCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentCareerMatchesApi.getAssessmentCareerMatchesCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a AssessmentCareerMatches resource.
         * @summary Retrieves a AssessmentCareerMatches resource.
         * @param {string} id AssessmentCareerMatches identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessmentCareerMatchesItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentCareerMatchesFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessmentCareerMatchesItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentCareerMatchesApi.getAssessmentCareerMatchesItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssessmentCareerMatchesApi - factory interface
 * @export
 */
export const AssessmentCareerMatchesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssessmentCareerMatchesApiFp(configuration)
    return {
        /**
         * Retrieves the collection of AssessmentCareerMatches resources.
         * @summary Retrieves the collection of AssessmentCareerMatches resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentCareerMatchesCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssessmentCareerMatchesFullRead>> {
            return localVarFp.getAssessmentCareerMatchesCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a AssessmentCareerMatches resource.
         * @summary Retrieves a AssessmentCareerMatches resource.
         * @param {string} id AssessmentCareerMatches identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentCareerMatchesItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentCareerMatchesFullRead> {
            return localVarFp.getAssessmentCareerMatchesItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssessmentCareerMatchesApi - object-oriented interface
 * @export
 * @class AssessmentCareerMatchesApi
 * @extends {BaseAPI}
 */
export class AssessmentCareerMatchesApi extends BaseAPI {
    /**
     * Retrieves the collection of AssessmentCareerMatches resources.
     * @summary Retrieves the collection of AssessmentCareerMatches resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentCareerMatchesApi
     */
    public getAssessmentCareerMatchesCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return AssessmentCareerMatchesApiFp(this.configuration).getAssessmentCareerMatchesCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a AssessmentCareerMatches resource.
     * @summary Retrieves a AssessmentCareerMatches resource.
     * @param {string} id AssessmentCareerMatches identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentCareerMatchesApi
     */
    public getAssessmentCareerMatchesItem(id: string, options?: RawAxiosRequestConfig) {
        return AssessmentCareerMatchesApiFp(this.configuration).getAssessmentCareerMatchesItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssessmentTypeApi - axios parameter creator
 * @export
 */
export const AssessmentTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of AssessmentType resources.
         * @summary Retrieves the collection of AssessmentType resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentTypesGetCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/assessment_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a AssessmentType resource.
         * @summary Retrieves a AssessmentType resource.
         * @param {string} id AssessmentType identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentTypesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAssessmentTypesIdGet', 'id', id)
            const localVarPath = `/api/assessment_types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssessmentTypeApi - functional programming interface
 * @export
 */
export const AssessmentTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssessmentTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of AssessmentType resources.
         * @summary Retrieves the collection of AssessmentType resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentTypesGetCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssessmentTypeFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAssessmentTypesGetCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentTypeApi.apiAssessmentTypesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a AssessmentType resource.
         * @summary Retrieves a AssessmentType resource.
         * @param {string} id AssessmentType identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentTypesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentTypeFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAssessmentTypesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentTypeApi.apiAssessmentTypesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssessmentTypeApi - factory interface
 * @export
 */
export const AssessmentTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssessmentTypeApiFp(configuration)
    return {
        /**
         * Retrieves the collection of AssessmentType resources.
         * @summary Retrieves the collection of AssessmentType resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentTypesGetCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssessmentTypeFullRead>> {
            return localVarFp.apiAssessmentTypesGetCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a AssessmentType resource.
         * @summary Retrieves a AssessmentType resource.
         * @param {string} id AssessmentType identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentTypesIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentTypeFullRead> {
            return localVarFp.apiAssessmentTypesIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssessmentTypeApi - object-oriented interface
 * @export
 * @class AssessmentTypeApi
 * @extends {BaseAPI}
 */
export class AssessmentTypeApi extends BaseAPI {
    /**
     * Retrieves the collection of AssessmentType resources.
     * @summary Retrieves the collection of AssessmentType resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentTypeApi
     */
    public apiAssessmentTypesGetCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return AssessmentTypeApiFp(this.configuration).apiAssessmentTypesGetCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a AssessmentType resource.
     * @summary Retrieves a AssessmentType resource.
     * @param {string} id AssessmentType identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentTypeApi
     */
    public apiAssessmentTypesIdGet(id: string, options?: RawAxiosRequestConfig) {
        return AssessmentTypeApiFp(this.configuration).apiAssessmentTypesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CareerApi - axios parameter creator
 * @export
 */
export const CareerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of Career resources.
         * @summary Retrieves the collection of Career resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/careers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Career resource.
         * @summary Retrieves a Career resource.
         * @param {string} id Career identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCareerItem', 'id', id)
            const localVarPath = `/api/careers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CareerApi - functional programming interface
 * @export
 */
export const CareerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CareerApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of Career resources.
         * @summary Retrieves the collection of Career resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CareerMinimumRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerApi.getCareerCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a Career resource.
         * @summary Retrieves a Career resource.
         * @param {string} id Career identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerItemFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerApi.getCareerItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CareerApi - factory interface
 * @export
 */
export const CareerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CareerApiFp(configuration)
    return {
        /**
         * Retrieves the collection of Career resources.
         * @summary Retrieves the collection of Career resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<CareerMinimumRead>> {
            return localVarFp.getCareerCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Career resource.
         * @summary Retrieves a Career resource.
         * @param {string} id Career identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CareerItemFullRead> {
            return localVarFp.getCareerItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CareerApi - object-oriented interface
 * @export
 * @class CareerApi
 * @extends {BaseAPI}
 */
export class CareerApi extends BaseAPI {
    /**
     * Retrieves the collection of Career resources.
     * @summary Retrieves the collection of Career resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerApi
     */
    public getCareerCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return CareerApiFp(this.configuration).getCareerCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Career resource.
     * @summary Retrieves a Career resource.
     * @param {string} id Career identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerApi
     */
    public getCareerItem(id: string, options?: RawAxiosRequestConfig) {
        return CareerApiFp(this.configuration).getCareerItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CareerAptitudesBaselineApi - axios parameter creator
 * @export
 */
export const CareerAptitudesBaselineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of CareerAptitudesBaseline resources.
         * @summary Retrieves the collection of CareerAptitudesBaseline resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerAptitudesBaselineCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/career_aptitudes_baselines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a CareerAptitudesBaseline resource.
         * @summary Retrieves a CareerAptitudesBaseline resource.
         * @param {string} id CareerAptitudesBaseline identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerAptitudesBaselineItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCareerAptitudesBaselineItem', 'id', id)
            const localVarPath = `/api/career_aptitudes_baselines/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CareerAptitudesBaselineApi - functional programming interface
 * @export
 */
export const CareerAptitudesBaselineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CareerAptitudesBaselineApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of CareerAptitudesBaseline resources.
         * @summary Retrieves the collection of CareerAptitudesBaseline resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerAptitudesBaselineCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CareerAptitudesBaselineFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerAptitudesBaselineCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerAptitudesBaselineApi.getCareerAptitudesBaselineCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a CareerAptitudesBaseline resource.
         * @summary Retrieves a CareerAptitudesBaseline resource.
         * @param {string} id CareerAptitudesBaseline identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerAptitudesBaselineItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerAptitudesBaselineFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerAptitudesBaselineItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerAptitudesBaselineApi.getCareerAptitudesBaselineItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CareerAptitudesBaselineApi - factory interface
 * @export
 */
export const CareerAptitudesBaselineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CareerAptitudesBaselineApiFp(configuration)
    return {
        /**
         * Retrieves the collection of CareerAptitudesBaseline resources.
         * @summary Retrieves the collection of CareerAptitudesBaseline resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerAptitudesBaselineCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<CareerAptitudesBaselineFullRead>> {
            return localVarFp.getCareerAptitudesBaselineCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a CareerAptitudesBaseline resource.
         * @summary Retrieves a CareerAptitudesBaseline resource.
         * @param {string} id CareerAptitudesBaseline identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerAptitudesBaselineItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CareerAptitudesBaselineFullRead> {
            return localVarFp.getCareerAptitudesBaselineItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CareerAptitudesBaselineApi - object-oriented interface
 * @export
 * @class CareerAptitudesBaselineApi
 * @extends {BaseAPI}
 */
export class CareerAptitudesBaselineApi extends BaseAPI {
    /**
     * Retrieves the collection of CareerAptitudesBaseline resources.
     * @summary Retrieves the collection of CareerAptitudesBaseline resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerAptitudesBaselineApi
     */
    public getCareerAptitudesBaselineCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return CareerAptitudesBaselineApiFp(this.configuration).getCareerAptitudesBaselineCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a CareerAptitudesBaseline resource.
     * @summary Retrieves a CareerAptitudesBaseline resource.
     * @param {string} id CareerAptitudesBaseline identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerAptitudesBaselineApi
     */
    public getCareerAptitudesBaselineItem(id: string, options?: RawAxiosRequestConfig) {
        return CareerAptitudesBaselineApiFp(this.configuration).getCareerAptitudesBaselineItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CareerClusterApi - axios parameter creator
 * @export
 */
export const CareerClusterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of CareerCluster resources.
         * @summary Retrieves the collection of CareerCluster resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerClusterCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/career_clusters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a CareerCluster resource.
         * @summary Retrieves a CareerCluster resource.
         * @param {string} id CareerCluster identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerClusterItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCareerClusterItem', 'id', id)
            const localVarPath = `/api/career_clusters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CareerClusterApi - functional programming interface
 * @export
 */
export const CareerClusterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CareerClusterApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of CareerCluster resources.
         * @summary Retrieves the collection of CareerCluster resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerClusterCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CareerClusterFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerClusterCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerClusterApi.getCareerClusterCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a CareerCluster resource.
         * @summary Retrieves a CareerCluster resource.
         * @param {string} id CareerCluster identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerClusterItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerClusterFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerClusterItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerClusterApi.getCareerClusterItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CareerClusterApi - factory interface
 * @export
 */
export const CareerClusterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CareerClusterApiFp(configuration)
    return {
        /**
         * Retrieves the collection of CareerCluster resources.
         * @summary Retrieves the collection of CareerCluster resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerClusterCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<CareerClusterFullRead>> {
            return localVarFp.getCareerClusterCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a CareerCluster resource.
         * @summary Retrieves a CareerCluster resource.
         * @param {string} id CareerCluster identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerClusterItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CareerClusterFullRead> {
            return localVarFp.getCareerClusterItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CareerClusterApi - object-oriented interface
 * @export
 * @class CareerClusterApi
 * @extends {BaseAPI}
 */
export class CareerClusterApi extends BaseAPI {
    /**
     * Retrieves the collection of CareerCluster resources.
     * @summary Retrieves the collection of CareerCluster resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerClusterApi
     */
    public getCareerClusterCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return CareerClusterApiFp(this.configuration).getCareerClusterCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a CareerCluster resource.
     * @summary Retrieves a CareerCluster resource.
     * @param {string} id CareerCluster identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerClusterApi
     */
    public getCareerClusterItem(id: string, options?: RawAxiosRequestConfig) {
        return CareerClusterApiFp(this.configuration).getCareerClusterItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CareerClusterRatingApi - axios parameter creator
 * @export
 */
export const CareerClusterRatingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of CareerClusterRating resources.
         * @summary Retrieves the collection of CareerClusterRating resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerClusterRatingCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/career_cluster_ratings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a CareerClusterRating resource.
         * @summary Retrieves a CareerClusterRating resource.
         * @param {string} id CareerClusterRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerClusterRatingItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCareerClusterRatingItem', 'id', id)
            const localVarPath = `/api/career_cluster_ratings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CareerClusterRatingApi - functional programming interface
 * @export
 */
export const CareerClusterRatingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CareerClusterRatingApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of CareerClusterRating resources.
         * @summary Retrieves the collection of CareerClusterRating resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerClusterRatingCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CareerClusterRatingFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerClusterRatingCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerClusterRatingApi.getCareerClusterRatingCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a CareerClusterRating resource.
         * @summary Retrieves a CareerClusterRating resource.
         * @param {string} id CareerClusterRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerClusterRatingItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerClusterRatingFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerClusterRatingItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerClusterRatingApi.getCareerClusterRatingItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CareerClusterRatingApi - factory interface
 * @export
 */
export const CareerClusterRatingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CareerClusterRatingApiFp(configuration)
    return {
        /**
         * Retrieves the collection of CareerClusterRating resources.
         * @summary Retrieves the collection of CareerClusterRating resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerClusterRatingCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<CareerClusterRatingFullRead>> {
            return localVarFp.getCareerClusterRatingCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a CareerClusterRating resource.
         * @summary Retrieves a CareerClusterRating resource.
         * @param {string} id CareerClusterRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerClusterRatingItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CareerClusterRatingFullRead> {
            return localVarFp.getCareerClusterRatingItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CareerClusterRatingApi - object-oriented interface
 * @export
 * @class CareerClusterRatingApi
 * @extends {BaseAPI}
 */
export class CareerClusterRatingApi extends BaseAPI {
    /**
     * Retrieves the collection of CareerClusterRating resources.
     * @summary Retrieves the collection of CareerClusterRating resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerClusterRatingApi
     */
    public getCareerClusterRatingCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return CareerClusterRatingApiFp(this.configuration).getCareerClusterRatingCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a CareerClusterRating resource.
     * @summary Retrieves a CareerClusterRating resource.
     * @param {string} id CareerClusterRating identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerClusterRatingApi
     */
    public getCareerClusterRatingItem(id: string, options?: RawAxiosRequestConfig) {
        return CareerClusterRatingApiFp(this.configuration).getCareerClusterRatingItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CareerClusterUserRatingApi - axios parameter creator
 * @export
 */
export const CareerClusterUserRatingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the CareerClusterUserRating resource.
         * @summary Removes the CareerClusterUserRating resource.
         * @param {string} id CareerClusterUserRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCareerClusterUserRatingsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCareerClusterUserRatingsIdDelete', 'id', id)
            const localVarPath = `/api/career_cluster_user_ratings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the CareerClusterUserRating resource.
         * @summary Replaces the CareerClusterUserRating resource.
         * @param {string} id CareerClusterUserRating identifier
         * @param {CareerClusterUserRatingMinimumUpdate} careerClusterUserRatingMinimumUpdate The updated CareerClusterUserRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeCareerClusterRatingCareerClusterUserRatingItem: async (id: string, careerClusterUserRatingMinimumUpdate: CareerClusterUserRatingMinimumUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeCareerClusterRatingCareerClusterUserRatingItem', 'id', id)
            // verify required parameter 'careerClusterUserRatingMinimumUpdate' is not null or undefined
            assertParamExists('changeCareerClusterRatingCareerClusterUserRatingItem', 'careerClusterUserRatingMinimumUpdate', careerClusterUserRatingMinimumUpdate)
            const localVarPath = `/api/career_cluster_user_ratings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(careerClusterUserRatingMinimumUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a CareerClusterUserRating resource.
         * @summary Retrieves a CareerClusterUserRating resource.
         * @param {string} id CareerClusterUserRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerClusterUserRatingItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCareerClusterUserRatingItem', 'id', id)
            const localVarPath = `/api/career_cluster_user_ratings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a CareerClusterUserRating resource.
         * @summary Creates a CareerClusterUserRating resource.
         * @param {CareerClusterUserRatingMinimumWrite} careerClusterUserRatingMinimumWrite The new CareerClusterUserRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToCareerClusterRatingCareerClusterUserRatingCollection: async (careerClusterUserRatingMinimumWrite: CareerClusterUserRatingMinimumWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'careerClusterUserRatingMinimumWrite' is not null or undefined
            assertParamExists('respondToCareerClusterRatingCareerClusterUserRatingCollection', 'careerClusterUserRatingMinimumWrite', careerClusterUserRatingMinimumWrite)
            const localVarPath = `/api/career_cluster_user_ratings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(careerClusterUserRatingMinimumWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CareerClusterUserRatingApi - functional programming interface
 * @export
 */
export const CareerClusterUserRatingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CareerClusterUserRatingApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the CareerClusterUserRating resource.
         * @summary Removes the CareerClusterUserRating resource.
         * @param {string} id CareerClusterUserRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCareerClusterUserRatingsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCareerClusterUserRatingsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerClusterUserRatingApi.apiCareerClusterUserRatingsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the CareerClusterUserRating resource.
         * @summary Replaces the CareerClusterUserRating resource.
         * @param {string} id CareerClusterUserRating identifier
         * @param {CareerClusterUserRatingMinimumUpdate} careerClusterUserRatingMinimumUpdate The updated CareerClusterUserRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeCareerClusterRatingCareerClusterUserRatingItem(id: string, careerClusterUserRatingMinimumUpdate: CareerClusterUserRatingMinimumUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerClusterUserRatingFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeCareerClusterRatingCareerClusterUserRatingItem(id, careerClusterUserRatingMinimumUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerClusterUserRatingApi.changeCareerClusterRatingCareerClusterUserRatingItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a CareerClusterUserRating resource.
         * @summary Retrieves a CareerClusterUserRating resource.
         * @param {string} id CareerClusterUserRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerClusterUserRatingItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerClusterUserRatingFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerClusterUserRatingItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerClusterUserRatingApi.getCareerClusterUserRatingItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a CareerClusterUserRating resource.
         * @summary Creates a CareerClusterUserRating resource.
         * @param {CareerClusterUserRatingMinimumWrite} careerClusterUserRatingMinimumWrite The new CareerClusterUserRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondToCareerClusterRatingCareerClusterUserRatingCollection(careerClusterUserRatingMinimumWrite: CareerClusterUserRatingMinimumWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerClusterUserRatingFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.respondToCareerClusterRatingCareerClusterUserRatingCollection(careerClusterUserRatingMinimumWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerClusterUserRatingApi.respondToCareerClusterRatingCareerClusterUserRatingCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CareerClusterUserRatingApi - factory interface
 * @export
 */
export const CareerClusterUserRatingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CareerClusterUserRatingApiFp(configuration)
    return {
        /**
         * Removes the CareerClusterUserRating resource.
         * @summary Removes the CareerClusterUserRating resource.
         * @param {string} id CareerClusterUserRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCareerClusterUserRatingsIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCareerClusterUserRatingsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the CareerClusterUserRating resource.
         * @summary Replaces the CareerClusterUserRating resource.
         * @param {string} id CareerClusterUserRating identifier
         * @param {CareerClusterUserRatingMinimumUpdate} careerClusterUserRatingMinimumUpdate The updated CareerClusterUserRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeCareerClusterRatingCareerClusterUserRatingItem(id: string, careerClusterUserRatingMinimumUpdate: CareerClusterUserRatingMinimumUpdate, options?: RawAxiosRequestConfig): AxiosPromise<CareerClusterUserRatingFullRead> {
            return localVarFp.changeCareerClusterRatingCareerClusterUserRatingItem(id, careerClusterUserRatingMinimumUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a CareerClusterUserRating resource.
         * @summary Retrieves a CareerClusterUserRating resource.
         * @param {string} id CareerClusterUserRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerClusterUserRatingItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CareerClusterUserRatingFullRead> {
            return localVarFp.getCareerClusterUserRatingItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a CareerClusterUserRating resource.
         * @summary Creates a CareerClusterUserRating resource.
         * @param {CareerClusterUserRatingMinimumWrite} careerClusterUserRatingMinimumWrite The new CareerClusterUserRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToCareerClusterRatingCareerClusterUserRatingCollection(careerClusterUserRatingMinimumWrite: CareerClusterUserRatingMinimumWrite, options?: RawAxiosRequestConfig): AxiosPromise<CareerClusterUserRatingFullRead> {
            return localVarFp.respondToCareerClusterRatingCareerClusterUserRatingCollection(careerClusterUserRatingMinimumWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CareerClusterUserRatingApi - object-oriented interface
 * @export
 * @class CareerClusterUserRatingApi
 * @extends {BaseAPI}
 */
export class CareerClusterUserRatingApi extends BaseAPI {
    /**
     * Removes the CareerClusterUserRating resource.
     * @summary Removes the CareerClusterUserRating resource.
     * @param {string} id CareerClusterUserRating identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerClusterUserRatingApi
     */
    public apiCareerClusterUserRatingsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return CareerClusterUserRatingApiFp(this.configuration).apiCareerClusterUserRatingsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the CareerClusterUserRating resource.
     * @summary Replaces the CareerClusterUserRating resource.
     * @param {string} id CareerClusterUserRating identifier
     * @param {CareerClusterUserRatingMinimumUpdate} careerClusterUserRatingMinimumUpdate The updated CareerClusterUserRating resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerClusterUserRatingApi
     */
    public changeCareerClusterRatingCareerClusterUserRatingItem(id: string, careerClusterUserRatingMinimumUpdate: CareerClusterUserRatingMinimumUpdate, options?: RawAxiosRequestConfig) {
        return CareerClusterUserRatingApiFp(this.configuration).changeCareerClusterRatingCareerClusterUserRatingItem(id, careerClusterUserRatingMinimumUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a CareerClusterUserRating resource.
     * @summary Retrieves a CareerClusterUserRating resource.
     * @param {string} id CareerClusterUserRating identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerClusterUserRatingApi
     */
    public getCareerClusterUserRatingItem(id: string, options?: RawAxiosRequestConfig) {
        return CareerClusterUserRatingApiFp(this.configuration).getCareerClusterUserRatingItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a CareerClusterUserRating resource.
     * @summary Creates a CareerClusterUserRating resource.
     * @param {CareerClusterUserRatingMinimumWrite} careerClusterUserRatingMinimumWrite The new CareerClusterUserRating resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerClusterUserRatingApi
     */
    public respondToCareerClusterRatingCareerClusterUserRatingCollection(careerClusterUserRatingMinimumWrite: CareerClusterUserRatingMinimumWrite, options?: RawAxiosRequestConfig) {
        return CareerClusterUserRatingApiFp(this.configuration).respondToCareerClusterRatingCareerClusterUserRatingCollection(careerClusterUserRatingMinimumWrite, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CareerFacetApi - axios parameter creator
 * @export
 */
export const CareerFacetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a CareerFacet resource.
         * @summary Retrieves a CareerFacet resource.
         * @param {string} id CareerFacet identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCareerFacetsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCareerFacetsIdGet', 'id', id)
            const localVarPath = `/api/career_facets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CareerFacetApi - functional programming interface
 * @export
 */
export const CareerFacetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CareerFacetApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a CareerFacet resource.
         * @summary Retrieves a CareerFacet resource.
         * @param {string} id CareerFacet identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCareerFacetsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerFacetFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCareerFacetsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerFacetApi.apiCareerFacetsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CareerFacetApi - factory interface
 * @export
 */
export const CareerFacetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CareerFacetApiFp(configuration)
    return {
        /**
         * Retrieves a CareerFacet resource.
         * @summary Retrieves a CareerFacet resource.
         * @param {string} id CareerFacet identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCareerFacetsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CareerFacetFullRead> {
            return localVarFp.apiCareerFacetsIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CareerFacetApi - object-oriented interface
 * @export
 * @class CareerFacetApi
 * @extends {BaseAPI}
 */
export class CareerFacetApi extends BaseAPI {
    /**
     * Retrieves a CareerFacet resource.
     * @summary Retrieves a CareerFacet resource.
     * @param {string} id CareerFacet identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerFacetApi
     */
    public apiCareerFacetsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return CareerFacetApiFp(this.configuration).apiCareerFacetsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CareerIntelligencesBaselineApi - axios parameter creator
 * @export
 */
export const CareerIntelligencesBaselineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of CareerIntelligencesBaseline resources.
         * @summary Retrieves the collection of CareerIntelligencesBaseline resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerIntelligencesBaselineCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/career_intelligences_baselines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a CareerIntelligencesBaseline resource.
         * @summary Retrieves a CareerIntelligencesBaseline resource.
         * @param {string} id CareerIntelligencesBaseline identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerIntelligencesBaselineItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCareerIntelligencesBaselineItem', 'id', id)
            const localVarPath = `/api/career_intelligences_baselines/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CareerIntelligencesBaselineApi - functional programming interface
 * @export
 */
export const CareerIntelligencesBaselineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CareerIntelligencesBaselineApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of CareerIntelligencesBaseline resources.
         * @summary Retrieves the collection of CareerIntelligencesBaseline resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerIntelligencesBaselineCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CareerIntelligencesBaselineFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerIntelligencesBaselineCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerIntelligencesBaselineApi.getCareerIntelligencesBaselineCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a CareerIntelligencesBaseline resource.
         * @summary Retrieves a CareerIntelligencesBaseline resource.
         * @param {string} id CareerIntelligencesBaseline identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerIntelligencesBaselineItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerIntelligencesBaselineFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerIntelligencesBaselineItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerIntelligencesBaselineApi.getCareerIntelligencesBaselineItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CareerIntelligencesBaselineApi - factory interface
 * @export
 */
export const CareerIntelligencesBaselineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CareerIntelligencesBaselineApiFp(configuration)
    return {
        /**
         * Retrieves the collection of CareerIntelligencesBaseline resources.
         * @summary Retrieves the collection of CareerIntelligencesBaseline resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerIntelligencesBaselineCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<CareerIntelligencesBaselineFullRead>> {
            return localVarFp.getCareerIntelligencesBaselineCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a CareerIntelligencesBaseline resource.
         * @summary Retrieves a CareerIntelligencesBaseline resource.
         * @param {string} id CareerIntelligencesBaseline identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerIntelligencesBaselineItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CareerIntelligencesBaselineFullRead> {
            return localVarFp.getCareerIntelligencesBaselineItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CareerIntelligencesBaselineApi - object-oriented interface
 * @export
 * @class CareerIntelligencesBaselineApi
 * @extends {BaseAPI}
 */
export class CareerIntelligencesBaselineApi extends BaseAPI {
    /**
     * Retrieves the collection of CareerIntelligencesBaseline resources.
     * @summary Retrieves the collection of CareerIntelligencesBaseline resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerIntelligencesBaselineApi
     */
    public getCareerIntelligencesBaselineCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return CareerIntelligencesBaselineApiFp(this.configuration).getCareerIntelligencesBaselineCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a CareerIntelligencesBaseline resource.
     * @summary Retrieves a CareerIntelligencesBaseline resource.
     * @param {string} id CareerIntelligencesBaseline identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerIntelligencesBaselineApi
     */
    public getCareerIntelligencesBaselineItem(id: string, options?: RawAxiosRequestConfig) {
        return CareerIntelligencesBaselineApiFp(this.configuration).getCareerIntelligencesBaselineItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CareerProgramApi - axios parameter creator
 * @export
 */
export const CareerProgramApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of CareerProgram resources.
         * @summary Retrieves the collection of CareerProgram resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerProgramCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/career_programs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a CareerProgram resource.
         * @summary Retrieves a CareerProgram resource.
         * @param {string} id CareerProgram identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerProgramItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCareerProgramItem', 'id', id)
            const localVarPath = `/api/career_programs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CareerProgramApi - functional programming interface
 * @export
 */
export const CareerProgramApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CareerProgramApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of CareerProgram resources.
         * @summary Retrieves the collection of CareerProgram resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerProgramCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CareerProgramFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerProgramCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerProgramApi.getCareerProgramCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a CareerProgram resource.
         * @summary Retrieves a CareerProgram resource.
         * @param {string} id CareerProgram identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerProgramItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerProgramFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerProgramItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerProgramApi.getCareerProgramItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CareerProgramApi - factory interface
 * @export
 */
export const CareerProgramApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CareerProgramApiFp(configuration)
    return {
        /**
         * Retrieves the collection of CareerProgram resources.
         * @summary Retrieves the collection of CareerProgram resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerProgramCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<CareerProgramFullRead>> {
            return localVarFp.getCareerProgramCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a CareerProgram resource.
         * @summary Retrieves a CareerProgram resource.
         * @param {string} id CareerProgram identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerProgramItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CareerProgramFullRead> {
            return localVarFp.getCareerProgramItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CareerProgramApi - object-oriented interface
 * @export
 * @class CareerProgramApi
 * @extends {BaseAPI}
 */
export class CareerProgramApi extends BaseAPI {
    /**
     * Retrieves the collection of CareerProgram resources.
     * @summary Retrieves the collection of CareerProgram resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerProgramApi
     */
    public getCareerProgramCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return CareerProgramApiFp(this.configuration).getCareerProgramCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a CareerProgram resource.
     * @summary Retrieves a CareerProgram resource.
     * @param {string} id CareerProgram identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerProgramApi
     */
    public getCareerProgramItem(id: string, options?: RawAxiosRequestConfig) {
        return CareerProgramApiFp(this.configuration).getCareerProgramItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CareerProgramMatchApi - axios parameter creator
 * @export
 */
export const CareerProgramMatchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of CareerProgramMatch resources.
         * @summary Retrieves the collection of CareerProgramMatch resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerProgramMatchCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/career_program_matches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a CareerProgramMatch resource.
         * @summary Retrieves a CareerProgramMatch resource.
         * @param {string} id CareerProgramMatch identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerProgramMatchItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCareerProgramMatchItem', 'id', id)
            const localVarPath = `/api/career_program_matches/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CareerProgramMatchApi - functional programming interface
 * @export
 */
export const CareerProgramMatchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CareerProgramMatchApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of CareerProgramMatch resources.
         * @summary Retrieves the collection of CareerProgramMatch resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerProgramMatchCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CareerProgramMatchFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerProgramMatchCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerProgramMatchApi.getCareerProgramMatchCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a CareerProgramMatch resource.
         * @summary Retrieves a CareerProgramMatch resource.
         * @param {string} id CareerProgramMatch identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerProgramMatchItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerProgramMatchFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerProgramMatchItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerProgramMatchApi.getCareerProgramMatchItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CareerProgramMatchApi - factory interface
 * @export
 */
export const CareerProgramMatchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CareerProgramMatchApiFp(configuration)
    return {
        /**
         * Retrieves the collection of CareerProgramMatch resources.
         * @summary Retrieves the collection of CareerProgramMatch resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerProgramMatchCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<CareerProgramMatchFullRead>> {
            return localVarFp.getCareerProgramMatchCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a CareerProgramMatch resource.
         * @summary Retrieves a CareerProgramMatch resource.
         * @param {string} id CareerProgramMatch identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerProgramMatchItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CareerProgramMatchFullRead> {
            return localVarFp.getCareerProgramMatchItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CareerProgramMatchApi - object-oriented interface
 * @export
 * @class CareerProgramMatchApi
 * @extends {BaseAPI}
 */
export class CareerProgramMatchApi extends BaseAPI {
    /**
     * Retrieves the collection of CareerProgramMatch resources.
     * @summary Retrieves the collection of CareerProgramMatch resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerProgramMatchApi
     */
    public getCareerProgramMatchCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return CareerProgramMatchApiFp(this.configuration).getCareerProgramMatchCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a CareerProgramMatch resource.
     * @summary Retrieves a CareerProgramMatch resource.
     * @param {string} id CareerProgramMatch identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerProgramMatchApi
     */
    public getCareerProgramMatchItem(id: string, options?: RawAxiosRequestConfig) {
        return CareerProgramMatchApiFp(this.configuration).getCareerProgramMatchItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CareerRangeApi - axios parameter creator
 * @export
 */
export const CareerRangeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of CareerRange resources.
         * @summary Retrieves the collection of CareerRange resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerRangeCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/career_ranges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a CareerRange resource.
         * @summary Retrieves a CareerRange resource.
         * @param {string} id CareerRange identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerRangeItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCareerRangeItem', 'id', id)
            const localVarPath = `/api/career_ranges/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CareerRangeApi - functional programming interface
 * @export
 */
export const CareerRangeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CareerRangeApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of CareerRange resources.
         * @summary Retrieves the collection of CareerRange resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerRangeCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CareerRangeMinimumRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerRangeCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerRangeApi.getCareerRangeCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a CareerRange resource.
         * @summary Retrieves a CareerRange resource.
         * @param {string} id CareerRange identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerRangeItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerRangeMinimumRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerRangeItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerRangeApi.getCareerRangeItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CareerRangeApi - factory interface
 * @export
 */
export const CareerRangeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CareerRangeApiFp(configuration)
    return {
        /**
         * Retrieves the collection of CareerRange resources.
         * @summary Retrieves the collection of CareerRange resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerRangeCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<CareerRangeMinimumRead>> {
            return localVarFp.getCareerRangeCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a CareerRange resource.
         * @summary Retrieves a CareerRange resource.
         * @param {string} id CareerRange identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerRangeItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CareerRangeMinimumRead> {
            return localVarFp.getCareerRangeItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CareerRangeApi - object-oriented interface
 * @export
 * @class CareerRangeApi
 * @extends {BaseAPI}
 */
export class CareerRangeApi extends BaseAPI {
    /**
     * Retrieves the collection of CareerRange resources.
     * @summary Retrieves the collection of CareerRange resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerRangeApi
     */
    public getCareerRangeCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return CareerRangeApiFp(this.configuration).getCareerRangeCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a CareerRange resource.
     * @summary Retrieves a CareerRange resource.
     * @param {string} id CareerRange identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerRangeApi
     */
    public getCareerRangeItem(id: string, options?: RawAxiosRequestConfig) {
        return CareerRangeApiFp(this.configuration).getCareerRangeItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CareerRatingApi - axios parameter creator
 * @export
 */
export const CareerRatingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of CareerRating resources.
         * @summary Retrieves the collection of CareerRating resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerRatingCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/career_ratings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a CareerRating resource.
         * @summary Retrieves a CareerRating resource.
         * @param {string} id CareerRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerRatingItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCareerRatingItem', 'id', id)
            const localVarPath = `/api/career_ratings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CareerRatingApi - functional programming interface
 * @export
 */
export const CareerRatingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CareerRatingApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of CareerRating resources.
         * @summary Retrieves the collection of CareerRating resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerRatingCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CareerRatingFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerRatingCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerRatingApi.getCareerRatingCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a CareerRating resource.
         * @summary Retrieves a CareerRating resource.
         * @param {string} id CareerRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerRatingItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerRatingFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerRatingItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerRatingApi.getCareerRatingItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CareerRatingApi - factory interface
 * @export
 */
export const CareerRatingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CareerRatingApiFp(configuration)
    return {
        /**
         * Retrieves the collection of CareerRating resources.
         * @summary Retrieves the collection of CareerRating resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerRatingCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<CareerRatingFullRead>> {
            return localVarFp.getCareerRatingCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a CareerRating resource.
         * @summary Retrieves a CareerRating resource.
         * @param {string} id CareerRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerRatingItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CareerRatingFullRead> {
            return localVarFp.getCareerRatingItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CareerRatingApi - object-oriented interface
 * @export
 * @class CareerRatingApi
 * @extends {BaseAPI}
 */
export class CareerRatingApi extends BaseAPI {
    /**
     * Retrieves the collection of CareerRating resources.
     * @summary Retrieves the collection of CareerRating resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerRatingApi
     */
    public getCareerRatingCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return CareerRatingApiFp(this.configuration).getCareerRatingCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a CareerRating resource.
     * @summary Retrieves a CareerRating resource.
     * @param {string} id CareerRating identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerRatingApi
     */
    public getCareerRatingItem(id: string, options?: RawAxiosRequestConfig) {
        return CareerRatingApiFp(this.configuration).getCareerRatingItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CareerSkillsBaselineApi - axios parameter creator
 * @export
 */
export const CareerSkillsBaselineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of CareerSkillsBaseline resources.
         * @summary Retrieves the collection of CareerSkillsBaseline resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerSkillsBaselineCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/career_skills_baselines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a CareerSkillsBaseline resource.
         * @summary Retrieves a CareerSkillsBaseline resource.
         * @param {string} id CareerSkillsBaseline identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerSkillsBaselineItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCareerSkillsBaselineItem', 'id', id)
            const localVarPath = `/api/career_skills_baselines/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CareerSkillsBaselineApi - functional programming interface
 * @export
 */
export const CareerSkillsBaselineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CareerSkillsBaselineApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of CareerSkillsBaseline resources.
         * @summary Retrieves the collection of CareerSkillsBaseline resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerSkillsBaselineCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CareerSkillsBaselineFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerSkillsBaselineCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerSkillsBaselineApi.getCareerSkillsBaselineCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a CareerSkillsBaseline resource.
         * @summary Retrieves a CareerSkillsBaseline resource.
         * @param {string} id CareerSkillsBaseline identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerSkillsBaselineItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerSkillsBaselineFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerSkillsBaselineItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerSkillsBaselineApi.getCareerSkillsBaselineItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CareerSkillsBaselineApi - factory interface
 * @export
 */
export const CareerSkillsBaselineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CareerSkillsBaselineApiFp(configuration)
    return {
        /**
         * Retrieves the collection of CareerSkillsBaseline resources.
         * @summary Retrieves the collection of CareerSkillsBaseline resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerSkillsBaselineCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<CareerSkillsBaselineFullRead>> {
            return localVarFp.getCareerSkillsBaselineCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a CareerSkillsBaseline resource.
         * @summary Retrieves a CareerSkillsBaseline resource.
         * @param {string} id CareerSkillsBaseline identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerSkillsBaselineItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CareerSkillsBaselineFullRead> {
            return localVarFp.getCareerSkillsBaselineItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CareerSkillsBaselineApi - object-oriented interface
 * @export
 * @class CareerSkillsBaselineApi
 * @extends {BaseAPI}
 */
export class CareerSkillsBaselineApi extends BaseAPI {
    /**
     * Retrieves the collection of CareerSkillsBaseline resources.
     * @summary Retrieves the collection of CareerSkillsBaseline resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerSkillsBaselineApi
     */
    public getCareerSkillsBaselineCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return CareerSkillsBaselineApiFp(this.configuration).getCareerSkillsBaselineCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a CareerSkillsBaseline resource.
     * @summary Retrieves a CareerSkillsBaseline resource.
     * @param {string} id CareerSkillsBaseline identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerSkillsBaselineApi
     */
    public getCareerSkillsBaselineItem(id: string, options?: RawAxiosRequestConfig) {
        return CareerSkillsBaselineApiFp(this.configuration).getCareerSkillsBaselineItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CareerUserRatingApi - axios parameter creator
 * @export
 */
export const CareerUserRatingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Replaces the CareerUserRating resource.
         * @summary Replaces the CareerUserRating resource.
         * @param {string} id CareerUserRating identifier
         * @param {CareerUserRatingMinimumWrite} careerUserRatingMinimumWrite The updated CareerUserRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeCareerUserRatingCareerUserRatingItem: async (id: string, careerUserRatingMinimumWrite: CareerUserRatingMinimumWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeCareerUserRatingCareerUserRatingItem', 'id', id)
            // verify required parameter 'careerUserRatingMinimumWrite' is not null or undefined
            assertParamExists('changeCareerUserRatingCareerUserRatingItem', 'careerUserRatingMinimumWrite', careerUserRatingMinimumWrite)
            const localVarPath = `/api/career_user_ratings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(careerUserRatingMinimumWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the CareerUserRating resource.
         * @summary Removes the CareerUserRating resource.
         * @param {string} id CareerUserRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCareerUserRatingItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCareerUserRatingItem', 'id', id)
            const localVarPath = `/api/career_user_ratings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of CareerUserRating resources.
         * @summary Retrieves the collection of CareerUserRating resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerUserRatingCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/career_user_ratings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a CareerUserRating resource.
         * @summary Retrieves a CareerUserRating resource.
         * @param {string} id CareerUserRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerUserRatingItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCareerUserRatingItem', 'id', id)
            const localVarPath = `/api/career_user_ratings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a CareerUserRating resource.
         * @summary Creates a CareerUserRating resource.
         * @param {CareerUserRatingMinimumWrite} careerUserRatingMinimumWrite The new CareerUserRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToCareerUserRatingCareerUserRatingCollection: async (careerUserRatingMinimumWrite: CareerUserRatingMinimumWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'careerUserRatingMinimumWrite' is not null or undefined
            assertParamExists('respondToCareerUserRatingCareerUserRatingCollection', 'careerUserRatingMinimumWrite', careerUserRatingMinimumWrite)
            const localVarPath = `/api/career_user_ratings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(careerUserRatingMinimumWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CareerUserRatingApi - functional programming interface
 * @export
 */
export const CareerUserRatingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CareerUserRatingApiAxiosParamCreator(configuration)
    return {
        /**
         * Replaces the CareerUserRating resource.
         * @summary Replaces the CareerUserRating resource.
         * @param {string} id CareerUserRating identifier
         * @param {CareerUserRatingMinimumWrite} careerUserRatingMinimumWrite The updated CareerUserRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeCareerUserRatingCareerUserRatingItem(id: string, careerUserRatingMinimumWrite: CareerUserRatingMinimumWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerUserRatingFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeCareerUserRatingCareerUserRatingItem(id, careerUserRatingMinimumWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerUserRatingApi.changeCareerUserRatingCareerUserRatingItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes the CareerUserRating resource.
         * @summary Removes the CareerUserRating resource.
         * @param {string} id CareerUserRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCareerUserRatingItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCareerUserRatingItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerUserRatingApi.deleteCareerUserRatingItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of CareerUserRating resources.
         * @summary Retrieves the collection of CareerUserRating resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerUserRatingCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CareerUserRatingFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerUserRatingCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerUserRatingApi.getCareerUserRatingCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a CareerUserRating resource.
         * @summary Retrieves a CareerUserRating resource.
         * @param {string} id CareerUserRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerUserRatingItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerUserRatingFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerUserRatingItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerUserRatingApi.getCareerUserRatingItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a CareerUserRating resource.
         * @summary Creates a CareerUserRating resource.
         * @param {CareerUserRatingMinimumWrite} careerUserRatingMinimumWrite The new CareerUserRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondToCareerUserRatingCareerUserRatingCollection(careerUserRatingMinimumWrite: CareerUserRatingMinimumWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerUserRatingFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.respondToCareerUserRatingCareerUserRatingCollection(careerUserRatingMinimumWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerUserRatingApi.respondToCareerUserRatingCareerUserRatingCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CareerUserRatingApi - factory interface
 * @export
 */
export const CareerUserRatingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CareerUserRatingApiFp(configuration)
    return {
        /**
         * Replaces the CareerUserRating resource.
         * @summary Replaces the CareerUserRating resource.
         * @param {string} id CareerUserRating identifier
         * @param {CareerUserRatingMinimumWrite} careerUserRatingMinimumWrite The updated CareerUserRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeCareerUserRatingCareerUserRatingItem(id: string, careerUserRatingMinimumWrite: CareerUserRatingMinimumWrite, options?: RawAxiosRequestConfig): AxiosPromise<CareerUserRatingFullRead> {
            return localVarFp.changeCareerUserRatingCareerUserRatingItem(id, careerUserRatingMinimumWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the CareerUserRating resource.
         * @summary Removes the CareerUserRating resource.
         * @param {string} id CareerUserRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCareerUserRatingItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCareerUserRatingItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of CareerUserRating resources.
         * @summary Retrieves the collection of CareerUserRating resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerUserRatingCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<CareerUserRatingFullRead>> {
            return localVarFp.getCareerUserRatingCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a CareerUserRating resource.
         * @summary Retrieves a CareerUserRating resource.
         * @param {string} id CareerUserRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerUserRatingItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CareerUserRatingFullRead> {
            return localVarFp.getCareerUserRatingItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a CareerUserRating resource.
         * @summary Creates a CareerUserRating resource.
         * @param {CareerUserRatingMinimumWrite} careerUserRatingMinimumWrite The new CareerUserRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToCareerUserRatingCareerUserRatingCollection(careerUserRatingMinimumWrite: CareerUserRatingMinimumWrite, options?: RawAxiosRequestConfig): AxiosPromise<CareerUserRatingFullRead> {
            return localVarFp.respondToCareerUserRatingCareerUserRatingCollection(careerUserRatingMinimumWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CareerUserRatingApi - object-oriented interface
 * @export
 * @class CareerUserRatingApi
 * @extends {BaseAPI}
 */
export class CareerUserRatingApi extends BaseAPI {
    /**
     * Replaces the CareerUserRating resource.
     * @summary Replaces the CareerUserRating resource.
     * @param {string} id CareerUserRating identifier
     * @param {CareerUserRatingMinimumWrite} careerUserRatingMinimumWrite The updated CareerUserRating resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerUserRatingApi
     */
    public changeCareerUserRatingCareerUserRatingItem(id: string, careerUserRatingMinimumWrite: CareerUserRatingMinimumWrite, options?: RawAxiosRequestConfig) {
        return CareerUserRatingApiFp(this.configuration).changeCareerUserRatingCareerUserRatingItem(id, careerUserRatingMinimumWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes the CareerUserRating resource.
     * @summary Removes the CareerUserRating resource.
     * @param {string} id CareerUserRating identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerUserRatingApi
     */
    public deleteCareerUserRatingItem(id: string, options?: RawAxiosRequestConfig) {
        return CareerUserRatingApiFp(this.configuration).deleteCareerUserRatingItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of CareerUserRating resources.
     * @summary Retrieves the collection of CareerUserRating resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerUserRatingApi
     */
    public getCareerUserRatingCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return CareerUserRatingApiFp(this.configuration).getCareerUserRatingCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a CareerUserRating resource.
     * @summary Retrieves a CareerUserRating resource.
     * @param {string} id CareerUserRating identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerUserRatingApi
     */
    public getCareerUserRatingItem(id: string, options?: RawAxiosRequestConfig) {
        return CareerUserRatingApiFp(this.configuration).getCareerUserRatingItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a CareerUserRating resource.
     * @summary Creates a CareerUserRating resource.
     * @param {CareerUserRatingMinimumWrite} careerUserRatingMinimumWrite The new CareerUserRating resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerUserRatingApi
     */
    public respondToCareerUserRatingCareerUserRatingCollection(careerUserRatingMinimumWrite: CareerUserRatingMinimumWrite, options?: RawAxiosRequestConfig) {
        return CareerUserRatingApiFp(this.configuration).respondToCareerUserRatingCareerUserRatingCollection(careerUserRatingMinimumWrite, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CareerWageApi - axios parameter creator
 * @export
 */
export const CareerWageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of CareerWage resources.
         * @summary Retrieves the collection of CareerWage resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {string} [career] 
         * @param {Array<string>} [career2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerWageCollection: async (page?: number, pagination?: boolean, career?: string, career2?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/career_wages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }

            if (career !== undefined) {
                localVarQueryParameter['career'] = career;
            }

            if (career2) {
                localVarQueryParameter['career[]'] = career2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a CareerWage resource.
         * @summary Retrieves a CareerWage resource.
         * @param {string} id CareerWage identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerWageItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCareerWageItem', 'id', id)
            const localVarPath = `/api/career_wages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CareerWageApi - functional programming interface
 * @export
 */
export const CareerWageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CareerWageApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of CareerWage resources.
         * @summary Retrieves the collection of CareerWage resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {string} [career] 
         * @param {Array<string>} [career2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerWageCollection(page?: number, pagination?: boolean, career?: string, career2?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CareerWageFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerWageCollection(page, pagination, career, career2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerWageApi.getCareerWageCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a CareerWage resource.
         * @summary Retrieves a CareerWage resource.
         * @param {string} id CareerWage identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerWageItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerWageFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerWageItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CareerWageApi.getCareerWageItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CareerWageApi - factory interface
 * @export
 */
export const CareerWageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CareerWageApiFp(configuration)
    return {
        /**
         * Retrieves the collection of CareerWage resources.
         * @summary Retrieves the collection of CareerWage resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {string} [career] 
         * @param {Array<string>} [career2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerWageCollection(page?: number, pagination?: boolean, career?: string, career2?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<CareerWageFullRead>> {
            return localVarFp.getCareerWageCollection(page, pagination, career, career2, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a CareerWage resource.
         * @summary Retrieves a CareerWage resource.
         * @param {string} id CareerWage identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerWageItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CareerWageFullRead> {
            return localVarFp.getCareerWageItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CareerWageApi - object-oriented interface
 * @export
 * @class CareerWageApi
 * @extends {BaseAPI}
 */
export class CareerWageApi extends BaseAPI {
    /**
     * Retrieves the collection of CareerWage resources.
     * @summary Retrieves the collection of CareerWage resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {string} [career] 
     * @param {Array<string>} [career2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerWageApi
     */
    public getCareerWageCollection(page?: number, pagination?: boolean, career?: string, career2?: Array<string>, options?: RawAxiosRequestConfig) {
        return CareerWageApiFp(this.configuration).getCareerWageCollection(page, pagination, career, career2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a CareerWage resource.
     * @summary Retrieves a CareerWage resource.
     * @param {string} id CareerWage identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerWageApi
     */
    public getCareerWageItem(id: string, options?: RawAxiosRequestConfig) {
        return CareerWageApiFp(this.configuration).getCareerWageItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContentBlockApi - axios parameter creator
 * @export
 */
export const ContentBlockApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a ContentBlock resource.
         * @summary Retrieves a ContentBlock resource.
         * @param {string} id ContentBlock identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentBlockItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getContentBlockItem', 'id', id)
            const localVarPath = `/api/content_blocks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentBlockApi - functional programming interface
 * @export
 */
export const ContentBlockApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContentBlockApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a ContentBlock resource.
         * @summary Retrieves a ContentBlock resource.
         * @param {string} id ContentBlock identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContentBlockItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentBlockFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContentBlockItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentBlockApi.getContentBlockItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContentBlockApi - factory interface
 * @export
 */
export const ContentBlockApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContentBlockApiFp(configuration)
    return {
        /**
         * Retrieves a ContentBlock resource.
         * @summary Retrieves a ContentBlock resource.
         * @param {string} id ContentBlock identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentBlockItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ContentBlockFullRead> {
            return localVarFp.getContentBlockItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContentBlockApi - object-oriented interface
 * @export
 * @class ContentBlockApi
 * @extends {BaseAPI}
 */
export class ContentBlockApi extends BaseAPI {
    /**
     * Retrieves a ContentBlock resource.
     * @summary Retrieves a ContentBlock resource.
     * @param {string} id ContentBlock identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentBlockApi
     */
    public getContentBlockItem(id: string, options?: RawAxiosRequestConfig) {
        return ContentBlockApiFp(this.configuration).getContentBlockItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ImageApi - axios parameter creator
 * @export
 */
export const ImageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a Image resource.
         * @summary Retrieves a Image resource.
         * @param {string} id Image identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getImageItem', 'id', id)
            const localVarPath = `/api/images/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImageApi - functional programming interface
 * @export
 */
export const ImageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImageApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a Image resource.
         * @summary Retrieves a Image resource.
         * @param {string} id Image identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImageApi.getImageItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ImageApi - factory interface
 * @export
 */
export const ImageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImageApiFp(configuration)
    return {
        /**
         * Retrieves a Image resource.
         * @summary Retrieves a Image resource.
         * @param {string} id Image identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ImageFullRead> {
            return localVarFp.getImageItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImageApi - object-oriented interface
 * @export
 * @class ImageApi
 * @extends {BaseAPI}
 */
export class ImageApi extends BaseAPI {
    /**
     * Retrieves a Image resource.
     * @summary Retrieves a Image resource.
     * @param {string} id Image identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageApi
     */
    public getImageItem(id: string, options?: RawAxiosRequestConfig) {
        return ImageApiFp(this.configuration).getImageItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InstitutionApi - axios parameter creator
 * @export
 */
export const InstitutionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of Institution resources.
         * @summary Retrieves the collection of Institution resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstitutionCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/institutions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Institution resource.
         * @summary Retrieves a Institution resource.
         * @param {string} id Institution identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstitutionItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInstitutionItem', 'id', id)
            const localVarPath = `/api/institutions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InstitutionApi - functional programming interface
 * @export
 */
export const InstitutionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InstitutionApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of Institution resources.
         * @summary Retrieves the collection of Institution resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstitutionCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InstitutionFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstitutionCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstitutionApi.getInstitutionCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a Institution resource.
         * @summary Retrieves a Institution resource.
         * @param {string} id Institution identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstitutionItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstitutionFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstitutionItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstitutionApi.getInstitutionItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InstitutionApi - factory interface
 * @export
 */
export const InstitutionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InstitutionApiFp(configuration)
    return {
        /**
         * Retrieves the collection of Institution resources.
         * @summary Retrieves the collection of Institution resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstitutionCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<InstitutionFullRead>> {
            return localVarFp.getInstitutionCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Institution resource.
         * @summary Retrieves a Institution resource.
         * @param {string} id Institution identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstitutionItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<InstitutionFullRead> {
            return localVarFp.getInstitutionItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InstitutionApi - object-oriented interface
 * @export
 * @class InstitutionApi
 * @extends {BaseAPI}
 */
export class InstitutionApi extends BaseAPI {
    /**
     * Retrieves the collection of Institution resources.
     * @summary Retrieves the collection of Institution resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstitutionApi
     */
    public getInstitutionCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return InstitutionApiFp(this.configuration).getInstitutionCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Institution resource.
     * @summary Retrieves a Institution resource.
     * @param {string} id Institution identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstitutionApi
     */
    public getInstitutionItem(id: string, options?: RawAxiosRequestConfig) {
        return InstitutionApiFp(this.configuration).getInstitutionItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InstructionApi - axios parameter creator
 * @export
 */
export const InstructionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a Instruction resource.
         * @summary Retrieves a Instruction resource.
         * @param {string} id Instruction identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstructionItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInstructionItem', 'id', id)
            const localVarPath = `/api/instructions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InstructionApi - functional programming interface
 * @export
 */
export const InstructionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InstructionApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a Instruction resource.
         * @summary Retrieves a Instruction resource.
         * @param {string} id Instruction identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstructionItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstructionItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstructionApi.getInstructionItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InstructionApi - factory interface
 * @export
 */
export const InstructionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InstructionApiFp(configuration)
    return {
        /**
         * Retrieves a Instruction resource.
         * @summary Retrieves a Instruction resource.
         * @param {string} id Instruction identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstructionItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<InstructionFullRead> {
            return localVarFp.getInstructionItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InstructionApi - object-oriented interface
 * @export
 * @class InstructionApi
 * @extends {BaseAPI}
 */
export class InstructionApi extends BaseAPI {
    /**
     * Retrieves a Instruction resource.
     * @summary Retrieves a Instruction resource.
     * @param {string} id Instruction identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstructionApi
     */
    public getInstructionItem(id: string, options?: RawAxiosRequestConfig) {
        return InstructionApiFp(this.configuration).getInstructionItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IntroductionPageApi - axios parameter creator
 * @export
 */
export const IntroductionPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a IntroductionPage resource.
         * @summary Retrieves a IntroductionPage resource.
         * @param {string} id IntroductionPage identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntroductionPageItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getIntroductionPageItem', 'id', id)
            const localVarPath = `/api/introduction_pages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntroductionPageApi - functional programming interface
 * @export
 */
export const IntroductionPageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntroductionPageApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a IntroductionPage resource.
         * @summary Retrieves a IntroductionPage resource.
         * @param {string} id IntroductionPage identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIntroductionPageItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntroductionPageFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIntroductionPageItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntroductionPageApi.getIntroductionPageItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IntroductionPageApi - factory interface
 * @export
 */
export const IntroductionPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntroductionPageApiFp(configuration)
    return {
        /**
         * Retrieves a IntroductionPage resource.
         * @summary Retrieves a IntroductionPage resource.
         * @param {string} id IntroductionPage identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntroductionPageItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<IntroductionPageFullRead> {
            return localVarFp.getIntroductionPageItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntroductionPageApi - object-oriented interface
 * @export
 * @class IntroductionPageApi
 * @extends {BaseAPI}
 */
export class IntroductionPageApi extends BaseAPI {
    /**
     * Retrieves a IntroductionPage resource.
     * @summary Retrieves a IntroductionPage resource.
     * @param {string} id IntroductionPage identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionPageApi
     */
    public getIntroductionPageItem(id: string, options?: RawAxiosRequestConfig) {
        return IntroductionPageApiFp(this.configuration).getIntroductionPageItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IntroductionQuestionContentBlockApi - axios parameter creator
 * @export
 */
export const IntroductionQuestionContentBlockApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a IntroductionQuestionContentBlock resource.
         * @summary Retrieves a IntroductionQuestionContentBlock resource.
         * @param {string} id IntroductionQuestionContentBlock identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntroductionQuestionContentBlockItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getIntroductionQuestionContentBlockItem', 'id', id)
            const localVarPath = `/api/introduction_question_content_blocks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntroductionQuestionContentBlockApi - functional programming interface
 * @export
 */
export const IntroductionQuestionContentBlockApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntroductionQuestionContentBlockApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a IntroductionQuestionContentBlock resource.
         * @summary Retrieves a IntroductionQuestionContentBlock resource.
         * @param {string} id IntroductionQuestionContentBlock identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIntroductionQuestionContentBlockItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntroductionQuestionContentBlockFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIntroductionQuestionContentBlockItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntroductionQuestionContentBlockApi.getIntroductionQuestionContentBlockItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IntroductionQuestionContentBlockApi - factory interface
 * @export
 */
export const IntroductionQuestionContentBlockApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntroductionQuestionContentBlockApiFp(configuration)
    return {
        /**
         * Retrieves a IntroductionQuestionContentBlock resource.
         * @summary Retrieves a IntroductionQuestionContentBlock resource.
         * @param {string} id IntroductionQuestionContentBlock identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntroductionQuestionContentBlockItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<IntroductionQuestionContentBlockFullRead> {
            return localVarFp.getIntroductionQuestionContentBlockItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntroductionQuestionContentBlockApi - object-oriented interface
 * @export
 * @class IntroductionQuestionContentBlockApi
 * @extends {BaseAPI}
 */
export class IntroductionQuestionContentBlockApi extends BaseAPI {
    /**
     * Retrieves a IntroductionQuestionContentBlock resource.
     * @summary Retrieves a IntroductionQuestionContentBlock resource.
     * @param {string} id IntroductionQuestionContentBlock identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntroductionQuestionContentBlockApi
     */
    public getIntroductionQuestionContentBlockItem(id: string, options?: RawAxiosRequestConfig) {
        return IntroductionQuestionContentBlockApiFp(this.configuration).getIntroductionQuestionContentBlockItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MacroQuestionTypeApi - axios parameter creator
 * @export
 */
export const MacroQuestionTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of MacroQuestionType resources.
         * @summary Retrieves the collection of MacroQuestionType resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMacroQuestionTypeCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/macro_question_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a MacroQuestionType resource.
         * @summary Retrieves a MacroQuestionType resource.
         * @param {string} id MacroQuestionType identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMacroQuestionTypeItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMacroQuestionTypeItem', 'id', id)
            const localVarPath = `/api/macro_question_types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MacroQuestionTypeApi - functional programming interface
 * @export
 */
export const MacroQuestionTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MacroQuestionTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of MacroQuestionType resources.
         * @summary Retrieves the collection of MacroQuestionType resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMacroQuestionTypeCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MacroQuestionTypeFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMacroQuestionTypeCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MacroQuestionTypeApi.getMacroQuestionTypeCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a MacroQuestionType resource.
         * @summary Retrieves a MacroQuestionType resource.
         * @param {string} id MacroQuestionType identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMacroQuestionTypeItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MacroQuestionTypeFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMacroQuestionTypeItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MacroQuestionTypeApi.getMacroQuestionTypeItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MacroQuestionTypeApi - factory interface
 * @export
 */
export const MacroQuestionTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MacroQuestionTypeApiFp(configuration)
    return {
        /**
         * Retrieves the collection of MacroQuestionType resources.
         * @summary Retrieves the collection of MacroQuestionType resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMacroQuestionTypeCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<MacroQuestionTypeFullRead>> {
            return localVarFp.getMacroQuestionTypeCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a MacroQuestionType resource.
         * @summary Retrieves a MacroQuestionType resource.
         * @param {string} id MacroQuestionType identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMacroQuestionTypeItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<MacroQuestionTypeFullRead> {
            return localVarFp.getMacroQuestionTypeItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MacroQuestionTypeApi - object-oriented interface
 * @export
 * @class MacroQuestionTypeApi
 * @extends {BaseAPI}
 */
export class MacroQuestionTypeApi extends BaseAPI {
    /**
     * Retrieves the collection of MacroQuestionType resources.
     * @summary Retrieves the collection of MacroQuestionType resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MacroQuestionTypeApi
     */
    public getMacroQuestionTypeCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return MacroQuestionTypeApiFp(this.configuration).getMacroQuestionTypeCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a MacroQuestionType resource.
     * @summary Retrieves a MacroQuestionType resource.
     * @param {string} id MacroQuestionType identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MacroQuestionTypeApi
     */
    public getMacroQuestionTypeItem(id: string, options?: RawAxiosRequestConfig) {
        return MacroQuestionTypeApiFp(this.configuration).getMacroQuestionTypeItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MajorApi - axios parameter creator
 * @export
 */
export const MajorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of Major resources.
         * @summary Retrieves the collection of Major resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMajorCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/majors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Major resource.
         * @summary Retrieves a Major resource.
         * @param {string} id Major identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMajorItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMajorItem', 'id', id)
            const localVarPath = `/api/majors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MajorApi - functional programming interface
 * @export
 */
export const MajorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MajorApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of Major resources.
         * @summary Retrieves the collection of Major resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMajorCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MajorFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMajorCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MajorApi.getMajorCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a Major resource.
         * @summary Retrieves a Major resource.
         * @param {string} id Major identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMajorItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MajorFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMajorItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MajorApi.getMajorItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MajorApi - factory interface
 * @export
 */
export const MajorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MajorApiFp(configuration)
    return {
        /**
         * Retrieves the collection of Major resources.
         * @summary Retrieves the collection of Major resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMajorCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<MajorFullRead>> {
            return localVarFp.getMajorCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Major resource.
         * @summary Retrieves a Major resource.
         * @param {string} id Major identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMajorItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<MajorFullRead> {
            return localVarFp.getMajorItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MajorApi - object-oriented interface
 * @export
 * @class MajorApi
 * @extends {BaseAPI}
 */
export class MajorApi extends BaseAPI {
    /**
     * Retrieves the collection of Major resources.
     * @summary Retrieves the collection of Major resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MajorApi
     */
    public getMajorCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return MajorApiFp(this.configuration).getMajorCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Major resource.
     * @summary Retrieves a Major resource.
     * @param {string} id Major identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MajorApi
     */
    public getMajorItem(id: string, options?: RawAxiosRequestConfig) {
        return MajorApiFp(this.configuration).getMajorItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PageApi - axios parameter creator
 * @export
 */
export const PageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a Page resource.
         * @summary Retrieves a Page resource.
         * @param {string} id Page identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPageItem', 'id', id)
            const localVarPath = `/api/pages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PageApi - functional programming interface
 * @export
 */
export const PageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PageApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a Page resource.
         * @summary Retrieves a Page resource.
         * @param {string} id Page identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPageItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PageApi.getPageItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PageApi - factory interface
 * @export
 */
export const PageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PageApiFp(configuration)
    return {
        /**
         * Retrieves a Page resource.
         * @summary Retrieves a Page resource.
         * @param {string} id Page identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<PageFullRead> {
            return localVarFp.getPageItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PageApi - object-oriented interface
 * @export
 * @class PageApi
 * @extends {BaseAPI}
 */
export class PageApi extends BaseAPI {
    /**
     * Retrieves a Page resource.
     * @summary Retrieves a Page resource.
     * @param {string} id Page identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getPageItem(id: string, options?: RawAxiosRequestConfig) {
        return PageApiFp(this.configuration).getPageItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductConfigurationApi - axios parameter creator
 * @export
 */
export const ProductConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of ProductConfiguration resources.
         * @summary Retrieves the collection of ProductConfiguration resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {string} [id] 
         * @param {Array<string>} [id2] 
         * @param {string} [name] 
         * @param {string} [product] 
         * @param {Array<string>} [product2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductConfigurationsGetCollection: async (page?: number, pagination?: boolean, id?: string, id2?: Array<string>, name?: string, product?: string, product2?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/product_configurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (id2) {
                localVarQueryParameter['id[]'] = id2;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (product2) {
                localVarQueryParameter['product[]'] = product2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a ProductConfiguration resource.
         * @summary Retrieves a ProductConfiguration resource.
         * @param {string} id ProductConfiguration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductConfigurationsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductConfigurationsIdGet', 'id', id)
            const localVarPath = `/api/product_configurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductConfigurationApi - functional programming interface
 * @export
 */
export const ProductConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of ProductConfiguration resources.
         * @summary Retrieves the collection of ProductConfiguration resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {string} [id] 
         * @param {Array<string>} [id2] 
         * @param {string} [name] 
         * @param {string} [product] 
         * @param {Array<string>} [product2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductConfigurationsGetCollection(page?: number, pagination?: boolean, id?: string, id2?: Array<string>, name?: string, product?: string, product2?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductConfigurationFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductConfigurationsGetCollection(page, pagination, id, id2, name, product, product2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductConfigurationApi.apiProductConfigurationsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a ProductConfiguration resource.
         * @summary Retrieves a ProductConfiguration resource.
         * @param {string} id ProductConfiguration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductConfigurationsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductConfigurationFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductConfigurationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductConfigurationApi.apiProductConfigurationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductConfigurationApi - factory interface
 * @export
 */
export const ProductConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductConfigurationApiFp(configuration)
    return {
        /**
         * Retrieves the collection of ProductConfiguration resources.
         * @summary Retrieves the collection of ProductConfiguration resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {string} [id] 
         * @param {Array<string>} [id2] 
         * @param {string} [name] 
         * @param {string} [product] 
         * @param {Array<string>} [product2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductConfigurationsGetCollection(page?: number, pagination?: boolean, id?: string, id2?: Array<string>, name?: string, product?: string, product2?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductConfigurationFullRead>> {
            return localVarFp.apiProductConfigurationsGetCollection(page, pagination, id, id2, name, product, product2, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a ProductConfiguration resource.
         * @summary Retrieves a ProductConfiguration resource.
         * @param {string} id ProductConfiguration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductConfigurationsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ProductConfigurationFullRead> {
            return localVarFp.apiProductConfigurationsIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductConfigurationApi - object-oriented interface
 * @export
 * @class ProductConfigurationApi
 * @extends {BaseAPI}
 */
export class ProductConfigurationApi extends BaseAPI {
    /**
     * Retrieves the collection of ProductConfiguration resources.
     * @summary Retrieves the collection of ProductConfiguration resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {string} [id] 
     * @param {Array<string>} [id2] 
     * @param {string} [name] 
     * @param {string} [product] 
     * @param {Array<string>} [product2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductConfigurationApi
     */
    public apiProductConfigurationsGetCollection(page?: number, pagination?: boolean, id?: string, id2?: Array<string>, name?: string, product?: string, product2?: Array<string>, options?: RawAxiosRequestConfig) {
        return ProductConfigurationApiFp(this.configuration).apiProductConfigurationsGetCollection(page, pagination, id, id2, name, product, product2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a ProductConfiguration resource.
     * @summary Retrieves a ProductConfiguration resource.
     * @param {string} id ProductConfiguration identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductConfigurationApi
     */
    public apiProductConfigurationsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ProductConfigurationApiFp(this.configuration).apiProductConfigurationsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PromptApi - axios parameter creator
 * @export
 */
export const PromptApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a Prompt resource.
         * @summary Retrieves a Prompt resource.
         * @param {string} id Prompt identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPromptItem', 'id', id)
            const localVarPath = `/api/prompts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromptApi - functional programming interface
 * @export
 */
export const PromptApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromptApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a Prompt resource.
         * @summary Retrieves a Prompt resource.
         * @param {string} id Prompt identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromptItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromptItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromptApi.getPromptItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PromptApi - factory interface
 * @export
 */
export const PromptApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromptApiFp(configuration)
    return {
        /**
         * Retrieves a Prompt resource.
         * @summary Retrieves a Prompt resource.
         * @param {string} id Prompt identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getPromptItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PromptApi - object-oriented interface
 * @export
 * @class PromptApi
 * @extends {BaseAPI}
 */
export class PromptApi extends BaseAPI {
    /**
     * Retrieves a Prompt resource.
     * @summary Retrieves a Prompt resource.
     * @param {string} id Prompt identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptApi
     */
    public getPromptItem(id: string, options?: RawAxiosRequestConfig) {
        return PromptApiFp(this.configuration).getPromptItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuestionApi - axios parameter creator
 * @export
 */
export const QuestionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of Answer resources.
         * @summary Retrieves the collection of Answer resources.
         * @param {string} id Answer identifier
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionsAnswersGetSubresourceQuestionSubresource: async (id: string, page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionsAnswersGetSubresourceQuestionSubresource', 'id', id)
            const localVarPath = `/api/questions/{id}/answers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of Question resources.
         * @summary Retrieves the collection of Question resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a Question resource.
         * @summary Retrieves a Question resource.
         * @param {string} id Question identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionItem', 'id', id)
            const localVarPath = `/api/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionApi - functional programming interface
 * @export
 */
export const QuestionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of Answer resources.
         * @summary Retrieves the collection of Answer resources.
         * @param {string} id Answer identifier
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionsAnswersGetSubresourceQuestionSubresource(id: string, page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnswerFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionsAnswersGetSubresourceQuestionSubresource(id, page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApi.apiQuestionsAnswersGetSubresourceQuestionSubresource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of Question resources.
         * @summary Retrieves the collection of Question resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QuestionMinimumRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApi.getQuestionCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a Question resource.
         * @summary Retrieves a Question resource.
         * @param {string} id Question identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApi.getQuestionItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionApi - factory interface
 * @export
 */
export const QuestionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionApiFp(configuration)
    return {
        /**
         * Retrieves the collection of Answer resources.
         * @summary Retrieves the collection of Answer resources.
         * @param {string} id Answer identifier
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionsAnswersGetSubresourceQuestionSubresource(id: string, page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<AnswerFullRead>> {
            return localVarFp.apiQuestionsAnswersGetSubresourceQuestionSubresource(id, page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of Question resources.
         * @summary Retrieves the collection of Question resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<QuestionMinimumRead>> {
            return localVarFp.getQuestionCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a Question resource.
         * @summary Retrieves a Question resource.
         * @param {string} id Question identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionFullRead> {
            return localVarFp.getQuestionItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionApi - object-oriented interface
 * @export
 * @class QuestionApi
 * @extends {BaseAPI}
 */
export class QuestionApi extends BaseAPI {
    /**
     * Retrieves the collection of Answer resources.
     * @summary Retrieves the collection of Answer resources.
     * @param {string} id Answer identifier
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionApi
     */
    public apiQuestionsAnswersGetSubresourceQuestionSubresource(id: string, page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return QuestionApiFp(this.configuration).apiQuestionsAnswersGetSubresourceQuestionSubresource(id, page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of Question resources.
     * @summary Retrieves the collection of Question resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionApi
     */
    public getQuestionCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return QuestionApiFp(this.configuration).getQuestionCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a Question resource.
     * @summary Retrieves a Question resource.
     * @param {string} id Question identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionApi
     */
    public getQuestionItem(id: string, options?: RawAxiosRequestConfig) {
        return QuestionApiFp(this.configuration).getQuestionItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuestionPageApi - axios parameter creator
 * @export
 */
export const QuestionPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a QuestionPage resource.
         * @summary Retrieves a QuestionPage resource.
         * @param {string} id QuestionPage identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionPageItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionPageItem', 'id', id)
            const localVarPath = `/api/question_pages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionPageApi - functional programming interface
 * @export
 */
export const QuestionPageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionPageApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a QuestionPage resource.
         * @summary Retrieves a QuestionPage resource.
         * @param {string} id QuestionPage identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionPageItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionPageItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionPageApi.getQuestionPageItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionPageApi - factory interface
 * @export
 */
export const QuestionPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionPageApiFp(configuration)
    return {
        /**
         * Retrieves a QuestionPage resource.
         * @summary Retrieves a QuestionPage resource.
         * @param {string} id QuestionPage identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionPageItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getQuestionPageItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionPageApi - object-oriented interface
 * @export
 * @class QuestionPageApi
 * @extends {BaseAPI}
 */
export class QuestionPageApi extends BaseAPI {
    /**
     * Retrieves a QuestionPage resource.
     * @summary Retrieves a QuestionPage resource.
     * @param {string} id QuestionPage identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionPageApi
     */
    public getQuestionPageItem(id: string, options?: RawAxiosRequestConfig) {
        return QuestionPageApiFp(this.configuration).getQuestionPageItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuestionTypeApi - axios parameter creator
 * @export
 */
export const QuestionTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a QuestionType resource.
         * @summary Retrieves a QuestionType resource.
         * @param {string} id QuestionType identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionTypeItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionTypeItem', 'id', id)
            const localVarPath = `/api/question_types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionTypeApi - functional programming interface
 * @export
 */
export const QuestionTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a QuestionType resource.
         * @summary Retrieves a QuestionType resource.
         * @param {string} id QuestionType identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionTypeItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionTypeFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionTypeItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionTypeApi.getQuestionTypeItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionTypeApi - factory interface
 * @export
 */
export const QuestionTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionTypeApiFp(configuration)
    return {
        /**
         * Retrieves a QuestionType resource.
         * @summary Retrieves a QuestionType resource.
         * @param {string} id QuestionType identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionTypeItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionTypeFullRead> {
            return localVarFp.getQuestionTypeItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionTypeApi - object-oriented interface
 * @export
 * @class QuestionTypeApi
 * @extends {BaseAPI}
 */
export class QuestionTypeApi extends BaseAPI {
    /**
     * Retrieves a QuestionType resource.
     * @summary Retrieves a QuestionType resource.
     * @param {string} id QuestionType identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionTypeApi
     */
    public getQuestionTypeItem(id: string, options?: RawAxiosRequestConfig) {
        return QuestionTypeApiFp(this.configuration).getQuestionTypeItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportApi - axios parameter creator
 * @export
 */
export const ReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a Report resource.
         * @summary Retrieves a Report resource.
         * @param {string} id Report identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentsIdreportGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAssessmentsIdreportGet', 'id', id)
            const localVarPath = `/api/assessments/{id}/report`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportApi - functional programming interface
 * @export
 */
export const ReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a Report resource.
         * @summary Retrieves a Report resource.
         * @param {string} id Report identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentsIdreportGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAssessmentsIdreportGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.apiAssessmentsIdreportGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportApi - factory interface
 * @export
 */
export const ReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportApiFp(configuration)
    return {
        /**
         * Retrieves a Report resource.
         * @summary Retrieves a Report resource.
         * @param {string} id Report identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentsIdreportGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportFullRead> {
            return localVarFp.apiAssessmentsIdreportGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */
export class ReportApi extends BaseAPI {
    /**
     * Retrieves a Report resource.
     * @summary Retrieves a Report resource.
     * @param {string} id Report identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public apiAssessmentsIdreportGet(id: string, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).apiAssessmentsIdreportGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportElementBadgesApi - axios parameter creator
 * @export
 */
export const ReportElementBadgesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a ReportElementBadges resource.
         * @summary Retrieves a ReportElementBadges resource.
         * @param {string} id ReportElementBadges identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportElementBadgesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReportElementBadgesIdGet', 'id', id)
            const localVarPath = `/api/report_element_badges/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a ReportElementBadges resource.
         * @summary Creates a ReportElementBadges resource.
         * @param {ReportElementBadgesMinimumWrite} reportElementBadgesMinimumWrite The new ReportElementBadges resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReportElementBadgesCollection: async (reportElementBadgesMinimumWrite: ReportElementBadgesMinimumWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportElementBadgesMinimumWrite' is not null or undefined
            assertParamExists('postReportElementBadgesCollection', 'reportElementBadgesMinimumWrite', reportElementBadgesMinimumWrite)
            const localVarPath = `/api/report_element_badges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportElementBadgesMinimumWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the ReportElementBadges resource.
         * @summary Replaces the ReportElementBadges resource.
         * @param {string} id ReportElementBadges identifier
         * @param {ReportElementBadgesMinimumWrite} reportElementBadgesMinimumWrite The updated ReportElementBadges resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReportElementBadgesItem: async (id: string, reportElementBadgesMinimumWrite: ReportElementBadgesMinimumWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putReportElementBadgesItem', 'id', id)
            // verify required parameter 'reportElementBadgesMinimumWrite' is not null or undefined
            assertParamExists('putReportElementBadgesItem', 'reportElementBadgesMinimumWrite', reportElementBadgesMinimumWrite)
            const localVarPath = `/api/report_element_badges/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportElementBadgesMinimumWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportElementBadgesApi - functional programming interface
 * @export
 */
export const ReportElementBadgesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportElementBadgesApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a ReportElementBadges resource.
         * @summary Retrieves a ReportElementBadges resource.
         * @param {string} id ReportElementBadges identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportElementBadgesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportElementBadgesFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportElementBadgesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportElementBadgesApi.apiReportElementBadgesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a ReportElementBadges resource.
         * @summary Creates a ReportElementBadges resource.
         * @param {ReportElementBadgesMinimumWrite} reportElementBadgesMinimumWrite The new ReportElementBadges resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postReportElementBadgesCollection(reportElementBadgesMinimumWrite: ReportElementBadgesMinimumWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportElementBadgesFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postReportElementBadgesCollection(reportElementBadgesMinimumWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportElementBadgesApi.postReportElementBadgesCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the ReportElementBadges resource.
         * @summary Replaces the ReportElementBadges resource.
         * @param {string} id ReportElementBadges identifier
         * @param {ReportElementBadgesMinimumWrite} reportElementBadgesMinimumWrite The updated ReportElementBadges resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putReportElementBadgesItem(id: string, reportElementBadgesMinimumWrite: ReportElementBadgesMinimumWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportElementBadgesFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putReportElementBadgesItem(id, reportElementBadgesMinimumWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportElementBadgesApi.putReportElementBadgesItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportElementBadgesApi - factory interface
 * @export
 */
export const ReportElementBadgesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportElementBadgesApiFp(configuration)
    return {
        /**
         * Retrieves a ReportElementBadges resource.
         * @summary Retrieves a ReportElementBadges resource.
         * @param {string} id ReportElementBadges identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportElementBadgesIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportElementBadgesFullRead> {
            return localVarFp.apiReportElementBadgesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a ReportElementBadges resource.
         * @summary Creates a ReportElementBadges resource.
         * @param {ReportElementBadgesMinimumWrite} reportElementBadgesMinimumWrite The new ReportElementBadges resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReportElementBadgesCollection(reportElementBadgesMinimumWrite: ReportElementBadgesMinimumWrite, options?: RawAxiosRequestConfig): AxiosPromise<ReportElementBadgesFullRead> {
            return localVarFp.postReportElementBadgesCollection(reportElementBadgesMinimumWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the ReportElementBadges resource.
         * @summary Replaces the ReportElementBadges resource.
         * @param {string} id ReportElementBadges identifier
         * @param {ReportElementBadgesMinimumWrite} reportElementBadgesMinimumWrite The updated ReportElementBadges resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReportElementBadgesItem(id: string, reportElementBadgesMinimumWrite: ReportElementBadgesMinimumWrite, options?: RawAxiosRequestConfig): AxiosPromise<ReportElementBadgesFullRead> {
            return localVarFp.putReportElementBadgesItem(id, reportElementBadgesMinimumWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportElementBadgesApi - object-oriented interface
 * @export
 * @class ReportElementBadgesApi
 * @extends {BaseAPI}
 */
export class ReportElementBadgesApi extends BaseAPI {
    /**
     * Retrieves a ReportElementBadges resource.
     * @summary Retrieves a ReportElementBadges resource.
     * @param {string} id ReportElementBadges identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportElementBadgesApi
     */
    public apiReportElementBadgesIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ReportElementBadgesApiFp(this.configuration).apiReportElementBadgesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a ReportElementBadges resource.
     * @summary Creates a ReportElementBadges resource.
     * @param {ReportElementBadgesMinimumWrite} reportElementBadgesMinimumWrite The new ReportElementBadges resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportElementBadgesApi
     */
    public postReportElementBadgesCollection(reportElementBadgesMinimumWrite: ReportElementBadgesMinimumWrite, options?: RawAxiosRequestConfig) {
        return ReportElementBadgesApiFp(this.configuration).postReportElementBadgesCollection(reportElementBadgesMinimumWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the ReportElementBadges resource.
     * @summary Replaces the ReportElementBadges resource.
     * @param {string} id ReportElementBadges identifier
     * @param {ReportElementBadgesMinimumWrite} reportElementBadgesMinimumWrite The updated ReportElementBadges resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportElementBadgesApi
     */
    public putReportElementBadgesItem(id: string, reportElementBadgesMinimumWrite: ReportElementBadgesMinimumWrite, options?: RawAxiosRequestConfig) {
        return ReportElementBadgesApiFp(this.configuration).putReportElementBadgesItem(id, reportElementBadgesMinimumWrite, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportElementRatingApi - axios parameter creator
 * @export
 */
export const ReportElementRatingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a ReportElementRating resource.
         * @summary Retrieves a ReportElementRating resource.
         * @param {string} id ReportElementRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportElementRatingsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReportElementRatingsIdGet', 'id', id)
            const localVarPath = `/api/report_element_ratings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the ReportElementRating resource.
         * @summary Removes the ReportElementRating resource.
         * @param {string} id ReportElementRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportElementRatingItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteReportElementRatingItem', 'id', id)
            const localVarPath = `/api/report_element_ratings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a ReportElementRating resource.
         * @summary Creates a ReportElementRating resource.
         * @param {ReportElementRatingMinimumWrite} reportElementRatingMinimumWrite The new ReportElementRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReportElementRatingCollection: async (reportElementRatingMinimumWrite: ReportElementRatingMinimumWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportElementRatingMinimumWrite' is not null or undefined
            assertParamExists('postReportElementRatingCollection', 'reportElementRatingMinimumWrite', reportElementRatingMinimumWrite)
            const localVarPath = `/api/report_element_ratings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportElementRatingMinimumWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the ReportElementRating resource.
         * @summary Replaces the ReportElementRating resource.
         * @param {string} id ReportElementRating identifier
         * @param {ReportElementRatingMinimumWrite} reportElementRatingMinimumWrite The updated ReportElementRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReportElementRatingItem: async (id: string, reportElementRatingMinimumWrite: ReportElementRatingMinimumWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putReportElementRatingItem', 'id', id)
            // verify required parameter 'reportElementRatingMinimumWrite' is not null or undefined
            assertParamExists('putReportElementRatingItem', 'reportElementRatingMinimumWrite', reportElementRatingMinimumWrite)
            const localVarPath = `/api/report_element_ratings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportElementRatingMinimumWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportElementRatingApi - functional programming interface
 * @export
 */
export const ReportElementRatingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportElementRatingApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a ReportElementRating resource.
         * @summary Retrieves a ReportElementRating resource.
         * @param {string} id ReportElementRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportElementRatingsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportElementRatingFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportElementRatingsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportElementRatingApi.apiReportElementRatingsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes the ReportElementRating resource.
         * @summary Removes the ReportElementRating resource.
         * @param {string} id ReportElementRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReportElementRatingItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReportElementRatingItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportElementRatingApi.deleteReportElementRatingItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a ReportElementRating resource.
         * @summary Creates a ReportElementRating resource.
         * @param {ReportElementRatingMinimumWrite} reportElementRatingMinimumWrite The new ReportElementRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postReportElementRatingCollection(reportElementRatingMinimumWrite: ReportElementRatingMinimumWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportElementRatingFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postReportElementRatingCollection(reportElementRatingMinimumWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportElementRatingApi.postReportElementRatingCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the ReportElementRating resource.
         * @summary Replaces the ReportElementRating resource.
         * @param {string} id ReportElementRating identifier
         * @param {ReportElementRatingMinimumWrite} reportElementRatingMinimumWrite The updated ReportElementRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putReportElementRatingItem(id: string, reportElementRatingMinimumWrite: ReportElementRatingMinimumWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportElementRatingFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putReportElementRatingItem(id, reportElementRatingMinimumWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportElementRatingApi.putReportElementRatingItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportElementRatingApi - factory interface
 * @export
 */
export const ReportElementRatingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportElementRatingApiFp(configuration)
    return {
        /**
         * Retrieves a ReportElementRating resource.
         * @summary Retrieves a ReportElementRating resource.
         * @param {string} id ReportElementRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportElementRatingsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportElementRatingFullRead> {
            return localVarFp.apiReportElementRatingsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the ReportElementRating resource.
         * @summary Removes the ReportElementRating resource.
         * @param {string} id ReportElementRating identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportElementRatingItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteReportElementRatingItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a ReportElementRating resource.
         * @summary Creates a ReportElementRating resource.
         * @param {ReportElementRatingMinimumWrite} reportElementRatingMinimumWrite The new ReportElementRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReportElementRatingCollection(reportElementRatingMinimumWrite: ReportElementRatingMinimumWrite, options?: RawAxiosRequestConfig): AxiosPromise<ReportElementRatingFullRead> {
            return localVarFp.postReportElementRatingCollection(reportElementRatingMinimumWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the ReportElementRating resource.
         * @summary Replaces the ReportElementRating resource.
         * @param {string} id ReportElementRating identifier
         * @param {ReportElementRatingMinimumWrite} reportElementRatingMinimumWrite The updated ReportElementRating resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReportElementRatingItem(id: string, reportElementRatingMinimumWrite: ReportElementRatingMinimumWrite, options?: RawAxiosRequestConfig): AxiosPromise<ReportElementRatingFullRead> {
            return localVarFp.putReportElementRatingItem(id, reportElementRatingMinimumWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportElementRatingApi - object-oriented interface
 * @export
 * @class ReportElementRatingApi
 * @extends {BaseAPI}
 */
export class ReportElementRatingApi extends BaseAPI {
    /**
     * Retrieves a ReportElementRating resource.
     * @summary Retrieves a ReportElementRating resource.
     * @param {string} id ReportElementRating identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportElementRatingApi
     */
    public apiReportElementRatingsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ReportElementRatingApiFp(this.configuration).apiReportElementRatingsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes the ReportElementRating resource.
     * @summary Removes the ReportElementRating resource.
     * @param {string} id ReportElementRating identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportElementRatingApi
     */
    public deleteReportElementRatingItem(id: string, options?: RawAxiosRequestConfig) {
        return ReportElementRatingApiFp(this.configuration).deleteReportElementRatingItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a ReportElementRating resource.
     * @summary Creates a ReportElementRating resource.
     * @param {ReportElementRatingMinimumWrite} reportElementRatingMinimumWrite The new ReportElementRating resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportElementRatingApi
     */
    public postReportElementRatingCollection(reportElementRatingMinimumWrite: ReportElementRatingMinimumWrite, options?: RawAxiosRequestConfig) {
        return ReportElementRatingApiFp(this.configuration).postReportElementRatingCollection(reportElementRatingMinimumWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the ReportElementRating resource.
     * @summary Replaces the ReportElementRating resource.
     * @param {string} id ReportElementRating identifier
     * @param {ReportElementRatingMinimumWrite} reportElementRatingMinimumWrite The updated ReportElementRating resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportElementRatingApi
     */
    public putReportElementRatingItem(id: string, reportElementRatingMinimumWrite: ReportElementRatingMinimumWrite, options?: RawAxiosRequestConfig) {
        return ReportElementRatingApiFp(this.configuration).putReportElementRatingItem(id, reportElementRatingMinimumWrite, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportScoreRangeApi - axios parameter creator
 * @export
 */
export const ReportScoreRangeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a ReportScoreRange resource.
         * @summary Retrieves a ReportScoreRange resource.
         * @param {string} id ReportScoreRange identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportScoreRangesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReportScoreRangesIdGet', 'id', id)
            const localVarPath = `/api/report_score_ranges/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportScoreRangeApi - functional programming interface
 * @export
 */
export const ReportScoreRangeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportScoreRangeApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a ReportScoreRange resource.
         * @summary Retrieves a ReportScoreRange resource.
         * @param {string} id ReportScoreRange identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportScoreRangesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportScoreRangeFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportScoreRangesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportScoreRangeApi.apiReportScoreRangesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportScoreRangeApi - factory interface
 * @export
 */
export const ReportScoreRangeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportScoreRangeApiFp(configuration)
    return {
        /**
         * Retrieves a ReportScoreRange resource.
         * @summary Retrieves a ReportScoreRange resource.
         * @param {string} id ReportScoreRange identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportScoreRangesIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportScoreRangeFullRead> {
            return localVarFp.apiReportScoreRangesIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportScoreRangeApi - object-oriented interface
 * @export
 * @class ReportScoreRangeApi
 * @extends {BaseAPI}
 */
export class ReportScoreRangeApi extends BaseAPI {
    /**
     * Retrieves a ReportScoreRange resource.
     * @summary Retrieves a ReportScoreRange resource.
     * @param {string} id ReportScoreRange identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportScoreRangeApi
     */
    public apiReportScoreRangesIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ReportScoreRangeApiFp(this.configuration).apiReportScoreRangesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportTypeApi - axios parameter creator
 * @export
 */
export const ReportTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of ReportType resources.
         * @summary Retrieves the collection of ReportType resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportTypesGetCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a ReportType resource.
         * @summary Retrieves a ReportType resource.
         * @param {string} id ReportType identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportTypesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReportTypesIdGet', 'id', id)
            const localVarPath = `/api/report_types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportTypeApi - functional programming interface
 * @export
 */
export const ReportTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of ReportType resources.
         * @summary Retrieves the collection of ReportType resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportTypesGetCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportTypesGetCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTypeApi.apiReportTypesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a ReportType resource.
         * @summary Retrieves a ReportType resource.
         * @param {string} id ReportType identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportTypesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportTypesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTypeApi.apiReportTypesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportTypeApi - factory interface
 * @export
 */
export const ReportTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportTypeApiFp(configuration)
    return {
        /**
         * Retrieves the collection of ReportType resources.
         * @summary Retrieves the collection of ReportType resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportTypesGetCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.apiReportTypesGetCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a ReportType resource.
         * @summary Retrieves a ReportType resource.
         * @param {string} id ReportType identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportTypesIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.apiReportTypesIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportTypeApi - object-oriented interface
 * @export
 * @class ReportTypeApi
 * @extends {BaseAPI}
 */
export class ReportTypeApi extends BaseAPI {
    /**
     * Retrieves the collection of ReportType resources.
     * @summary Retrieves the collection of ReportType resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTypeApi
     */
    public apiReportTypesGetCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return ReportTypeApiFp(this.configuration).apiReportTypesGetCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a ReportType resource.
     * @summary Retrieves a ReportType resource.
     * @param {string} id ReportType identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTypeApi
     */
    public apiReportTypesIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ReportTypeApiFp(this.configuration).apiReportTypesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportTypeElementBadgeRequirementsApi - axios parameter creator
 * @export
 */
export const ReportTypeElementBadgeRequirementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a ReportTypeElementBadgeRequirements resource.
         * @summary Retrieves a ReportTypeElementBadgeRequirements resource.
         * @param {string} id ReportTypeElementBadgeRequirements identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportTypeElementBadgeRequirementsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReportTypeElementBadgeRequirementsIdGet', 'id', id)
            const localVarPath = `/api/report_type_element_badge_requirements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of ReportTypeElementBadgeRequirements resources.
         * @summary Retrieves the collection of ReportTypeElementBadgeRequirements resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTypeElementBadgeRequirementsCollection: async (page?: number, pagination?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report_type_element_badge_requirements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportTypeElementBadgeRequirementsApi - functional programming interface
 * @export
 */
export const ReportTypeElementBadgeRequirementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportTypeElementBadgeRequirementsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a ReportTypeElementBadgeRequirements resource.
         * @summary Retrieves a ReportTypeElementBadgeRequirements resource.
         * @param {string} id ReportTypeElementBadgeRequirements identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportTypeElementBadgeRequirementsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportTypeElementBadgeRequirementsFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportTypeElementBadgeRequirementsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTypeElementBadgeRequirementsApi.apiReportTypeElementBadgeRequirementsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of ReportTypeElementBadgeRequirements resources.
         * @summary Retrieves the collection of ReportTypeElementBadgeRequirements resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportTypeElementBadgeRequirementsCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportTypeElementBadgeRequirementsFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportTypeElementBadgeRequirementsCollection(page, pagination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTypeElementBadgeRequirementsApi.getReportTypeElementBadgeRequirementsCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportTypeElementBadgeRequirementsApi - factory interface
 * @export
 */
export const ReportTypeElementBadgeRequirementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportTypeElementBadgeRequirementsApiFp(configuration)
    return {
        /**
         * Retrieves a ReportTypeElementBadgeRequirements resource.
         * @summary Retrieves a ReportTypeElementBadgeRequirements resource.
         * @param {string} id ReportTypeElementBadgeRequirements identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportTypeElementBadgeRequirementsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportTypeElementBadgeRequirementsFullRead> {
            return localVarFp.apiReportTypeElementBadgeRequirementsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of ReportTypeElementBadgeRequirements resources.
         * @summary Retrieves the collection of ReportTypeElementBadgeRequirements resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTypeElementBadgeRequirementsCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<ReportTypeElementBadgeRequirementsFullRead>> {
            return localVarFp.getReportTypeElementBadgeRequirementsCollection(page, pagination, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportTypeElementBadgeRequirementsApi - object-oriented interface
 * @export
 * @class ReportTypeElementBadgeRequirementsApi
 * @extends {BaseAPI}
 */
export class ReportTypeElementBadgeRequirementsApi extends BaseAPI {
    /**
     * Retrieves a ReportTypeElementBadgeRequirements resource.
     * @summary Retrieves a ReportTypeElementBadgeRequirements resource.
     * @param {string} id ReportTypeElementBadgeRequirements identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTypeElementBadgeRequirementsApi
     */
    public apiReportTypeElementBadgeRequirementsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ReportTypeElementBadgeRequirementsApiFp(this.configuration).apiReportTypeElementBadgeRequirementsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of ReportTypeElementBadgeRequirements resources.
     * @summary Retrieves the collection of ReportTypeElementBadgeRequirements resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTypeElementBadgeRequirementsApi
     */
    public getReportTypeElementBadgeRequirementsCollection(page?: number, pagination?: boolean, options?: RawAxiosRequestConfig) {
        return ReportTypeElementBadgeRequirementsApiFp(this.configuration).getReportTypeElementBadgeRequirementsCollection(page, pagination, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportUserAnswerApi - axios parameter creator
 * @export
 */
export const ReportUserAnswerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the ReportUserAnswer resource.
         * @summary Removes the ReportUserAnswer resource.
         * @param {string} id ReportUserAnswer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportUserAnswersIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReportUserAnswersIdDelete', 'id', id)
            const localVarPath = `/api/report_user_answers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a ReportUserAnswer resource.
         * @summary Retrieves a ReportUserAnswer resource.
         * @param {string} id ReportUserAnswer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportUserAnswersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiReportUserAnswersIdGet', 'id', id)
            const localVarPath = `/api/report_user_answers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a ReportUserAnswer resource.
         * @summary Creates a ReportUserAnswer resource.
         * @param {ReportUserAnswerMinimumWrite} reportUserAnswerMinimumWrite The new ReportUserAnswer resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReportUserAnswerCollection: async (reportUserAnswerMinimumWrite: ReportUserAnswerMinimumWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportUserAnswerMinimumWrite' is not null or undefined
            assertParamExists('postReportUserAnswerCollection', 'reportUserAnswerMinimumWrite', reportUserAnswerMinimumWrite)
            const localVarPath = `/api/report_user_answers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportUserAnswerMinimumWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the ReportUserAnswer resource.
         * @summary Replaces the ReportUserAnswer resource.
         * @param {string} id ReportUserAnswer identifier
         * @param {ReportUserAnswerMinimumWrite} reportUserAnswerMinimumWrite The updated ReportUserAnswer resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReportUserAnswerItem: async (id: string, reportUserAnswerMinimumWrite: ReportUserAnswerMinimumWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putReportUserAnswerItem', 'id', id)
            // verify required parameter 'reportUserAnswerMinimumWrite' is not null or undefined
            assertParamExists('putReportUserAnswerItem', 'reportUserAnswerMinimumWrite', reportUserAnswerMinimumWrite)
            const localVarPath = `/api/report_user_answers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportUserAnswerMinimumWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportUserAnswerApi - functional programming interface
 * @export
 */
export const ReportUserAnswerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportUserAnswerApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the ReportUserAnswer resource.
         * @summary Removes the ReportUserAnswer resource.
         * @param {string} id ReportUserAnswer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportUserAnswersIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportUserAnswersIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportUserAnswerApi.apiReportUserAnswersIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a ReportUserAnswer resource.
         * @summary Retrieves a ReportUserAnswer resource.
         * @param {string} id ReportUserAnswer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportUserAnswersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportUserAnswerFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportUserAnswersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportUserAnswerApi.apiReportUserAnswersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a ReportUserAnswer resource.
         * @summary Creates a ReportUserAnswer resource.
         * @param {ReportUserAnswerMinimumWrite} reportUserAnswerMinimumWrite The new ReportUserAnswer resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postReportUserAnswerCollection(reportUserAnswerMinimumWrite: ReportUserAnswerMinimumWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportUserAnswerFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postReportUserAnswerCollection(reportUserAnswerMinimumWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportUserAnswerApi.postReportUserAnswerCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the ReportUserAnswer resource.
         * @summary Replaces the ReportUserAnswer resource.
         * @param {string} id ReportUserAnswer identifier
         * @param {ReportUserAnswerMinimumWrite} reportUserAnswerMinimumWrite The updated ReportUserAnswer resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putReportUserAnswerItem(id: string, reportUserAnswerMinimumWrite: ReportUserAnswerMinimumWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportUserAnswerFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putReportUserAnswerItem(id, reportUserAnswerMinimumWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportUserAnswerApi.putReportUserAnswerItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportUserAnswerApi - factory interface
 * @export
 */
export const ReportUserAnswerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportUserAnswerApiFp(configuration)
    return {
        /**
         * Removes the ReportUserAnswer resource.
         * @summary Removes the ReportUserAnswer resource.
         * @param {string} id ReportUserAnswer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportUserAnswersIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiReportUserAnswersIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a ReportUserAnswer resource.
         * @summary Retrieves a ReportUserAnswer resource.
         * @param {string} id ReportUserAnswer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportUserAnswersIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportUserAnswerFullRead> {
            return localVarFp.apiReportUserAnswersIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a ReportUserAnswer resource.
         * @summary Creates a ReportUserAnswer resource.
         * @param {ReportUserAnswerMinimumWrite} reportUserAnswerMinimumWrite The new ReportUserAnswer resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReportUserAnswerCollection(reportUserAnswerMinimumWrite: ReportUserAnswerMinimumWrite, options?: RawAxiosRequestConfig): AxiosPromise<ReportUserAnswerFullRead> {
            return localVarFp.postReportUserAnswerCollection(reportUserAnswerMinimumWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the ReportUserAnswer resource.
         * @summary Replaces the ReportUserAnswer resource.
         * @param {string} id ReportUserAnswer identifier
         * @param {ReportUserAnswerMinimumWrite} reportUserAnswerMinimumWrite The updated ReportUserAnswer resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReportUserAnswerItem(id: string, reportUserAnswerMinimumWrite: ReportUserAnswerMinimumWrite, options?: RawAxiosRequestConfig): AxiosPromise<ReportUserAnswerFullRead> {
            return localVarFp.putReportUserAnswerItem(id, reportUserAnswerMinimumWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportUserAnswerApi - object-oriented interface
 * @export
 * @class ReportUserAnswerApi
 * @extends {BaseAPI}
 */
export class ReportUserAnswerApi extends BaseAPI {
    /**
     * Removes the ReportUserAnswer resource.
     * @summary Removes the ReportUserAnswer resource.
     * @param {string} id ReportUserAnswer identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportUserAnswerApi
     */
    public apiReportUserAnswersIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return ReportUserAnswerApiFp(this.configuration).apiReportUserAnswersIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a ReportUserAnswer resource.
     * @summary Retrieves a ReportUserAnswer resource.
     * @param {string} id ReportUserAnswer identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportUserAnswerApi
     */
    public apiReportUserAnswersIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ReportUserAnswerApiFp(this.configuration).apiReportUserAnswersIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a ReportUserAnswer resource.
     * @summary Creates a ReportUserAnswer resource.
     * @param {ReportUserAnswerMinimumWrite} reportUserAnswerMinimumWrite The new ReportUserAnswer resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportUserAnswerApi
     */
    public postReportUserAnswerCollection(reportUserAnswerMinimumWrite: ReportUserAnswerMinimumWrite, options?: RawAxiosRequestConfig) {
        return ReportUserAnswerApiFp(this.configuration).postReportUserAnswerCollection(reportUserAnswerMinimumWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the ReportUserAnswer resource.
     * @summary Replaces the ReportUserAnswer resource.
     * @param {string} id ReportUserAnswer identifier
     * @param {ReportUserAnswerMinimumWrite} reportUserAnswerMinimumWrite The updated ReportUserAnswer resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportUserAnswerApi
     */
    public putReportUserAnswerItem(id: string, reportUserAnswerMinimumWrite: ReportUserAnswerMinimumWrite, options?: RawAxiosRequestConfig) {
        return ReportUserAnswerApiFp(this.configuration).putReportUserAnswerItem(id, reportUserAnswerMinimumWrite, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StemApi - axios parameter creator
 * @export
 */
export const StemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a Stem resource.
         * @summary Retrieves a Stem resource.
         * @param {string} id Stem identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStemItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getStemItem', 'id', id)
            const localVarPath = `/api/stems/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StemApi - functional programming interface
 * @export
 */
export const StemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StemApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a Stem resource.
         * @summary Retrieves a Stem resource.
         * @param {string} id Stem identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStemItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStemItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StemApi.getStemItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StemApi - factory interface
 * @export
 */
export const StemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StemApiFp(configuration)
    return {
        /**
         * Retrieves a Stem resource.
         * @summary Retrieves a Stem resource.
         * @param {string} id Stem identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStemItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getStemItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StemApi - object-oriented interface
 * @export
 * @class StemApi
 * @extends {BaseAPI}
 */
export class StemApi extends BaseAPI {
    /**
     * Retrieves a Stem resource.
     * @summary Retrieves a Stem resource.
     * @param {string} id Stem identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StemApi
     */
    public getStemItem(id: string, options?: RawAxiosRequestConfig) {
        return StemApiFp(this.configuration).getStemItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TimerApi - axios parameter creator
 * @export
 */
export const TimerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a Timer resource.
         * @summary Retrieves a Timer resource.
         * @param {string} id Timer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTimersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTimersIdGet', 'id', id)
            const localVarPath = `/api/timers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimerApi - functional programming interface
 * @export
 */
export const TimerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TimerApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a Timer resource.
         * @summary Retrieves a Timer resource.
         * @param {string} id Timer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTimersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimerFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTimersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimerApi.apiTimersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TimerApi - factory interface
 * @export
 */
export const TimerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TimerApiFp(configuration)
    return {
        /**
         * Retrieves a Timer resource.
         * @summary Retrieves a Timer resource.
         * @param {string} id Timer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTimersIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<TimerFullRead> {
            return localVarFp.apiTimersIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimerApi - object-oriented interface
 * @export
 * @class TimerApi
 * @extends {BaseAPI}
 */
export class TimerApi extends BaseAPI {
    /**
     * Retrieves a Timer resource.
     * @summary Retrieves a Timer resource.
     * @param {string} id Timer identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimerApi
     */
    public apiTimersIdGet(id: string, options?: RawAxiosRequestConfig) {
        return TimerApiFp(this.configuration).apiTimersIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the User resource.
         * @summary Removes the User resource.
         * @param {string} id User identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdDelete', 'id', id)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the User resource.
         * @summary Replaces the User resource.
         * @param {string} id User identifier
         * @param {UserMinimumWrite} userMinimumWrite The updated User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPut: async (id: string, userMinimumWrite: UserMinimumWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdPut', 'id', id)
            // verify required parameter 'userMinimumWrite' is not null or undefined
            assertParamExists('apiUsersIdPut', 'userMinimumWrite', userMinimumWrite)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMinimumWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a User resource.
         * @summary Creates a User resource.
         * @param {UserMinimumWrite} userMinimumWrite The new User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserUserCollection: async (userMinimumWrite: UserMinimumWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMinimumWrite' is not null or undefined
            assertParamExists('createUserUserCollection', 'userMinimumWrite', userMinimumWrite)
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMinimumWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a User resource.
         * @summary Retrieves a User resource.
         * @param {string} id User identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenUserItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTokenUserItem', 'id', id)
            const localVarPath = `/api/users/{id}/token`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of User resources.
         * @summary Retrieves the collection of User resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [emailAddress] 
         * @param {Array<string>} [emailAddress2] 
         * @param {string} [externalId] 
         * @param {Array<string>} [externalId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCollection: async (page?: number, pagination?: boolean, firstName?: string, lastName?: string, emailAddress?: string, emailAddress2?: Array<string>, externalId?: string, externalId2?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }

            if (firstName !== undefined) {
                localVarQueryParameter['firstName'] = firstName;
            }

            if (lastName !== undefined) {
                localVarQueryParameter['lastName'] = lastName;
            }

            if (emailAddress !== undefined) {
                localVarQueryParameter['emailAddress'] = emailAddress;
            }

            if (emailAddress2) {
                localVarQueryParameter['emailAddress[]'] = emailAddress2;
            }

            if (externalId !== undefined) {
                localVarQueryParameter['externalId'] = externalId;
            }

            if (externalId2) {
                localVarQueryParameter['externalId[]'] = externalId2;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a User resource.
         * @summary Retrieves a User resource.
         * @param {string} id User identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserItem', 'id', id)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the User resource.
         * @summary Removes the User resource.
         * @param {string} id User identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUsersIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the User resource.
         * @summary Replaces the User resource.
         * @param {string} id User identifier
         * @param {UserMinimumWrite} userMinimumWrite The updated User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdPut(id: string, userMinimumWrite: UserMinimumWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdPut(id, userMinimumWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUsersIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a User resource.
         * @summary Creates a User resource.
         * @param {UserMinimumWrite} userMinimumWrite The new User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserUserCollection(userMinimumWrite: UserMinimumWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserUserCollection(userMinimumWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.createUserUserCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a User resource.
         * @summary Retrieves a User resource.
         * @param {string} id User identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTokenUserItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTokenUserItem200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTokenUserItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getTokenUserItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of User resources.
         * @summary Retrieves the collection of User resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [emailAddress] 
         * @param {Array<string>} [emailAddress2] 
         * @param {string} [externalId] 
         * @param {Array<string>} [externalId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCollection(page?: number, pagination?: boolean, firstName?: string, lastName?: string, emailAddress?: string, emailAddress2?: Array<string>, externalId?: string, externalId2?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserFullRead>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCollection(page, pagination, firstName, lastName, emailAddress, emailAddress2, externalId, externalId2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUserCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a User resource.
         * @summary Retrieves a User resource.
         * @param {string} id User identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUserItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Removes the User resource.
         * @summary Removes the User resource.
         * @param {string} id User identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiUsersIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the User resource.
         * @summary Replaces the User resource.
         * @param {string} id User identifier
         * @param {UserMinimumWrite} userMinimumWrite The updated User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPut(id: string, userMinimumWrite: UserMinimumWrite, options?: RawAxiosRequestConfig): AxiosPromise<UserFullRead> {
            return localVarFp.apiUsersIdPut(id, userMinimumWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a User resource.
         * @summary Creates a User resource.
         * @param {UserMinimumWrite} userMinimumWrite The new User resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserUserCollection(userMinimumWrite: UserMinimumWrite, options?: RawAxiosRequestConfig): AxiosPromise<UserFullRead> {
            return localVarFp.createUserUserCollection(userMinimumWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a User resource.
         * @summary Retrieves a User resource.
         * @param {string} id User identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenUserItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetTokenUserItem200Response> {
            return localVarFp.getTokenUserItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of User resources.
         * @summary Retrieves the collection of User resources.
         * @param {number} [page] The collection page number
         * @param {boolean} [pagination] Enable or disable pagination
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [emailAddress] 
         * @param {Array<string>} [emailAddress2] 
         * @param {string} [externalId] 
         * @param {Array<string>} [externalId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCollection(page?: number, pagination?: boolean, firstName?: string, lastName?: string, emailAddress?: string, emailAddress2?: Array<string>, externalId?: string, externalId2?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserFullRead>> {
            return localVarFp.getUserCollection(page, pagination, firstName, lastName, emailAddress, emailAddress2, externalId, externalId2, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a User resource.
         * @summary Retrieves a User resource.
         * @param {string} id User identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<UserFullRead> {
            return localVarFp.getUserItem(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Removes the User resource.
     * @summary Removes the User resource.
     * @param {string} id User identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUsersIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUsersIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the User resource.
     * @summary Replaces the User resource.
     * @param {string} id User identifier
     * @param {UserMinimumWrite} userMinimumWrite The updated User resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUsersIdPut(id: string, userMinimumWrite: UserMinimumWrite, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUsersIdPut(id, userMinimumWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a User resource.
     * @summary Creates a User resource.
     * @param {UserMinimumWrite} userMinimumWrite The new User resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public createUserUserCollection(userMinimumWrite: UserMinimumWrite, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).createUserUserCollection(userMinimumWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a User resource.
     * @summary Retrieves a User resource.
     * @param {string} id User identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getTokenUserItem(id: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getTokenUserItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of User resources.
     * @summary Retrieves the collection of User resources.
     * @param {number} [page] The collection page number
     * @param {boolean} [pagination] Enable or disable pagination
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {string} [emailAddress] 
     * @param {Array<string>} [emailAddress2] 
     * @param {string} [externalId] 
     * @param {Array<string>} [externalId2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserCollection(page?: number, pagination?: boolean, firstName?: string, lastName?: string, emailAddress?: string, emailAddress2?: Array<string>, externalId?: string, externalId2?: Array<string>, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getUserCollection(page, pagination, firstName, lastName, emailAddress, emailAddress2, externalId, externalId2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a User resource.
     * @summary Retrieves a User resource.
     * @param {string} id User identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserItem(id: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getUserItem(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserAnswerApi - axios parameter creator
 * @export
 */
export const UserAnswerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Replaces the UserAnswer resource.
         * @summary Replaces the UserAnswer resource.
         * @param {string} id UserAnswer identifier
         * @param {UserAnswerMinimumWrite} userAnswerMinimumWrite The updated UserAnswer resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserAnswerUserAnswerItem: async (id: string, userAnswerMinimumWrite: UserAnswerMinimumWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeUserAnswerUserAnswerItem', 'id', id)
            // verify required parameter 'userAnswerMinimumWrite' is not null or undefined
            assertParamExists('changeUserAnswerUserAnswerItem', 'userAnswerMinimumWrite', userAnswerMinimumWrite)
            const localVarPath = `/api/user_answers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userAnswerMinimumWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the UserAnswer resource.
         * @summary Removes the UserAnswer resource.
         * @param {string} id UserAnswer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAnswerItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUserAnswerItem', 'id', id)
            const localVarPath = `/api/user_answers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a UserAnswer resource.
         * @summary Retrieves a UserAnswer resource.
         * @param {string} id UserAnswer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAnswerItem: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserAnswerItem', 'id', id)
            const localVarPath = `/api/user_answers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a UserAnswer resource.
         * @summary Creates a UserAnswer resource.
         * @param {UserAnswerMinimumWrite} userAnswerMinimumWrite The new UserAnswer resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToQuestionUserAnswerCollection: async (userAnswerMinimumWrite: UserAnswerMinimumWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAnswerMinimumWrite' is not null or undefined
            assertParamExists('respondToQuestionUserAnswerCollection', 'userAnswerMinimumWrite', userAnswerMinimumWrite)
            const localVarPath = `/api/user_answers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userAnswerMinimumWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAnswerApi - functional programming interface
 * @export
 */
export const UserAnswerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserAnswerApiAxiosParamCreator(configuration)
    return {
        /**
         * Replaces the UserAnswer resource.
         * @summary Replaces the UserAnswer resource.
         * @param {string} id UserAnswer identifier
         * @param {UserAnswerMinimumWrite} userAnswerMinimumWrite The updated UserAnswer resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeUserAnswerUserAnswerItem(id: string, userAnswerMinimumWrite: UserAnswerMinimumWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAnswerFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeUserAnswerUserAnswerItem(id, userAnswerMinimumWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAnswerApi.changeUserAnswerUserAnswerItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes the UserAnswer resource.
         * @summary Removes the UserAnswer resource.
         * @param {string} id UserAnswer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserAnswerItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserAnswerItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAnswerApi.deleteUserAnswerItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a UserAnswer resource.
         * @summary Retrieves a UserAnswer resource.
         * @param {string} id UserAnswer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAnswerItem(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAnswerFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAnswerItem(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAnswerApi.getUserAnswerItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a UserAnswer resource.
         * @summary Creates a UserAnswer resource.
         * @param {UserAnswerMinimumWrite} userAnswerMinimumWrite The new UserAnswer resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondToQuestionUserAnswerCollection(userAnswerMinimumWrite: UserAnswerMinimumWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAnswerFullRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.respondToQuestionUserAnswerCollection(userAnswerMinimumWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAnswerApi.respondToQuestionUserAnswerCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserAnswerApi - factory interface
 * @export
 */
export const UserAnswerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserAnswerApiFp(configuration)
    return {
        /**
         * Replaces the UserAnswer resource.
         * @summary Replaces the UserAnswer resource.
         * @param {string} id UserAnswer identifier
         * @param {UserAnswerMinimumWrite} userAnswerMinimumWrite The updated UserAnswer resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserAnswerUserAnswerItem(id: string, userAnswerMinimumWrite: UserAnswerMinimumWrite, options?: RawAxiosRequestConfig): AxiosPromise<UserAnswerFullRead> {
            return localVarFp.changeUserAnswerUserAnswerItem(id, userAnswerMinimumWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the UserAnswer resource.
         * @summary Removes the UserAnswer resource.
         * @param {string} id UserAnswer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAnswerItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUserAnswerItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a UserAnswer resource.
         * @summary Retrieves a UserAnswer resource.
         * @param {string} id UserAnswer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAnswerItem(id: string, options?: RawAxiosRequestConfig): AxiosPromise<UserAnswerFullRead> {
            return localVarFp.getUserAnswerItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a UserAnswer resource.
         * @summary Creates a UserAnswer resource.
         * @param {UserAnswerMinimumWrite} userAnswerMinimumWrite The new UserAnswer resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToQuestionUserAnswerCollection(userAnswerMinimumWrite: UserAnswerMinimumWrite, options?: RawAxiosRequestConfig): AxiosPromise<UserAnswerFullRead> {
            return localVarFp.respondToQuestionUserAnswerCollection(userAnswerMinimumWrite, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserAnswerApi - object-oriented interface
 * @export
 * @class UserAnswerApi
 * @extends {BaseAPI}
 */
export class UserAnswerApi extends BaseAPI {
    /**
     * Replaces the UserAnswer resource.
     * @summary Replaces the UserAnswer resource.
     * @param {string} id UserAnswer identifier
     * @param {UserAnswerMinimumWrite} userAnswerMinimumWrite The updated UserAnswer resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAnswerApi
     */
    public changeUserAnswerUserAnswerItem(id: string, userAnswerMinimumWrite: UserAnswerMinimumWrite, options?: RawAxiosRequestConfig) {
        return UserAnswerApiFp(this.configuration).changeUserAnswerUserAnswerItem(id, userAnswerMinimumWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes the UserAnswer resource.
     * @summary Removes the UserAnswer resource.
     * @param {string} id UserAnswer identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAnswerApi
     */
    public deleteUserAnswerItem(id: string, options?: RawAxiosRequestConfig) {
        return UserAnswerApiFp(this.configuration).deleteUserAnswerItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a UserAnswer resource.
     * @summary Retrieves a UserAnswer resource.
     * @param {string} id UserAnswer identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAnswerApi
     */
    public getUserAnswerItem(id: string, options?: RawAxiosRequestConfig) {
        return UserAnswerApiFp(this.configuration).getUserAnswerItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a UserAnswer resource.
     * @summary Creates a UserAnswer resource.
     * @param {UserAnswerMinimumWrite} userAnswerMinimumWrite The new UserAnswer resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAnswerApi
     */
    public respondToQuestionUserAnswerCollection(userAnswerMinimumWrite: UserAnswerMinimumWrite, options?: RawAxiosRequestConfig) {
        return UserAnswerApiFp(this.configuration).respondToQuestionUserAnswerCollection(userAnswerMinimumWrite, options).then((request) => request(this.axios, this.basePath));
    }
}



